import { resources as InsuranceV2Translations } from './scenes/Form/InsurancePage/v2/translations';
import { translations as ReviewTranslations } from './scenes/Review/translations';
import { translations as RecommendationTranslations } from './scenes/Recommendation/translations';
import { translations as CommonTranslations } from 'common/dist/utils/translations';
import { translations as AddressInputTranslations } from './components/AddressInput/translations';
import { translations as GuarantorVerificationTranslations } from './components/GuarantorVerification/translations';
import { translations as PharmacyInputTranslations } from './components/PharmacyInput/translations';
import { translations as EmergencyContactsTranslations } from './components/Question/EmergencyContacts/translations';
import { translations as DigitalCheckInTranslations } from './scenes/DigitalCheckIn/translations';
import { translations as LoginTranslations } from './scenes/Login/translations';

const resources = {
  en: {
    ...AddressInputTranslations.en,
    ...EmergencyContactsTranslations.en,
    ...GuarantorVerificationTranslations.en,
    ...InsuranceV2Translations.en,
    ...LoginTranslations.en,
    ...PharmacyInputTranslations.en,
    ...DigitalCheckInTranslations.en,
    ...RecommendationTranslations.en,
    ...ReviewTranslations.en,
    common: {
      address: 'Address',
      cancel: 'Cancel',
      continue: 'Continue',
      edit: 'Edit',
      firstName: 'First name',
      generalError: "We've experienced an issue. Please try again later.",
      homePhone: 'Home phone',
      lastName: 'Last name',
      mobilePhone: 'Mobile phone',
      no: 'No',
      phone: 'Phone',
      phoneNumber: 'phone number',
      phoneType: 'Phone Type',
      relationshipToPatient: 'Relationship to patient',
      relationship: 'Relationship',
      remove: 'Remove',
      removeItem: 'Remove {{item}}',
      saveUpdates: 'Save updates',
      skip: 'Skip',
      someoneElse: 'Someone else',
      submit: 'Submit',
      yes: 'Yes',
    },
    insurance: {
      cameraAccessDeclined:
        'Camera permission is required to add a new insurance card. Please accept permissions in your browser settings to continue.\nOnce permissions have been added, refresh this page.',
      coverageStartDate: 'Coverage start date',
      doNotAddThisCard: "Don't add this card",
      doNotUseInsurance: "Don't use insurance",
      doNotUseInsuranceQuestion: "Don't use insurance?",
      goBack: 'Go back',
      groupNumber: 'Group number',
      logoOfInsuranceProvider: 'Logo of insurance provider',
      memberId: 'Member ID',
      subscriber: 'Subscriber',
      title:
        'Please upload images of the front and back of your insurance card.',
      toast: 'New insurance card added',
    },
    photoId: {
      digitalArrivalNote:
        'Adding your ID now will allow you to skip the front desk when you arrive for your appointment.',
      dontAddId: "Don't add ID",
      review:
        'Review the ID that we have on file and confirm that it is correct',
      skipIdTitle: 'Skip adding an ID?',
      skipIdWarning:
        'If skipping, make sure you bring your ID with you to your appointment so you can present it to the front desk at check-in.',
      title: "Upload photos of the patient's drivers license or government ID.",
    },
    uploadCard: {
      addAtAppointment: 'Add at appointment',
      addBackInstructions: 'Add the back of your card',
      addFrontInstructions: 'Add the front of your card',
      addNewCard: 'Add new card',
      back: 'Back',
      backCaptureDescription:
        'Line up the back of your card with the outlined area.',
      backCaptureTitle: 'Back of card',
      backOfCard: 'Back of card',
      capture: 'Capture',
      continue: 'Continue',
      fileTypeAlertMessage:
        'Incorrect file type. Please upload a .jpg, .png, .pdf, or .gif',
      front: 'Front',
      frontBackRequired: 'Front and back of card are both required for upload',
      frontCaptureDescription:
        'Line up the front of your card with the outlined area.',
      frontCaptureTitle: 'Front of card',
      frontCaptureToastMessage: 'Front of card successful! Now do the back.',
      frontOfCard: 'Front of card',
      loaderLabel: 'Uploading...',
      imgAltBack: 'Back of card',
      imgAltFront: 'Front of card',
      remove: 'Remove',
      pdfConversionFailureMessage:
        'Failed to process PDF. Please try uploading again',
      saveBackPhoto: 'Save back photo',
      saveFrontPhoto: 'Save front photo',
      title: 'Please upload images of the front and back of your card.',
      titleBack: 'Back of card',
      titleFront: 'Front of card',
      straighten: 'Straighten',
      upload: 'Upload',
    },
    translation: {
      ...CommonTranslations.en,
      add: 'Add',
      addInput: 'Add {{input}}',
      addSignatureDisclaimerP1:
        'By tapping "Add Signature", I agree to use electronic records and signatures. I have read the ',
      avoidUsingPatientsPhoneNumber: `Avoid using the patient's phone number`,
      cameraAccessDeclined:
        'Camera permission is required to add a new card. Please accept permissions in your browser settings to continue.\nOnce permissions have been added, refresh this page.',
      cameraLoading: 'Camera loading',
      cancelAppointment: 'Cancel appointment',
      cancelAppointment_plural: 'Cancel appointments',
      cancelAppointmentsFailedNotif:
        '{{numberOfFailedCancellations}} appointment failed to be cancelled',
      cancelAppointmentsFailedNotif_plural:
        '{{numberOfFailedCancellations}} appointments failed to be cancelled',
      cancelAppointmentsSucceededNotif:
        '{{numberOfSuccessfulCancellations}} appointment cancelled',
      cancelAppointmentsSucceededNotif_plural:
        '{{numberOfSuccessfulCancellations}} appointments cancelled',
      CELLPHONE: 'CELL',
      dataIsSecure:
        'All data is securely uploaded using bank-grade encryption and HIPAA-compliant methods.',
      dateOfBirth: 'Date of Birth',
      directions: 'Directions',
      emailAddress: 'Email Address',
      errorMessage: '{{input}} is missing',
      errorOccurredTryAgain: 'An error occured. Please try again.',
      errorOccuredRetryImage: 'An error occured. Please retry using an image.',
      email: 'email',
      employersPhoneNumber: `Employer's phone number`,
      enterAddress: 'Enter your address',
      enterMobilePhoneNumberAssociatedWithRecords:
        'Enter the mobile phone number associated with your records',
      failedUploadInternetError:
        'Failed to upload, please verify your internet connection and try again.',
      firstName: 'First Name',
      grossHouseholdIncome: 'Gross household income',
      HOMEPHONE: 'HOME',
      instructions: 'Instructions',
      invalidAddress: 'Invalid address',
      invalidInputError: "invalid {{type}} in the field '{{label}}'",
      invalidZipcode: 'Invalid zipcode',
      lastName: 'Last Name',
      mobilePhoneNumber: 'Mobile phone number',
      moreInformation: 'More information',
      nevermind: 'Nevermind',
      newSubscriberFormAlert:
        'This person is also commonly referred to as the “Subscriber” on your insurance card.',
      noUpdate: 'No, update',
      number: 'number',
      patientRelationshipToContact: 'Patient Relationship to Contact',
      placeholderAddress: '123 Main Street, San Francisco, CA, USA',
      placeholderEmail: 'you@email.com',
      pleaseAddPrimaryPhoneNumberForCallBack:
        'Please add the primary phone number where you would like to receive your call back.',
      pleaseConfirmAppointment: 'Please confirm the following appointment:',
      pleaseConfirmAppointment_plural:
        'Please confirm the following appointments:',
      phoneNumber: 'Phone Number',
      readMore: 'Read More',
      religionContextualHelp:
        'Gathering your religious affiliation allows us to provide you with the most personalized care that we can. Religion and spirituality can impact decisions regarding diet, medicines based on animal products, modesty, the preferred gender of their health providers and much more. Some religions have strict prayer times that may interfere with medical treatment, so knowing your religion allows us to be as respectful as possible.',
      reviewYourVisitForms:
        'Review your visit forms now to complete your visit registration and check-in for your appointment',
      reviewYourVisitForms_plural:
        'Review your visit forms now to complete your visit registration and check-in for your appointments',
      relationshipMainLabel: 'How is "{{entity1}}" related to "{{entity2}}"?',
      relationshipSubLabel: '{{entity}} is their...',
      resubscribePrompt: 'To resubscribe, click the button below:',
      resubscribe: 'Resubscribe',
      resubscribed: 'Resubscribed',
      reviewContactName:
        "Review {{contactName}}'s address on file and update if changed",
      sex: 'Sex',
      thankYouWeLookForward:
        'Thank you for your response. We look forward to your upcoming appointment.',
      thankYouWeLookForward_plural:
        'Thank you for your response. We look forward to your upcoming appointments.',
      thePersonPayingForThisVisit: 'the person paying for this visit',
      whoIsResponsibleForPayingThisVisit:
        'Who is responsible for paying for this visit?',
      WORKPHONE: 'WORK',
      unsubscribedMessage:
        'You have been unsubscribed from Notable Healthcare email updates at this email address.',
      unableToProcessRequest:
        'We were unable to automatically process your request.',
      unableToResubscribe: 'We were unable to resubscribe your email.',
      visitType: 'Visit {{type}}',
      yesConfirm: 'Yes, confirm',
      yesContinue: 'Yes, continue',
      yesConfirm_plural: 'Yes, confirm all',
    },
  },
  es: {
    ...AddressInputTranslations.es,
    ...EmergencyContactsTranslations.es,
    ...GuarantorVerificationTranslations.es,
    ...InsuranceV2Translations.es,
    ...LoginTranslations.es,
    ...DigitalCheckInTranslations.es,
    ...RecommendationTranslations.es,
    ...ReviewTranslations.es,
    common: {
      address: 'Dirección',
      remove: 'Eliminar',
      removeItem: 'Eliminar {{item}}',
      cancel: 'Cancelar',
      relationshipToPatient: 'Relación con el paciente',
      relationship: 'Relación',
      firstName: 'Primer nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      mobilePhone: 'Teléfono móvil',
      homePhone: 'Teléfono de casa',
      edit: 'Editar',
      saveUpdates: 'Guardar actualizaciones',
      someoneElse: 'Alguien más',
      skip: 'Saltar',
      submit: 'Enviar',
    },
    insurance: {
      coverageStartDate: 'Fecha de inicio de cobertura',
      doNotAddThisCard: 'No agregues esta tarjeta',
      doNotUseInsurance: 'No usar seguro',
      doNotUseInsuranceQuestion: '¿No usar seguro?',
      goBack: 'Volver',
      groupNumber: 'Número de grupo',
      logoOfInsuranceProvider: 'Logotipo del proveedor de seguros.',
      memberId: 'ID de Miembro',
      subscriber: 'Abonado',
      title: 'Cargue imágenes del frente y reverso de su tarjeta de seguro.',
      toast: 'Nueva tarjeta de seguro agregada',
      Other: 'Otro',
    },
    photoId: {
      title:
        'Sube fotos de la licencia de conducir o identificación gubernamental de la suscriptor.',
    },
    uploadCard: {
      addAtAppointment: 'Agregar en la cita',
      addBackInstructions: 'Agregue el reverso de su tarjeta',
      addFrontInstructions: 'Agregue el anverso de su tarjeta',
      addNewCard: 'Agregar nueva tarjeta',
      back: 'Reverso',
      backCaptureDescription:
        'Alinee el reverso de su tarjeta con el área delineada.',
      backCaptureTitle: 'Reverso de la tarjeta',
      capture: 'Capturar',
      continue: 'Continuar',
      fileTypeAlertMessage:
        'Tipo de archivo incorrecto. Cargue un .jpg, .png, .pdf o .gif',
      front: 'Anverso',
      frontCaptureDescription:
        'Alinee el anverso de su tarjeta con el área delineada.',
      frontCaptureTitle: 'Anverso de la tarjeta',
      frontCaptureToastMessage:
        '¡Anverso de la tarjeta exitoso! Ahora haz el reverso',
      imgAltBack: 'Reverso de su tarjeta',
      imgAltFront: 'Anverso de su tarjeta',
      loaderLabel: 'Cargando...',
      pdfConversionFailureMessage:
        'No se pudo procesar el PDF. Por favor intenta subir de nuevo',
      remove: 'Eliminar',
      saveBackPhoto: 'Guardar foto del reverso',
      saveFrontPhoto: 'Guardar foto del anverso',
      straighten: 'Enderezar',
      title: 'Cargue imágenes del anverso y reverso de su tarjeta de seguro.',
      titleBack: 'Reverso de la tarjeta',
      titleFront: 'Anverso de la tarjeta',
      upload: 'Cargar',
    },
    translation: {
      ...CommonTranslations.es,
      'dataIsSecure':
        'Todos los datos se cargan de manera segura usando métodos de cifrado de nivel bancario y que cumplen con HIPAA.',
      ' is required': ' se requiere',
      '# Days of strenuous activity / week':
        'Días de ejercicio intenso / semana',
      '## Allergy not appearing in search?\n\nPlease talk with your clinician about other allergies you may have.':
        '## ¿No encuentra su alergia en la búsqueda?\n\nHable con su médico sobre otras alergias que pueda tener.',
      '## Finding the correct Subscriber or Member ID\n\nEach insurance card has a unique ID that your insurance provider uses to identify you and any dependents you may have on your plan. It is usually located in the top left section of your card and can be called Member ID, Subscriber ID, or ID. Include all the letters and numbers in your ID, but leave out any dashes, spaces or other symbols.':
        '## Encontrar el suscriptor o ID de miembro correcto\n\nCada tarjeta de seguro tiene una identificación única que su proveedor de seguros usa para identificarlo a usted y a cualquier dependiente que pueda tener en su plan. Por lo general, se encuentra en la sección superior izquierda de su tarjeta y puede denominarse ID de miembro, ID de suscriptor o ID. Incluya todas las letras y números en su identificación, pero omita guiones, espacios u otros símbolos.',
      '## Who is my subscriber?\n\nThe subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        '## ¿Quién es el mi suscriptor?\n\nEl suscriptor es la persona que paga las primas del seguro de salud o cuyo empleo es la base para la afiliación al plan de seguro.',
      '(Arrive: {{time}})': '(Llegada: {{time}})',
      '(Canceled)': '(Cancelada)',
      '(Confirmed)': '(Confirmada)',
      '(Rescheduled)': '(Reprogramada)',
      ', or call {{phoneToCall}} for assistance.':
        ', o llama a {{phoneToCall}} para obtener ayuda.',
      '1 pack': '1 paquete',
      '1-2 times per month': '1 o 2 veces al mes',
      '1-2 times per week': '1 o 2 veces a la semana',
      '1-2 times per year': '1 o 2 veces al año',
      '1/2 pack': '1/2 paquete',
      '1/4 pack': '1/4 paquete',
      '2 packs': '2 paquetes',
      '3 packs': '3 paquetes',
      '3-5 times per week': '3 o 5 veces a la semana',
      '> 3 packs': '> 3 paquetes',
      'A 6-digit authentication code was sent':
        'Se envió un código de autenticación de 6 dígitos',
      'ADD': 'TDA: Trastorno por déficit de atención',
      'ADHD': 'TDAH: Trastorno por déficit de atención con hiperactividad',
      'Abdominal Pain': 'Dolor abdominal',
      'Abdominal pain': 'Dolor abdominal',
      'Acetaminophen': 'Paracetamol',
      'Acid Reflux': 'Reflujo ácido',
      'Acknowledge and submit': 'Aceptar y enviar',
      'Add Signature': 'Agregar firma',
      'Add all procedures that apply to your surgical history.':
        'Añade todos los procedimientos que correspondan a su historial quirúrgico.',
      'Add an allergy': 'Agregar alergias',
      'Add another surgery': 'Añadir otra cirugía',
      'Add the name of the location': 'Agregar el nombre de la ubicación',
      'Add to Calendar': 'Añadir al calendario',
      'Add your billing information': 'Agrega tu información de facturación',
      'Add your information to finish scheduling':
        'Agrega tu información para terminar de programar',
      'Add your payment information': 'Agrega tu información de pago',
      "Add your subscriber's information":
        'Agregue la información del suscriptor',
      'Address': 'Dirección',
      'Address Line 1': 'Dirección línea 1',
      'Address Line 2': 'Dirección línea 2',
      'Adhesive': 'Adhesiva',
      'Adhesive Bandage': 'Venda adhesiva',
      'Adhesive Tape': 'Venda adhesiva',
      'Adopted child': 'Hijo adoptado',
      'Agnostic': 'Agnóstico',
      'Alcohol abuse': 'Abuso de alcohol',
      'All appointments': 'Todas las citas',
      'Allergic Reaction': 'Reacción alérgica',
      'Allergy': 'Alergia',
      'Allergy not appearing in search?':
        '¿No encuentra su alergia en la búsqueda?',
      'Alone': 'Solo/a',
      'Alphabetically': 'Alfabéticamente',
      'Alprazolam': 'Alprazolam',
      "Alzheimer's disease": 'Enfermedad de Alzheimer',
      'American Indian or Alaska Native': 'Indio americano o nativo de Alaska',
      'Amish': 'Amish',
      'Amoxicillin': 'Amoxicilina',
      'Amoxicillin-Clavulanate': 'Amoxicilina-Clavulanato',
      'Amoxicillin-clavulanate': 'Amoxicilina-clavulánico',
      'Amphetamines': 'Anfetaminas',
      'Ampicillin': 'Ampicilina',
      'An error occurred, please try to reload the page.':
        'Ocurrió un error, intente recargar la página.',
      'Anaphylaxis': 'Anafilaxia',
      'Anaphylaxis/Allergy': 'Anafilaxia/alergia',
      'Anemia': 'Anemia',
      'Angioedema': 'Angioedema',
      'Annually': 'Anualmente',
      'Answer is invalid for question':
        'La respuesta no es válida para la pregunta',
      'Anxiety': 'Ansiedad',
      'Appendectomy': 'Apendicectomía',
      'Apply': 'Aplicar',
      'April': 'Abril',
      'Are you concerned about alcohol use at home?':
        '¿Le preocupa el consumo de alcohol en su hogar?',
      'Are you concerned about substance use at home?':
        '¿Le preocupa el consumo de sustancias en su hogar?',
      'Are you sexually active?': '¿Es sexualmente activo/a?',
      'Are you sure you want to cancel this appointment? This action cannot be undone.':
        '¿Está seguro que quiere cancelar esta cita? Esta acción no se puede cambiar.',
      'Are you sure you want to reschedule? This action cannot be undone. Rescheduled appointments will need to be re-confirmed closer to the appointment date.':
        '¿Seguro que quiere reprogramarla? Esta acción no se puede deshacer. Las citas reprogramadas deberán volver a confirmarse cuando se aproxime la fecha de la cita.',
      'Are you taking the following medications?':
        '¿Está tomando los siguientes medicamentos?',
      'Arrhythmia': 'Arritmia',
      'Arthralgia': 'Artralgia',
      'Arthritis': 'Artritis',
      'Asian': 'Asiático',
      'Asian Indian': 'Indio Asiático',
      'Aspirin': 'Aspirina',
      'Assisted Living Facility':
        'Vivienda para personas con necesidades especiales',
      'Asthma': 'Asma',
      'Atorvastatin': 'Atorvastatina',
      'Atrial Fibrillation': 'Fibrilación auricular',
      'Augmentin': 'Augmentina',
      'August': 'Agosto',
      'Aunt': 'Tía',
      'Aunt or uncle': 'Tía(o)',
      'Aunt/Uncle': 'Tía(o)',
      'Availability': 'Disponibilidad',
      'Azithromycin': 'Azitromicina',
      'Back': 'Volver',
      'Back left': 'Parte posterior izquierda',
      "Back of Driver's License": 'Dorso de la licencia de conducir',
      'Back of Insurance Card': 'Dorso de la tarjeta del seguro',
      'Back of card': 'Dorso de la tarjeta',
      'Back right': 'Parte posterior derecha',
      'Bactrim': 'Bactrim',
      'Based on the information you entered, you are not yet eligible to receive a vaccine.':
        'Según la información que ingresó, aún no es elegible para recibir una vacuna.',
      'Be sure to include any allergies that are new.':
        'Asegúrese de incluir cualquier alergia que sea nueva.',
      'Be sure to include drug and non-drug allergies.':
        'Incluya alergias a medicamentos y a otros productos.',
      'Benzodiazepines': 'Benzodiazepinas',
      'Bi-weekly': 'Quincenalmente',
      'Bilateral': 'Bilateral',
      'Birth control / contraceptive used (select all that apply)':
        'Control de la natalidad/anticonceptivo utilizado (seleccione todo lo que corresponda)',
      'Birth control pills': 'Pastillas anticonceptivas',
      'Bisexual': 'Bisexual',
      'Black or African American': 'Moreno o afroamericano',
      'Bleeding disorder': 'Trastorno hemorrágico',
      'Blood': 'Sangre',
      'Blood Products': 'Productos sanguíneos',
      'Both sides': 'Ambos lados',
      'Bradycardia': 'Bradicardia',
      'Breast cancer': 'Cáncer de mama',
      'Brother': 'Hermano',
      'Buddhist': 'Budista',
      'Bupivacaine': 'Bupivacaína',
      'By continuing, you agree to our': 'Al continuar, usted acepta nuestras',
      'addSignatureDisclaimerP1':
        "Al activar 'Agregar firma', acepto usar registros y firmas electrónicos. He leído las ",
      'CABG (Heart bypass surgery)': 'Cirugía de bypass coronario',
      'CELL': 'Célula',
      'CELLPHONE': 'Teléfono Celular',
      'COPD': 'EPOC: enfermedad pulmonar obstructiva crónica',
      'Cadaver donor': 'Donante fallecido',
      'Call now': 'Llame ahora',
      'Call {{practiceName}} at <link /> to complete this cancellation.':
        'Llame a {{practiceName}} al <link />  para completar esta cancelación.',
      'Cancel': 'Cancelar',
      'Cancel Appointment': 'Cancelar Cita',
      'Cancel an appointment': 'Cancelar una cita',
      'Cancellation window has passed':
        'Se ha superado el plazo de cancelación',
      'Cancelling appointment...': 'Cancelando cita...',
      'Cancelling appointments within {{time}} will require a call to the clinic listed above.':
        'Cancelar citas dentro de {{time}} requerirá de una llamada a la clínica anteriormente indicada.',
      'Cancer': 'Cáncer',
      'Cancer of stomach': 'Cáncer de estómago',
      'Cardiac pacemaker placement': 'Colocación de marcapasos cardíaco',
      "Care Provider's First Name": 'Nombre del proveedor de atención',
      "Care Provider's Last Name": 'Apellido del proveedor de atención',
      'Caregiver': 'Cuidador',
      'Catholic': 'Católico',
      'Cefazolin': 'Cefazolina',
      'Cefdinir': 'Cefdinir',
      'Ceftriaxone': 'Ceftriaxona',
      'Cefuroxime': 'Cefuroxima',
      'Celecoxib': 'Celecoxib',
      'Cephalexin': 'Cefalexina',
      'Cesarean section (C-Section)': 'Cesárea',
      'Change': 'Cambiar',
      'Change Language': 'Cambiar idioma',
      'Change pictures': 'Cambiar imágenes',
      'Chest Pain': 'Dolor torácico',
      'Chest pain': 'Dolor en el pecho',
      'Child': 'Hijo',
      'Child - no financial responsibility':
        'Hijo - sin responsabilidad financiera',
      'Child in law': 'Yerno, nuera',
      'Child where insured has no financial responsibility':
        'Hijo no dependiente',
      'Child-in-law': 'Yerno, nuera',
      'Children': 'Niños',
      'Chinese': 'Chino',
      'Cholecystectomy (Gallbladder removal)': 'Colecistectomía',
      'Choose not to disclose': 'No quiero responder',
      'Christian': 'Cristiano',
      'Christian Scientists': 'Científicos Cristianos',
      'Chronic Back Pain': 'Dolor de espalda crónico',
      'Chronic back pain': 'Dolor de espalda crónico',
      'Chronic kidney disease': 'Enfermedad renal crónica',
      'Ciprofloxacin': 'Ciprofloxacino',
      'Cirrhosis of liver': 'Cirrosis hepática',
      'Cisatracurium': 'Cisatracurio',
      'City': 'Ciudad',
      'Civil Union': 'Unión civil',
      'Clarithromycin': 'Claritromicina',
      'Clear images': 'Borrar imágenes',
      'Clear shaded area': 'Borrar área sombreada',
      'Clindamycin': 'Clindamicina',
      'Co-pay': 'Copago',
      'Cocaine': 'Cocaína',
      'Codeine': 'Codeína',
      'Cohabitating': 'Cohabitando',
      'Collateral dependent': 'Dependiente colateral',
      'Colon cancer': 'Cáncer de colon',
      'Colon cancer stage 1': 'Cáncer de colon estadío 1',
      'Complete my registration': 'Completar mi registro',
      'Condom': 'Condón',
      'Confirming appointments...': 'Confirmando citas...',
      'Confirming your appointment...': 'Su cita está siendo confirmada.',
      'Confusion': 'Desorientación',
      'Congestive heart failure': 'Insuficiencia cardíaca congestiva',
      'Conjunctivitis': 'Conjuntivitis',
      'Continue': 'Continuar',
      'Continue to back of body': 'Continuar a la parte posterior del cuerpo',
      'Continue to payment': 'continuar con el pago',
      'Continue without receipt': 'Continuar sin recibo',
      'Continue without signing': 'Continuar sin firmar',
      'Controlled Substance Agreement': 'Acuerdo de Sustancias Controladas',
      'Coronary Artery Disease': 'Arteriopatía coronaria',
      'Coronary artery disease': 'Arteriopatía coronaria',
      'Cortisone': 'Cortisona',
      'Cough': 'Tos',
      'Counseling': 'Asesoramiento',
      'Court appointed guardian': 'Tutor designado por la corte',
      'Cousin': 'Primo(a)',
      'Coverage Start Date': 'Fecha de inicio de la cobertura',
      "Cow's Milk": 'Productos lácteos',
      'Craniotomy': 'Craneotomía',
      'Cuban': 'Cubano',
      'Current everyday smoker': 'Fumo todos los días',
      'Current someday smoker': 'Fumador actual leve de tabaco',
      'Currently use': 'Consumo actualmente',
      'Daily': 'A diario',
      'Date of Birth': 'Fecha de nacimiento',
      'Date of birth': 'Fecha de nacimiento',
      'Dates': 'Fechas',
      'Daughter': 'Hija',
      'Day (Optional)': 'Día (Opcional)',
      'Daycare': 'Cuidador/a',
      'Days': 'Días',
      'December': 'Diciembre',
      'Decreased Blood Pressure': 'Hipotensión',
      'Decreased Heart Rate': 'Bradicardia',
      'Decreased blood pressure': 'Disminución de la presión arterial',
      'Decreased heart rate': 'Disminución del ritmo cardíaco',
      'Dementia': 'Demencia',
      'Demerol': 'Demerol',
      'Dependent child': 'Hijo dependiente',
      'Dependent of minor dependent': 'Dependiente del dependiente menor',
      'Depression': 'Depresión',
      'Dermatitis': 'Dermatitis',
      'Developmental delay': 'Retraso en el desarrollo',
      'Dexamethasone': 'Dexametasona',
      'Dexmedetomidine': 'Dexmedetomidina',
      'Diabetes': 'Diabetes',
      'Diabetes Type 1': 'Diabetes tipo 1',
      'Diabetes Type 2': 'Diabetes tipo 2',
      'Diarrhea': 'Diarrea',
      'Diazepam': 'Diazepam',
      'Dietary': 'Dietético',
      'Dietary Restrictions': 'Restricciones en la dieta',
      'Dignity Consent to Release PHI':
        'Consentimiento de Dignity para divulgar PHI',
      'Dignity Established Patient Consent - CA':
        'Dignidad establecido consentimiento del paciente - CA',
      'Dignity Health - Notice Of Privacy Practices for Health Information (NPP) Acknowledgment Form':
        'Dignity Health - Formulario de acuse de recibo del Aviso de prácticas de privacidad para la información de salud (NPP)',
      'Dignity Health Conditions of Admissions':
        'Dignidad Salud Condiciones de Admisión',
      'Dignity Health Conditions of Admissions (NEW)':
        'Dignidad Salud Condiciones de Admisión',
      'Dignity Health Established Patient Consent':
        'Consentimiento del paciente establecido por Dignity Health',
      'Dignity New Patient Consent':
        'Consentimiento de paciente nuevo de Dignity Health',
      'Dignity New Patient Consent - CA':
        'Dignidad Nuevo consentimiento del paciente - CA',
      'Diphenhydramine': 'Difenhidramina',
      'Disabled': 'Persona con discapacidad',
      'Disorder caused by alcohol': 'Trastorno causado por el alcohol',
      'Distance': 'Distancia',
      'Diverticulitis': 'Diverticulitis',
      'Divorced': 'Divorciado/a',
      'Dizziness': 'Mareo',
      'Do not wish to provide': 'No deseo responder',
      'Do you have additional insurance you would like to add?':
        '¿Tiene un seguro adicional que desearía agregar?',
      'Do you have any feedback for improving the payment experience?':
        '¿Tiene algún comentario para mejorar la experiencia de pago?',
      'Does not use seatbelts': 'No usa cinturón de seguridad',
      'Does not wear helmet': 'No usa casco',
      'Domestic partnership': 'Pareja doméstica',
      'Done adding allergies': 'He terminado de añadir las alergias',
      'Donor': 'Donante',
      'Dont know': 'No lo sé',
      'Doripenem': 'Doripenem',
      'Doxycycline': 'Doxiciclina',
      'Drag to reposition photo':
        'Arrastrar para cambiar la posición de la foto',
      'Dyspnea': 'Disnea',
      'Ecstasy': 'Éxtasis',
      'Eczema': 'Eczema',
      'Edema': 'Edema',
      'Edit': 'Editar',
      'Edit Drawing': 'Editar Dibujo',
      'Eggs': 'Huevos',
      'Electronic Record and Signature Disclosures':
        'divulgaciones de registro y firma electrónicos',
      'Email is missing or invalid':
        'Falta el correo electrónico o no es válido',
      'Email me a receipt': 'Envíame un recibo por correo electrónico',
      'Emancipated minor': 'Menor emancipado',
      'Emotional problem': 'Problema emocional',
      'Emphysema': 'Enfisema',
      'Employed': 'Empleado',
      'Employee': 'Empleado',
      'Employer': 'Nombre del empleador',
      'Employer name': 'Nombre del empleador',
      'Employment status': 'Situación laboral',
      'Enalapril': 'Enalapril',
      'End stage renal disease requiring dialysis':
        'Insuficiencia renal de estadio terminal en diálisis',
      'English': 'Inglesa',
      'Enter the following information from your insurance card.':
        'Ingrese la siguiente información de su tarjeta de seguro.',
      'Enter their name...': 'Indique su nombre...',
      'Enter your answer here...': 'Escribe aquí tu respuesta...',
      'Enter your email': 'Introduce tu correo electrónico',
      'Environmental risks:': 'Riesgos ambientales:',
      'Epilepsy': 'Epilepsia',
      'Error with selected payment method. Please choose another option.':
        'Error con el método de pago seleccionado. Por favor elige otra opción.',
      'Ertapenem': 'Ertapenem',
      'Erythromycin': 'Eritromicina',
      'Etomidate': 'Etomidato',
      'Every day of the week': 'Cada día de la semana',
      'Ex-spouse': 'Ex-esposo/a',
      'Ex spouse': 'Ex esposo/a',
      'Example: rash on right leg': 'Ejemplo: erupción en la pierna derecha',
      'Exposed to hazardous chemicals or paint':
        'Exposición a químicos peligrosos o pinturas',
      'Exposed to pets/animals': 'Exposición a mascotas/animales',
      'Extended family': 'Familia extendida',
      'Eye Redness': 'Enrojecimiento de los ojos',
      'Eye Swelling': 'Hinchazón de los ojos',
      'Eye redness': 'Enrojecimiento de los ojos',
      'Eye swelling': 'Inflamación de los ojos',
      'Eyelid Swelling': 'Hinchazón de párpados',
      'Facial Swelling': 'Hinchazón facial',
      'Failed to load PDF file.': 'No se pudo cargar el archivo PDF.',
      'Failed to send a verification code at the moment, please see the front desk.':
        'No se pudo enviar un código de verificación en este momento, diríjase a la recepción.',
      'Failed to send verification code, please try again later.':
        'No se pudo enviar el código de verificación, inténtalo de nuevo más tarde.',
      'Failed to submit call back request, please contact your care provider.':
        'No se pudo enviar la solicitud de devolución de llamada, comuníquese con su proveedor de atención.',
      'Failed to verify code, please see the front desk.':
        'No se pudo verificar el código, diríjase a la recepción.',
      'Father': 'Padre',
      'Father-in-law': 'Suegro',
      'Father in law': 'Suegro',
      'February': 'Febrero',
      'Female': 'Femenino',
      'Fentanyl': 'Fentanilo',
      'Fetching available time slots...':
        'Obteniendo intervalos de tiempo disponibles...',
      'Fever': 'Fiebre',
      'Fibromyalgia': 'Fibromialgia',
      'Finish': 'Terminar',
      'First name': 'Nombre',
      'Fish': 'Pescado',
      'Five times per week': 'cinco veces por semana',
      'Flushing': 'Enrojecimiento',
      'For your security,': 'Para su seguridad,',
      'For your security, in which of the following ZIP codes do you reside?':
        'Por su seguridad, ¿en cuál de los siguientes códigos postales reside?',
      'Formerly smoker': 'Fumé en el pasado',
      'Formerly used': 'Solía consumir',
      'Forms & Documents': 'Formularios y documentos',
      'Foster Care': 'Orfanato',
      'Foster child': 'Hijo adoptivo',
      'Foster parent': 'Padre adoptivo',
      'Four times per week': 'cuatro veces por semana',
      'French': 'Francesa',
      'Frequency': 'Frecuencia',
      'Friend': 'Amigo(a)',
      'Friend/Neighbor': 'Amigo/Vecino',
      'Friends or family available to help?':
        '¿Tiene amigos o familiares que puedan ayudarle?',
      'From': 'De',
      'Front left': 'Frente izquierdo',
      "Front of Driver's License": 'Frente de la licencia de conducir',
      'Front of Insurance Card': 'Frente de la tarjeta del seguro',
      'Front of card': 'Frente de la tarjeta',
      'Front right': 'Frente derecho',
      'Full payment is not required at this time but will save you time when you arrive.':
        'El pago completo no es necesario en este momento, pero le ahorrará tiempo cuando llegue.',
      'Full time': 'Tiempo completo',
      'Furosemide': 'Furosemida',
      'GI tract cancer (includes gastric, esophageal)':
        'Cáncer del tracto GI (incluye gástrico, esofágico)',
      'Gabapentin': 'Gabapentina',
      'Gastric bypass surgery': 'Cirugía de bypass gástrico',
      'Gastric cancer': 'Cáncer gástrico',
      'Gastroesophageal reflux disease (GERD)':
        'Enfermedad por reflujo gastroesofágico',
      'Gathering provider availability':
        'Reuniéndo disponibilidad de proveedores',
      'Gentamicin': 'Gentamicina',
      'German': 'Alemana',
      'Glaucoma': 'Glaucoma',
      'Gluten': 'Gluten',
      'Glutens': 'Gluten',
      'Go back to insurance list': 'Volver a la lista de seguros',
      'Grandchild': 'Nieto(a)',
      'Granddaughter': 'Nieta',
      'Grandfather': 'Abuelo',
      'Grandmother': 'Abuela',
      'Grandparent': 'Abuelo(a)',
      'Grandson': 'Nieto',
      'Great Grandfather': 'Bisabuelo',
      'Great Grandmother': 'Bisabuela',
      'Great Grandparent': 'Bisabuelo(a)',
      'Great grandfather': 'Bisabuelo',
      'Great grandmother': 'Bisabuela',
      'Great-grandfather': 'Bisabuelo',
      'Great-grandmother': 'Bisabuela',
      'Group or plan number': 'Número de grupo o plan',
      'Guamanian or Chamorro': 'Guamaniano o Chamorro',
      'Guardian': 'Tutor legal',
      'HIV': 'VIH',
      'HOME': 'Casa',
      'HOMEPHONE': 'Teléfono de Casa',
      'Haldol': 'Haldol',
      'Hallucinations': 'Alucinaciones',
      'He/Him/His': 'Él',
      'Hallucinogens/LSD': 'Alucinógenos/LSD',
      'Handicapped dependent': 'Dependiente discapacitado',
      'He / him': 'Él / su',
      'Headache': 'Cefalea',
      'Heart Failure': 'Insuficiencia cardiaca',
      'Heart attack': 'Infarto de miocardio',
      'Heart failure': 'Insuficiencia cardiaca',
      'Heart murmur': 'Soplo cardíaco',
      'Heart valve replacement': 'Sustitución de válvula cardiaca',
      'Heavy tobacco smoker': 'Fumador severo de tabaco',
      'Hernia repair': 'Reparación de hernia',
      'Heroin': 'Heroína',
      'High Blood Pressure': 'Alta presión sanguínea',
      'High Cholesterol': 'Colesterol alto',
      'High blood pressure (hypertension)': 'Hipertensión',
      'High cholesterol (hyperlipidemia)': 'Colesterol alto',
      'Hindu': 'Hindú',
      'Hip replacement': 'Reemplazo de cadera',
      'Hispanic, Latino or Spanish Origin':
        'Hispano, latino o de origen español',
      'Hives': 'Urticaria',
      'Home does not have smoke/CO detectors':
        'Vivienda sin detectores de humo/CO',
      'Home has a pool/is on a lake': 'Vivienda con piscina/junto a un lago',
      'Home has mold/water damage': ' Vivienda con humedades/daños por agua',
      'Home has stairs': 'Vivienda con escaleras',
      'Home with Assistance': 'Vivienda con asistencia',
      'Home/Independent': 'Vivienda/Independiente',
      'Homeless Shelter': 'Refugio para indigentes',
      'Hospice': 'Hospicio',
      'How is the patient related to the person paying for this visit?':
        '¿Cómo se relaciona el paciente con la persona que paga esta visita?',
      'How is the patient related to the subscriber of the insurance?':
        '¿Cómo se relaciona el paciente con el suscriptor del seguro?',
      'How is the subscriber of the insurance related to the patient?':
        '¿Cómo se relaciona el suscriptor del seguro con el paciente?',
      'How many packs a day?': '¿Cuántos paquetes al día?',
      'How many years did you use?': '¿Cuántos años lo consumió?',
      'How often do you typically use these drugs?':
        '¿Con qué frecuencia suele consumir estas drogas?',
      "How would you like to pay for today's visit?":
        '¿Cómo le gustaría pagar la visita de hoy?',
      'How would you like to verify your identity?':
        '¿Cómo le gustaría verificar su identidad?',
      'Hydrocodone': 'Hidrocodona',
      'Hydrocortisone': 'Hidrocortisona',
      'Hydromorphone': 'Hidromorfona',
      'Hypertension': 'Hipertensión',
      'Hyperthyroidism': 'Hipertiroidismo',
      'Hypnosis': 'Hipnosis',
      'Hypotension': 'Hipotensión',
      'Hypothyroidism': 'Hipotiroidismo',
      'Hysterectomy': 'Histerectomía',
      'I acknowledge that this appointment will not be canceled until I call the clinic number listed with the appointment':
        'Reconozco que esta cita no será cancelada hasta que no me comunique con la clinical al teléfono indicado en este comunicado',
      'I am signing for...': 'Firmo para...',
      'I am the parent, legal guardian, or person with legal authority to make health care decisions on behalf of the patient':
        'soy el padre, la madre, el tutor legal o la persona con autoridad legal para tomar decisiones de atención médica en nombre del paciente',
      'I am the patient': 'soy el paciente',
      "I don't have any allergies": 'No tengo alergias',
      "I don't have any surgical history": 'no tengo antecedentes quirurgicos',
      "I don't have my card": 'no tengo mi tarjeta',
      "I'll pay later": 'pagaré más tarde',
      'IBS': 'Síndrome del intestino irritable',
      'ICD (Internal cardiac defibrillator placement)':
        'Colocación de desfibrilador cardíaco interno',
      'IUD': 'DIU',
      'Ibuprofen': 'Ibuprofeno',
      'If any of these allergies have changed please discuss this with your caregiver in person.':
        'Si alguna de estas alergias ha cambiado, discútalo personalmente con su médico.',
      "If you believe you've received this message in error, please try again or call us at {{phoneNumber}}":
        'Si cree que ha recibido este mensaje por error, inténtelo de nuevo o llámenos al {{phoneNumber}}',
      'If you cannot find your payor, please select "Other"':
        "Si no puede encontrar su pagador, seleccione 'Otro'",
      'If you previously unsubscribed, you will be resubscribed so we can deliver this verification text message.':
        'Si canceló su suscripción anteriormente, se le volverá a suscribir para que podamos enviarle este mensaje de texto de verificación.',
      'Imipenem': 'Imipenem',
      'In law': 'Familiar político',
      'In recovery': 'Recuperándose',
      'In-Law': 'Familiar político',
      'Include all numbers & letters': 'Incluir todos los números y letras',
      'Incorrect zip code.': 'Código postal incorrecto.',
      'Increased Blood Pressure': 'Hipertensión',
      'Increased Heart Rate': 'Taquicardia',
      'Increased Sensitivity To Light': 'Fotosensibilidad',
      'Increased blood pressure': 'Aumento de la presión arterial',
      'Increased heart rate': 'Aumento del ritmo cardíaco',
      'Increased sensitivity to light': 'Mayor sensibilidad a la luz',
      'Indomethacin': 'Indometacina',
      'Inflammatory bowel disease': 'Enfermedad inflamatoria intestinal',
      'Inhalants/Glues/Solvents': 'Colas disolventes inhalantes',
      'Injured plaintiff': 'Demandante lesionado',
      'Insomnia': 'Insomnio',
      'Insulin': 'Insulina',
      'Insurance #': 'Seguro No.',
      'Insurance Company': 'Compañía de seguros',
      'Inter-sex': 'Intersexual',
      'Invalid date of birth format: {{dateOfBirth}}':
        'Formato de fecha de nacimiento no válido: {{dateOfBirth}}',
      'Invalid verification code.': 'Código de verificación invalido',
      'Invalid zip selected, please select/unselect the correct zip and try again.':
        'El código postal seleccionado no es válido, seleccione / anule la selección del código postal correcto y vuelva a intentarlo.',
      'Iodinated_contrast': 'Contraste_yodado',
      'Iodine': 'Yodo',
      'Irregular Heart Rate': 'Ritmo cardíaco irregular',
      'Irregular heart rate': 'Frecuencia cardíaca irregular',
      'Irritable bowel syndrome': 'Síndrome del intestino irritable',
      'Is this insurance still accurate and active?':
        '¿Este seguro sigue siendo preciso y activo?',
      'Is this still your primary insurance?':
        '¿Sigue siendo este su seguro principal?',
      'Itching': 'Picor',
      'January': 'Enero',
      'Japanese': 'Japonés',
      "Jehova's Witness": 'Testigo de Jehová',
      'Jewish': 'Judío',
      'Joint Notice Of Privacy Practices for Health Information (NPP) Acknowledgment Form':
        'Dignity Health - Formulario de acuse de recibo del Aviso de prácticas de privacidad para la información de salud (NPP)',
      'Joint Pain': 'Dolor en las articulaciones',
      'Joint pain': 'Dolor en las articulaciones',
      'Joint repair': 'Reparación articular',
      'July': 'Julio',
      'June': 'Junio',
      'Keflex': 'Keflex',
      'Ketamine': 'Ketamina',
      'Kidney disease': 'Nefropatía',
      'Kidney transplant': 'Trasplante renal',
      'Knee replacement': 'Reemplazo de rodilla',
      'Korean': 'Coreano',
      'Labetalol': 'Labetalol',
      'Lactose': 'Lactosa',
      'Lactose intolerance': 'Intolerancia a la lactosa',
      'Last name': 'Apellido',
      'Last name and date of birth must be provided.':
        'Deben proporcionarse el apellido y la fecha de nacimiento.',
      'Latex': 'Látex',
      'Left': 'Izquierdo',
      'Left side': 'Lado izquierdo',
      'Legal': 'Legal',
      'Legal first name': 'Primer nombre legal',
      'Legal guardian': 'Tutor legal',
      'Legal last name': 'Apellido legal',
      'Lesbian, gay or homosexual': 'Lesbiana, gay u homosexual',
      'Leukemia': 'Leucemia',
      'Levofloxacin': 'Levofloxacino',
      'Levofloxacin (Levaquin)': 'Levofloxacino',
      'Lidocaine': 'Lidocaína',
      'Life Partner': 'Compañero de vida',
      'Life partner': 'Compañero de vida',
      'Light Sensitivity': 'Fotosensibilidad',
      'Light tobacco smoker': 'Fumador moderado de tabaco',
      'Linezolid': 'Linezolida',
      'Lisinopril': 'Lisinopril',
      'Liver cancer': 'Cáncer hepático',
      'Liver cirrhosis': 'Cirrosis hepática',
      'Living situation:': 'Situación de vida:',
      'Loading PDF...': 'Cargando PDF...',
      'Loading...': 'Cargando...',
      'Logout': 'Cerrar sesión',
      'Lorazepam': 'Lorazepam',
      'Losartan': 'Losartán',
      'Lovastatin': 'Lovastatina',
      'Lumpectomy (Breast mass removal)': 'Tumorectomía',
      'Lung cancer': 'Cáncer pulmonar',
      'Lupus': 'Lupus',
      'Lymphoma': 'Linfoma',
      'MMG Behavioral Health Late Cancellation / Missed Appointments, Consent for Treatment, & Disclosure of Info':
        'MMG Behavioral Health Cancelación tardía / Citas perdidas, Consentimiento para tratamiento y Divulgación de información',
      'Mailing Address': 'Dirección postal',
      'Male': 'Masculino',
      'Mannitol': 'Manitol',
      'March': 'Marzo',
      'Marijuana': 'Marihuana',
      'Mark Twain Conditions of Admission':
        'Condiciones de admisión de Mark Twain',
      'Married': 'Casado/a',
      'Mastectomy (Breast removal)': 'Mastectomía',
      'Maternal Aunt': 'Tía materna',
      'Maternal Grandfather': 'Abuelo materno',
      'Maternal Grandmother': 'Abuela materna',
      'Maternal Uncle': 'Tío materno',
      'Max login attempts reached. Please contact your provider for support.':
        'Se alcanzó el número máximo de intentos de inicio de sesión. Comuníquese con su proveedor para obtener ayuda.',
      'May': 'Mayo',
      'Medications': 'Medicamentos',
      'Mental disability': 'Discapacidad mental',
      'Meperidine': 'Meperidina',
      'Meropenem': 'Meropenem',
      'Methamphetamines': 'Metanfetaminas',
      'Methylprednisolone': 'Metilprednisolona',
      'Metoclopramide': 'Metoclopramida',
      'Metoprolol': 'Metoprolol',
      'Metronidazole': 'Metronidazol',
      'Mexican': 'Mexicano',
      'Midazolam': 'Midazolam',
      'Middle Eastern or North African': 'Medio Oriente o Norte de África',
      'Migraine headaches': 'Migraña',
      'Migraines': 'Migrañas',
      'Mild': 'Leve',
      'Milk Products': 'Productos lácteos',
      'Minocycline': 'Minociclina',
      'Minor': 'Menor',
      'Moderate': 'Moderada',
      'Modify Appointment': 'Modificar cita',
      'Month': 'Mes',
      'Monthly': 'Mensualmente',
      'Months': 'Meses',
      'More information': 'Más información',
      'Mormon': 'Mormón',
      'Morphine': 'Morfina',
      'Mother': 'Madre',
      'Mother-in-law': 'Suegra',
      'Mother in law': 'Suegra',
      'Moxifloxacin': 'Moxifloxacino',
      'Multiple sclerosis': 'Esclerosis múltiple',
      'Muscle Pain': 'Dolor muscular',
      'Muscle pain': 'Dolor muscular',
      'Muslim': 'Musulmán',
      'Myself': 'Mí',
      'Name': 'Nombre',
      'Name of surgery': 'Nombre de la cirugía',
      'Names of parent(s) / guardian(s):': 'Nombres de los padres/tutor(es):',
      'Names of sibling(s):': 'Nombres de los hermanos:',
      'Naproxen': 'Naproxeno',
      'Native Hawaiian or Pacific Islander':
        'Nativo de Hawái o de las islas del Pacífico',
      'Natural planning': 'Planificación natural',
      'Nausea': 'Náuseas',
      'Need help signing in?': '¿Necesita ayuda para iniciar sesión?',
      'Need help?': '¿Necesitas ayuda?',
      'Negative Feedback': 'Retroalimentación negativa',
      'Neighbor': 'Vecino(a)',
      'Never smoker': 'Nunca he fumado',
      'Never used': 'Nunca he consumido',
      'Nevermind, keep appointment': 'No importa, mantener cita',
      'Nicotine replacement': 'reemplazo de nicotina',
      'Niece or nephew': 'Sobrino, sobrina',
      'Niece/Nephew': 'Sobrino(a)',
      'Nissen fundoplication': 'Funduplicatura de Nissen',
      'Nitrofurantoin': 'Nitrofurantoína',
      'No': 'No',
      'No appointments available': 'No hay citas disponibles',
      'No Pronouns': 'Sin Pronombres',
      'No matches found.': 'No se encontraron coincidencias.',
      "No, I'm paying out of pocket": 'No, estoy pagando de mi bolsillo',
      'No, continue': 'No, continuar',
      'No, my ID has changed': 'No, mi ID ha cambiado',
      'No, my insurance has changed': 'No, mi seguro ha cambiado',
      'Non-Binary': 'No binario',
      'Nonbinary or genderqueer': 'No binario',
      'None of the above': 'Ninguna de las anteriores',
      'Not Hispanic, Latino or Spanish Origin':
        'No hispano, latino ni de origen español',
      'Not employed': 'Sin empleo',
      'Not finding your ideal availability?':
        '¿No encuentras tu disponibilidad ideal?',
      'Not sure?': 'No estoy segura',
      'Not taking': 'No los estoy tomando',
      'Not used since pregnant': 'Sin uso desde el embarazo',
      'November': 'Noviembre',
      'Nsaids': 'AINE',
      'Number of minutes of activity': 'Número de minutos de actividad',
      'Obesity': 'Obesidad',
      'Obstructive sleep apnea': 'Apnea obstructiva del sueño',
      'October': 'Octubre',
      'Ofloxacin': 'Ofloxacina',
      'On active military duty': 'En servicio militar activo',
      'On behalf of the patient': 'Para el paciente',
      'On days that you drink alcohol, how many drinks do you typically consume?':
        'En los días que bebe alcohol, ¿cuántas copas se toma normalmente?',
      'Once per week': 'Una vez por semana',
      'Ondansetron': 'Ondansetrón',
      'Only 100 characters allowed': 'Solo se permiten 100 caracteres',
      'Opioids': 'Opioides',
      'Optional': 'Opcional',
      'Organ donor': 'Donante de órganos',
      'Orthodox Jews': 'Judíos Ortodoxos',
      'Osteoarthritis': 'Osteoartritis',
      'Osteoporosis': 'Osteoporosis',
      'Other': 'Otro',
      'Other (specify)': 'Otra',
      'Other Existing Problem': 'Otro problema existente',
      'Other adult': 'Otro adulto',
      'Ovarian cancer': 'Cáncer ovárico',
      'Overage Dependent': 'Dependiente mayor',
      'Overage dependent': 'Dependiente mayor',
      'Oxycodone': 'Oxicodona',
      'Pancreatic cancer': 'Cáncer pancreático',
      'Pancuronium': 'Pancuronio',
      'Parent': 'Padre',
      'Parent in law': 'Suegro(a)',
      'Parent-in-law': 'Suegro(a)',
      'Parental marital status:': 'Estado civil de los padres:',
      "Parkinson's": 'Enfermedad de Parkinson',
      'Part time': 'Tiempo parcial',
      'Participate in high risk sports': 'Participa en deportes de alto riesgo',
      'Partnered': 'Compañero/a',
      'Paternal Aunt': 'Tía paterna',
      'Paternal Grandfather': 'Abuelo paterno',
      'Paternal Grandmother': 'Abuela paterna',
      'Paternal Uncle': 'Tío paterno',
      'Patient date of birth': 'Fecha de nacimiento del paciente',
      'Patient last name': 'Apellido',
      'Pay': 'Pagar',
      'Pay later': 'Paga después',
      'Pay out-of-pocket': 'Pago de bolsillo',
      'Pay total due': 'Pagar el total adeudado',
      'Pay with insurance': 'Pago con seguro',
      'Payment successful': 'Pago exitoso',
      'Peanut': 'Manís',
      'Peanuts': 'Maní',
      'Penicillin': 'Penicilina',
      'Peptic ulcer disease': 'Enfermedad de úlcera péptica',
      'Percocet': 'Percocet',
      'Personal family': 'Familiar personal',
      'Phone number is missing or invalid':
        'Falta el número de teléfono o no es válido',
      'Please briefly describe the reason for your visit':
        'Describa brevemente el motivo de su visita',
      'Please choose a payment method below.':
        'Elija un método de pago a continuación.',
      'Please don’t share any sensitive personal information, as this feedback will be shared with non-clinical members of our team to improve the experience.':
        'No comparta ninguna información personal confidencial, ya que estos comentarios se compartirán con miembros no clínicos de nuestro equipo para mejorar la experiencia.',
      'Please enter a month': 'Por favor ingrese un mes',
      "Please enter a valid date between your birth date and today's date.":
        'Por favor ingrese una fecha válida entre su fecha de nacimiento y la fecha de hoy.',
      'Please enter a valid date of birth':
        'Por favor ingresa una fecha de nacimiento valida',
      'Please enter a valid day': 'Por favor ingrese un día válido',
      'Please enter a valid phone number':
        'Por favor ingrese un número de teléfono válido',
      'Please enter a valid year': 'Por favor ingrese un año válido',
      'Please enter the following information to confirm your vaccine status:':
        'Ingrese la siguiente información para confirmar su estado de vacunación:',
      "Please enter the patient's date of birth and last name.":
        'Por favor ingrese la fecha de nacimiento y el apellido del paciente.',
      'Please enter your date of birth':
        'Por favor ingrese su fecha de nacimiento',
      'Please enter your first name': 'Por favor ingrese su Primer nombre',
      'Please enter your last name': 'Por favor ingrese su apellido',
      'Please enter your phone number before submitting.':
        'Por favor, introduzca su número de teléfono antes de enviar.',
      'Please explain (optional)': 'Por favor explique (opcional)',
      'Please provide more details regarding your allergy':
        'Proporcione más detalles sobre su alergia',
      'Please provide more details regarding your procedure':
        'Proporcione más detalles sobre su procedimiento',
      'Please provide your information:':
        'Por favor proporcione su información:',
      'Please review the following document(s).':
        'Por favor, revise los siguientes documentos.',
      'Please review the required documents and mark them as checked.':
        'Por favor revise los documentos requeridos y márquelos como marcados.',
      'Please select an option for each medication':
        'Seleccione una opción para cada medicamento',
      'Please shade all locations you have pain or discomfort.':
        'Sombree todos los lugares donde tenga dolor o malestar.',
      'Please talk with your clinician about other allergies you may have.':
        'Hable con su médico sobre otras alergias que pueda tener.',
      'Positive Feedback': 'Retroalimentación positiva',
      'Prednisolone': 'Prednisolona',
      'Prednisone': 'Prednisona',
      'Prefer not to answer': 'Prefiero no responder',
      'Preferred Pharmacy': 'Farmacia preferida',
      'Pregabalin': 'Pregabalina',
      'Prepayment': 'Pago por adelantado',
      'Prescription Medications': 'Medicamentos prescritos',
      'Primary Care Provider': 'Proveedor de atención primaria',
      'Primary Insurance': 'Seguro primario',
      'Prior balance': 'Saldo anterior',
      'Procaine': 'Procaína',
      'Promethazine': 'Prometazina',
      'Propofol': 'Propofol',
      'Prostate cancer': 'Cáncer prostático',
      'Prostatectomy': 'Prostatectomía',
      'Psoriasis': 'Soriasis',
      'Puerto Rican': 'Puertorriqueño',
      'REQUIRED': 'REQUERIDO',
      'Ramipril': 'Ramipril',
      'Rash': 'Erupción',
      'Reason for Visit': 'Razón de la visita',
      'Recipient': 'Receptor',
      'Refuse to disclose': 'No quiero responder',
      'Relationship': 'Relación',
      'Relationship to the patient': 'Relación con el paciente',
      'Relative': 'Pariente',
      'Remove pharmacy': 'Eliminar farmacia',
      'Remove this insurance': 'Eliminar este seguro',
      'Request a call back': 'Solicitar una devolución de llamada',
      'Requires verification': 'Requiere verificación',
      'Reschedule Appointment': 'Reprogramar Cita',
      'Reschedule appointment': 'Reprogramar cita',
      'Reschedule or cancel appointment': 'Reprogramar o cancelar cita',
      'Rescheduling appointment...': 'Reprogramando cita...',
      'Respiratory distress': 'Dificultad respiratoria',
      'resubscribed': 'Reinscrito',
      'resubscribe': 'Reinscribirse',
      'Retired': 'Jubilado',
      'Retired military': 'Militar retirado',
      'Retrieving patient information':
        'Recuperación de información del paciente',
      'Review & pay your': 'Revisa y paga tu',
      'Review and update your current allergies.':
        'Revise y actualice sus alergias actuales.',
      'Review and update your surgical history.':
        'Revisar y actualizar su historial quirúrgico.',
      'Review the Photo ID we have on file. Is this ID still valid?':
        'Revise la identificación con foto que tenemos en el archivo. ¿Sigue siendo válida esta identificación?',
      'Review the following visit instructions to finish confirming your appointments:':
        'Revise las siguientes instrucciones de su visita para terminar de confirmar sus citas:',
      'Review the requirements for cancelling appointments within {{time}}:':
        'Revise los requisitos para cancelar su cita con {{time}} de anticipación:',
      'Rheumatoid arthritis': 'Artritis reumatoide',
      'Right': 'Derecho',
      'Right side': 'Lado derecho',
      'Ringing In Ears': 'Zumbido en los oídos',
      'Ringing in ears': 'zumbido en los oídos',
      'Rocuronium': 'Rocuronio',
      'Roommate': 'Compañero de habitación',
      'Ropivacaine': 'Ropivacaína',
      'Rotate': 'Girar',
      'Rotator cuff repair': 'Reparación del manguito rotador',
      'Same Gender Caregiver': 'Cuidador del mismo sexo',
      'Same as patient': 'Igual que el paciente',
      'Samoan': 'Samoano',
      'Save': 'Salvar',
      'Save and continue': 'Guardar y continuar',
      'Save back photo': 'Guardar foto trasera',
      'Save front photo': 'Guardar foto frontal',
      'Save payment information': 'Guardar información de pago',
      'Save time later by completing your registration now':
        'Ahorre tiempo más adelante completando su registro ahora',
      'Schedule appointment': 'Programar cita',
      'Scopolamine': 'Escopolamina',
      'Search by date': 'Buscar por fecha',
      'Search by name...': 'Buscar por nombre...',
      'Search pharmacies...': 'Buscar farmacias...',
      'Search...': 'Búsqueda...',
      'Searching...': 'Buscando...',
      'Season allergies': 'Alergia estacional',
      'Secondary Insurance': 'Seguro secundario',
      'Securing your payment': 'Asegurando tu pago',
      'Seizure': 'Convulsiones',
      'Seizures': 'Convulsiones',
      'Select a language': 'Selecciona un idioma',
      'Select a new time for your appointment below, or cancel if you can no longer attend.':
        'Seleccione una nueva hora para su cita o cancele si ya no puede asistir.',
      'Select an option': 'Seleccione una opción',
      'Select or add an employer': 'Seleccionar o agregar un empleador',
      'Select the appointment you would like to cancel.':
        'Seleccione la cita que desea cancelar.',
      'Select the location on the {{bodyLocationName}} that you need to review.':
        'Seleccione la ubicación en {{bodyLocationName}} que necesita revisar.',
      'Select which documents you wish to sign.':
        'Seleccione los documentos que desea firmar.',
      "Select who's signing.": 'Seleccione quién está firmando',
      'Self': 'Titular',
      'Self employed': 'Autónomo',
      'Separated': 'Separado/a',
      'September': 'Septiembre',
      'Seventh Day Adventists': 'Adventistas del Séptimo Día',
      'Several times per day': 'Varias veces al día',
      'Severe': 'Severa',
      'Severity': 'Severidad',
      'Sex': 'Sexo',
      'Sex is missing': 'Falta el Género',
      'Sexually transmitted illness': 'Enfermedad de transmisión sexual',
      'She / her': 'Ella / su',
      'She/Her/Hers': 'Ella',
      'Shellfish': 'Mariscos',
      'Shortness Of Breath': 'Dificultad para respirar',
      'Shortness of breath': 'Dificultad para respirar',
      'Shoulder replacement': 'Reemplazo de hombro',
      'Sibling': 'Hermano(a)',
      'Sibling in law': 'Cuñado(a)',
      'Sibling-in-law': 'Cuñado(a)',
      'Siblings': 'Hermano(a)s',
      'Side of body (Optional)': 'Lado del cuerpo (Opcional)',
      'Sign in': 'Iniciar sesión',
      'Significant Other': 'Pareja',
      'Significant other': 'Pareja',
      'Sikhs': 'Sijs',
      'Simvastatin': 'Simvastatina',
      'Single': 'Soltero/a',
      'Sister': 'Hermana',
      'Six times per week': 'Seis veces por semana',
      'Skilled Nursing Facility': 'Centro de enfermería especializada',
      'Skin cancer': 'Cáncer de piel',
      'Sleep Apnea': 'Apnea obstructiva del sueño',
      'Smoking': 'Fumar',
      'Someone else': 'Otra persona',
      'Something else': 'Algo más',
      'Something went wrong, please select another time slot.':
        'Algo salió mal, seleccione otro intervalo de tiempo.',
      'Something went wrong, please try again later.':
        'Algo ha salido mal, vuelva a probar más tarde.',
      'Something went wrong. Please refresh or contact the practice for support.':
        'Algo salió mal. Actualice o comuníquese con la clinica para obtener ayuda.',
      'Something went wrong. Please try again in few minutes.':
        'Algo salió mal. Vuelva a intentarlo en unos minutos',
      'Son': 'Hijo',
      'Sorry, that time could not be booked. Please try selecting a different day':
        'Lo sentimos, esa hora no se pudo reservar. Intente seleccionar un día diferente',
      'Sort': 'Ordenar',
      'Soy': 'Soja',
      'Spanish': 'Española',
      'Sponsor': 'Patrocinador',
      'Sponsored dependent': 'Dependiente patrocinado',
      'Spouse': 'Esposo/a',
      'Start': 'Iniciar sesión',
      'State': 'Estado',
      'Status': 'Estado',
      'Stepchild': 'Hijastro(a)',
      'Stepfather': 'Padrastro',
      'Stepmother': 'Madrastra',
      'Stepparent': 'Padrastro/Madrastra',
      'Stevens Johnson Syndrome': 'Síndrome de Stevens Johnson',
      'Stevens johnson syndrome': 'Síndrome de Stevens Johnson',
      'Stevens-Johnson Syndrome': 'Síndrome de Stevens-Johnson',
      'Stimulants': 'Estimulantes',
      'Straight or heterosexual': 'Hetero o heterosexual',
      'Stroke': 'Infarto cerebral',
      'Student': 'Estudiante',
      'Student full time': 'Estudiante a tiempo completo',
      'Student part time': 'Estudiante a tiempo parcial',
      'Submit Signature': 'Enviar firma',
      'Submit signature': 'Enviar firma',
      'Subscriber or Member ID': 'ID de suscriptor o miembro',
      'Substance abuse': 'Abuso de sustancias',
      'Succinylcholine': 'Succinilcolina',
      'Suicide': 'Suicidio',
      'Suicide risk': 'Riesgo de suicidio',
      'Sulfa Medications': 'medicamentos de sulfa',
      'Sulfamethoxazole': 'Sulfametoxazol',
      'Swelling': 'Hinchazón',
      'Synthetics': 'Sintéticos',
      'TURP (Transurethral resection of prostate)':
        'Resección transuretral de próstata',
      'Tachycardia': 'Taquicardia',
      'Take a picture of the back of your insurance card & position it in the frame. Make sure all four corners of your card are visible.':
        'Tome una fotografía de la trasera de su tarjeta del seguro y colóquela en el marco. Asegúrese de que las cuatro esquinas de su tarjeta sean visibles.',
      'Take a picture of the front of your insurance card & position it in the frame. Make sure all four corners of your card are visible.':
        'Tome una foto de la parte delantera de su tarjeta de seguro médico y colóquela en el marco. Asegúrese de que las cuatro esquinas de su tarjeta sean visibles.',
      'Taking as prescribed': 'Tomando según lo prescrito',
      'Taking as directed': 'Tomando según las indicaciones',
      'Taking but not as directed': 'Tomando pero no según las indicaciones',
      'Taking but not as prescribed': 'Tomando, pero no según lo prescrito',
      'Tap the checkmark next to each document to sign it. Click the name of the document to view it.':
        'Active la marca de verificación junto a cada documento para firmarlo. Haga clic en el nombre del documento para verlo.',
      'Tell us about your current allergies.':
        'Cuéntenos cuáles son sus alergias actuales.',
      'Tell us what you loved! (optional)':
        '¡Cuéntanos lo que te encantó! (Opcional)',
      'Terms of Use': 'Condiciones de Uso',
      'Tertiary Insurance': 'Seguro terciario',
      'Tetracycline': 'Tetraciclina',
      'Thank you for your response. No further action is needed.':
        'Gracias por su respuesta. No se necesitan más acciones.',
      'Thank you for your response. No further action is needed. We look forward to your appointment.':
        'Gracias por su respuesta. No se necesita ninguna otra acción. Esperamos su cita.',
      'Thank you.': 'Gracias.',
      "Thanks, please continue to your provider's office, and complete the forms texted to you.":
        'Gracias, diríjase a la oficina de su proveedor y complete los formularios que se le enviaron por mensaje de texto.',
      'Thanks. We could not send to that number, but please continue to your appointment to be seen.':
        'Gracias. No pudimos enviar a ese número, pero por favor continúe a su cita para que lo atiendan.',
      'The appointment could not be scheduled, please select another date or time.':
        'La cita no se pudo programar, seleccione otra fecha u hora',
      'The patient is their...': 'La paciente es su...',
      'There are no future appointments available for this week.':
        'No hay citas futuras disponibles para esta semana.',
      'There was an error logging in.': 'Hubo un error al iniciar sesión.',
      "There was an error processing your rescheduling request.'":
        'Hubo un error al procesar su solicitud de reprogramación.',
      'There was an error. Please try again.':
        'Hubo un error. Inténtalo de nuevo.',
      'They / their': 'Ellos / sus',
      'This application requires your browser to have cookies enabled. Change your privacy settings and refresh the page to login.':
        'Esta aplicación requiere que su navegador tenga habilitadas las cookies. Cambie su configuración de privacidad y actualice la página para iniciar sesión.',
      'This appointment is still scheduled. To finish cancelling or rescheduling, please call <link />.':
        'Esta cita aún está programada. Para terminar de cancelarla o reprogramarla, debe llamar al <link />.',
      'This card is not supported. Please try a different card.':
        'Esta tarjeta no es compatible. Intente con una tarjeta diferente.',
      'This link has expired. If your appointment has not already passed, please check your messages for a newer link.':
        'Este enlace ha caducado. Si su cita aún no ha pasado, revise sus mensajes para obtener un enlace más nuevo.',
      'This link is no longer valid. If your appointment has not already passed, please check your messages for a newer link.':
        'Este enlace ya no es válido. Si su cita aún no ha pasado, verifique sus mensajes para obtener un enlace más nuevo',
      "This person is the patient's...":
        'Relación de esta persona con el paciente:',
      'This type of appointment does not allow online rescheduling. Click the button above to cancel your appointment.':
        'Este tipo de cita no se puede reprogramar en línea. Haga clic en el botón superior para cancelar su cita.',
      'This type of appointment does not allow online rescheduling. Give us a call at <link /> to reschedule, or click the button above to cancel your appointment.':
        'Este tipo de cita no permite la reprogramación en línea. Llámenos al <link /> para reprogramarla o haga clic en el acima botón para cancelar su cita.',
      'Three times per week': 'tres veces por semana',
      'Thrombosis': 'Trombosis',
      'Thyroid disorder': 'Trastorno tiroideo',
      'Thyroidectomy': 'Tiroidectomía',
      'Time': 'Tiempo',
      'Times': 'Tiempos',
      'Tinnitus': 'Tinnitus',
      'Tmrw,': 'Mañana,',
      'To': 'A',
      'To make a change please let us know when you check in for your appointment.':
        'Para hacer un cambio, avísenos cuando se registre para su cita.',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        'Para reprogramar una cita, llame al número proporcionado anteriormente con su cita.',
      'resubscribePrompt':
        'Para volver a suscribirte, haz clic en el botón de abajo:',
      'Tobramycin': 'Tobramicina',
      'Today': 'Hoy',
      'Today,': 'Hoy dia,',
      'Tomorrow': 'Mañana',
      'Tonsillectomy': 'Amigdalectomía',
      'Toradol': 'Toradol',
      'Total due': 'Total vencida',
      'Tramadol': 'Tramadol',
      'Transgender (Female to male)': 'Transgénero (de mujer a hombre)',
      'Transgender (Male to female)': 'Transgénero (hombre a mujer)',
      'Trimethoprim': 'Trimetoprima',
      'Tubal ligation': 'Ligadura de trompas',
      'Tuberculosis': 'Tuberculosis',
      'Two times per week': 'dos veces por semana',
      'Type to search...': 'Escribe para buscar...',
      'Type your full name on the line below to sign these documents.':
        'Escriba su nombre completo en la línea de abajo para firmar estos documentos.',
      'Unable to obtain': 'Incapaz de obtener',
      'Unavailable': 'No disponible',
      'Uncle': 'Tío',
      'Unknown': 'Desconocido',
      'Unlocked guns': 'Armas desbloqueadas',
      'Unmarried': 'Soltero(a)',
      'Unverified proxy': 'Sin verificar',
      'Updated': 'Actualizado a las',
      'Upload': 'Subir',
      'Upload photos of your additional health insurance card. Additional cards may be uploaded after.':
        'Sube fotos de tu tarjeta de seguro médico adicionales. Se pueden subir tarjetas adicionales después.',
      'Upload photos of your primary health insurance card. Additional cards may be uploaded after.':
        'Sube fotos de su tarjeta de seguro médico primario. Se pueden subir tarjetas adicionales después.',
      'Urinary tract infections': 'Infección del tracto urinario',
      'Use a different payment method': 'Usar un método de pago diferente',
      'Use a different phone number': 'Usar un número de teléfono diferente',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'El uso de esta herramienta es únicamente para comunicaciones no urgentes y es posible que su proveedor no revise las respuestas. Si necesita una respuesta inmediata, llame directamente al consultorio de su proveedor. En caso de una emergencia médica, llame al 911 o acuda inmediatamente a la sala de urgencias más cercana.',
      'Used early in pregnancy': 'Utilizado al principio del embarazo',
      'Valsartan': 'Valsartán',
      'Vancomycin': 'Vancomicina',
      'Vecuronium': 'Vecuronio',
      'Verification code': 'Código de verificación',
      'Vertigo': 'Vértigo',
      'Vietnamese': 'Vietnamita',
      'View more availability': 'Ver más disponibilidad',
      'Virtual Visit': 'Visita virtual',
      'Vomiting': 'Vómitos',
      'WORK': 'Trabajar',
      'WORKPHONE': 'Teléfono del Trabajo',
      'Ward': 'Tutela',
      'Was this experience easy to use?':
        '¿Fue esta experiencia fácil de usar?',
      'Was this helpful?': '¿Le resultó útil?',
      'Was your last mammogram performed within our provider network?':
        '¿Se realizó su última mamografía dentro de nuestra red de proveedores?',
      'We are unable to register you at the moment, please see the front desk.':
        'No podemos registrarlo en este momento, consulte la recepción.',
      'We no longer have any available vaccine slots, but you have been added to our waitlist. We will be contacting you to schedule once there are more availabilities.':
        'Ya no hay cupo disponible para vacunas, mientras tanto, hemos incluido su nombre en la lista de espera. Nos comunicaremos con usted una vez haya disponibilidad.',
      'We were unable to process your payment due to issues confirming your billing details.\n\nPlease contact the front desk for assistance.':
        'No pudimos procesar su pago debido a problemas para confirmar sus detalles de facturación.\n\nPóngase en contacto con la recepción para obtener ayuda.',
      'unableToResubscribe': 'No pudimos reinscribir su correo electrónico.',
      'unableToProcessRequest':
        'No pudimos procesar automáticamente su solicitud.',
      'Weeks': 'Semanas',
      'What are your preferred pronouns?':
        '¿Cuáles son sus pronombres preferidos?',
      'What is your gender identity?': '¿Cuál es su identidad de género?',
      'What is your sexual orientation?': '¿Cuál es su orientación sexual?',
      'What made the experience challenging?':
        '¿Qué hizo que la experiencia fuera desafiante?',
      'What made the experience easy to use?':
        '¿Qué hizo que la experiencia fuera fácil de usar?',
      'What was your assigned sex at birth?':
        '¿Qué sexo se le asignó al nacer?',
      'Wheat': 'Trigo',
      'Wheezing': 'Sibilancias',
      'When was your last mammogram performed? (optional)':
        '¿Cuándo se realizó su última mamografía? (opcional)',
      'When was your surgery': 'cuando fue tu operacion',
      'When you drink alcohol, how many drinks do you typically consume?':
        'Cuando bebes alcohol, ¿cuántas bebidas consumes normalmente?',
      'When you used to drink alcohol, how many drinks per day did you typically consume?':
        'Cuando tomaba alcohol, ¿cuántas bebidas por día solía consumir?',
      'When you used to use these drugs, how often did you typically use them?':
        'Cuando consumía estas drogas, ¿con qué frecuencia lo hacía?',
      'Where do I find this?': '¿Dónde lo encuentro?',
      'Where was your last mammogram performed? (optional)':
        '¿Dónde se realizó su última mamografía? (opcional)',
      'Which drugs did you use?': '¿Qué drogas consumía?',
      'Which drugs do you use?': '¿Qué drogas consume?',
      'Which environmental risks apply to you? Select all that apply.':
        '¿Qué riesgos ambientales se aplican a su caso? Seleccione todos los que correspondan.',
      'Which family members have had':
        '¿Qué miembros de la familia han sufrido',
      'Which of the following treatments for tobacco use have you previously completed?':
        '¿Cuál de los siguientes tratamientos para el tabaquismo ha completado anteriormente?',
      'Which substances did you use? Select all that apply.':
        '¿Qué sustancias usó? Seleccione todas las que correspondan.',
      'Which substances do you use? Select all that apply.':
        '¿Qué sustancias consume? Seleccione todas las que correspondan.',
      'White': 'Blanco',
      'White or Caucasian': 'Blanco o caucásico',
      'Who do you live with?': '¿Con quién vive?',
      'Who do you live with? Select all that apply.':
        '¿Con quién vive?  Seleccione todos los que correspondan.',
      'Who is the subscriber?': '¿Quién es el suscriptor?',
      'Who should we contact in an emergency?':
        '¿A quién debemos contactar en caso de emergencia?',
      'Why are you asking me this?': '¿Por qué me estás preguntando esto?',
      'Wife': 'Esposa',
      'Widowed': 'Viudo/a',
      "Will you be using insurance to pay for today's visit?":
        '¿Va a utilizar su seguro médico para pagar la visita de hoy?',
      'Within {{time}}': 'En {{time}}',
      'Woodland Behavioral Health New Patient Forms':
        'Formularios para pacientes nuevos de Woodland Behavioral Health',
      'Year': 'Año',
      'Years': 'Años',
      'Yes': 'Sí',
      'Yes, add another': 'Sí, agregar otro',
      'You have a co-pay and prepayment due. Select the items you are able to pay.':
        'Tiene que pagar un copago y un prepago. Seleccione los artículos que puede pagar.',
      'You have a co-pay and prior balance due. Select the items you are able to pay.':
        'Tiene un copago y un saldo anterior adeudado. Seleccione los artículos que puede pagar.',
      'You have a co-pay, prepayment and prior balance due. Select the items you are able to pay.':
        'Tiene un copago, prepago y saldo anterior adeudado. Seleccione los artículos que puede pagar.',
      'unsubscribedMessage':
        'Ha sido dado de baja de las actualizaciones por correo electrónico de Notable Healthcare en esta dirección de correo electrónico.',
      'You have a prepayment and prior balance due. Select the items you are able to pay.':
        'Tiene un prepago y un saldo anterior adeudado. Seleccione los artículos que puede pagar.',
      'You submitted this': 'Enviaste esto',
      'Your appointment is confirmed.': 'Su cita está confirmada',
      'Your call back is confirmed. We will give you a call as soon as possible.':
        'Su devolución de llamada está confirmada. Le llamaremos lo antes posible.',
      'Your full name': 'Su nombre completo',
      'Your payment details have already been submitted.':
        'Sus detalles de pago ya han sido enviados.',
      'Your payment for this visit has been canceled.\n\nPlease contact the front desk for assistance.':
        'Su pago por esta visita ha sido cancelado.\n\nPóngase en contacto con la recepción para obtener ayuda.',
      'Zip': 'Código Postal',
      'Zip Code': 'Código Postal',
      'Zip code': 'Código postal',
      'Zoom': 'Ampliar',
      'add': 'Agregue',
      'addInput': 'Agregue {{input}}',
      'and understand my options.': 'y entiendo mis opciones.',
      'avoidUsingPatientsPhoneNumber':
        'Evite usar el número de teléfono del paciente',
      'back of the body': 'parte posterior del cuerpo',
      'cancelAppointment': 'Cancelar cita',
      'cancelAppointment_plural': 'Cancelar citas',
      'characterLimitExceeded':
        "Se superó el límite de caracteres de {{characterLimit}} para la pregunta '{{label}}'",
      'characters': 'caracteres',
      'close': 'cerrar',
      'co-pay': 'copago',
      'dateOfBirth': 'Fecha de Nacimiento',
      'days': 'días',
      'directions': 'Direcciones',
      'email': 'Correo electrónico',
      'emailAddress': 'Dirección de Correo Electrónico',
      'employersPhoneNumber': 'No. de teléfono del empleador',
      'enterAddress': 'Ingrese su dirección',
      'enterMobilePhoneNumberAssociatedWithRecords':
        'Introduce el número de teléfono móvil asociado a tus registros',
      'errorMessage': 'Falta el/la {{input}}',
      'errorOccuredRetryImage':
        'Ocurrió un error. Vuelva a intentarlo con una imagen.',
      'errorOccurredTryAgain': 'Ocurrió un error. Inténtalo de nuevo.',
      'failedUploadInternetError':
        'No se pudo cargar, verifique su conexión a Internet y vuelva a intentarlo.',
      'firstName': 'Primer nombre',
      'front of the body': 'frente del cuerpo',
      'grossHouseholdIncome': 'Ingreso bruto del hogar',
      'hours': 'horas',
      'instructions': 'Instrucciones',
      'invalidAddress': 'Dirección inválida',
      'invalidAmountAndYearsOfUsage':
        "Los valores de la pregunta '{{label}}' deben especificar la cantidad y los años de uso",
      'invalidAnswerForQuestion':
        "La respuesta no es válida para la pregunta '{{label}}'",
      'invalidDate': "La fecha de la pregunta '{{label}}' no es válida",
      'invalidEmail':
        "El valor de la pregunta '{{label}}' debe ser un correo electrónico válido",
      'invalidGrossIncomePeriod':
        'Seleccione un período de tiempo para su ingreso familiar bruto',
      'invalidGrossIncomeValue': 'Por favor complete su ingreso familiar bruto',
      'invalidInputError': "{{type}} inválido en el campo '{{label}}'",
      'invalidIntervalValue':
        "El valor de la pregunta '{{label}}' debe ser divisible por {{intervalValue}}",
      'invalidMaxValue':
        "El valor de la pregunta '{{label}}' debe ser menor o igual que {{maxValue}}",
      'invalidMinValue':
        "El valor de la pregunta '{{label}}' debe ser mayor o igual que {{minValue}}",
      'invalidNumericValue':
        "El valor de la pregunta '{{label}}' debe ser un número",
      'invalidPhoneNumber':
        "Debe ser un número de teléfono válido para la pregunta '{{label}}'",
      'invalidZipcode': 'Código postal no válido',
      'isRequiredValue': "'{{label}}' se requiere",
      'lastName': 'Apellido',
      'loading': 'cargando',
      'minutes': 'minutos',
      'missingEmergencyContact':
        'Falta alguna información de contacto de emergencia para "{{label}}"',
      'mobilePhoneNumber': 'Número de teléfono móvil',
      'moreInformation': 'Más información',
      'no appointment': 'sin cita',
      'number': 'número',
      'on': 'el',
      'patientRelationshipToContact': 'Parentesco del paciente con el contacto',
      'phoneNumber': 'No. de teléfono',
      'placeholderAddress': '123 Calle Principal, San Francisco, CA, USA',
      'placeholderEmail': 'usted@correo.com',
      'pleaseAddPrimaryPhoneNumberForCallBack':
        'Agregue el número de teléfono principal donde le gustaría recibir su llamada.',
      'Please Ask': 'Por favor pregunte',
      'pleaseCompleteQuestion': "Por favor complete la pregunta '{{label}}'",
      'pleaseConfirmAppointment': 'Por favor confirme la siguiente cita:',
      'pleaseConfirmAppointment_plural':
        'Por favor confirme las siguientes citas:',
      'pleaseEnterGuarantorName': 'Por favor ingrese el nombre de su garante',
      'pleaseSelectAGuarantor': 'Por favor seleccione un garante',
      'pleaseSelectGuarantorRelationship': 'Seleccione la relación del garante',
      'pleaseValidateGuarantorAddress':
        'Por favor valide la dirección del garante',
      'prepayment': 'pago por adelantado',
      'prior balance': 'saldo anterior',
      'readMore': 'Leer más',
      'relationshipMainLabel':
        "¿Cómo está relacionado '{{entity1}}' con '{{entity2}}'?",
      'relationshipSubLabel': '{{entity}} es su...',
      'religionContextualHelp':
        'Reunir su afiliación religiosa nos permite brindarle la atención más personalizada posible. La religión y la espiritualidad pueden influir en las decisiones relacionadas con la dieta, los medicamentos basados ​​en productos animales, la modestia, el género preferido de sus proveedores de salud y mucho más. Algunas religiones tienen tiempos de oración estrictos que pueden interferir con el tratamiento médico, por lo que conocer su religión nos permite ser lo más respetuosos posible.',
      'review': 'revisa',
      'reviewContactName':
        'Revisar la dirección de {{contactName}} en el archivo y actualizar si ha cambiado.',
      'reviewYourVisitForms':
        'Revise sus formularios de visita ahora para completar su registro de visita y prepararse para su cita',
      'reviewYourVisitForms_plural':
        'Revise sus formularios de visita ahora para completar su registro de visita y prepararse para sus citas',
      'sex': 'Género',
      'sign in to continue.': 'inicie sesión para continuar',
      'someGuarantorInfoIsMissing': 'Falta alguna información del garante',
      'thankYouWeLookForward':
        'Gracias por su respuesta. Lo estaremos esperando para su próxima cita.',
      'thankYouWeLookForward_plural':
        'Gracias por su respuesta. Lo estaremos esperando para sus próximas citas.',
      'the patient': 'el paciente',
      'thePersonPayingForThisVisit': 'la persona que paga esta visita',
      'to {{to}}': 'para {{to}}',
      'today at': 'hoy a las',
      'valuesAreAllRequired':
        "Los valores para la pregunta '{{label}}' son obligatorios",
      'visit fee': 'tarifa de visita',
      'visitType': '{{type}} de visita',
      'whoIsResponsibleForPayingThisVisit':
        '¿Quién es responsable de pagar esta visita?',
      'yesConfirm': 'Sí, confirmar',
      'yesConfirm_plural': 'Sí, confirmar todo',
      'yesterday at': 'ayer a las',
      '{{friendlyName}} has requested you return for a follow-up visit {{followUpValueWithUnit}}.':
        '{{friendlyName}} le ha solicitado que regrese para una visita de seguimiento {{followUpValueWithUnit}}.',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'Responda las siguientes preguntas para ayudar a Notable Testing a prepararse para su próxima visita.',
      'Patient Registration': 'Registro de pacientes',
      'Payments & Insurance': 'Pagos y seguros',
      'Email Address (if you do not have an email, enter NA@test.com)':
        'Dirección de correo electrónico (si no tiene un correo electrónico, ingrese NA@test.com)',
      'Cell Phone Number': 'Número de teléfono celular',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        'Número de teléfono particular (déjelo en blanco si no tiene número de teléfono particular)',
      'What race do you most identify with?':
        '¿Con qué raza se identifica más?',
      'American Indian': 'Indio americano',
      'other': 'otra',
      'What is your ethnicity?': '¿Cuál es su etnia?',
      'Hispanic, Latino, or Spanish Origin':
        'De origen hispano, latino o español',
      'Not Hispanic, Latino, or Spanish Origin':
        'No es de origen hispano, latino o español',
      'What is your preferred Language': '¿Cuál es su idioma preferido?',
      'Please list your emergency contact and their relationship to the patient':
        'Indique su contacto de emergencia y su relación con el paciente.',
      'First Name': 'Nombre',
      'Last Name': 'Apellido',
      'Phone Number': 'Número de teléfono',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '“Indique su contacto de emergencia y su relación con el paciente” es obligatorio',
      'Do you need an interpreter for a spoken language or ASL?':
        '¿Necesita un intérprete de un idioma hablado o Lengua de señas estadounidense (American Sign Language, ASL)?',
      'Are you an MIT student?':
        '¿Es estudiante del Instituto de Tecnología de Massachusetts (Massachusetts Institute of Technology, MIT)?',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        '¿Esta cita está relacionada con un accidente, una lesión laboral o una visita al Departamento de Transporte (Department of Transportation, DOT), o tiene autorización para recibir atención aquí como parte de su trabajo?',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        'Para asegurarse de que nuestra información de facturación sea correcta, verifique su cobertura para esta visita en la recepción cuando llegue.',
      'Remove': 'Eliminar',
      'Confirm Insurance': 'Confirmar seguro',
      'Add another Insurance': 'Agregar otro seguro',
      "Don't Use Insurance": 'No utilizo seguro',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        'Sin agregar un seguro, usted puede ser totalmente responsable de pagar su factura médica de su bolsillo.',
      'Go back': 'Volver atrás',
      'Please upload images of the front and back of your insurance card.':
        'Cargue imágenes del frente y reverso de su tarjeta de seguro.',
      'Add the front of your card': 'Agregue el frente de su tarjeta',
      'Add the back of your card': 'Agregue el reverso de su tarjeta',
      'Capture': 'Tomar foto',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        'No se puede leer la información de su tarjeta. Agregue la información que falta a continuación para seguir agregando cobertura de seguro.',
      'Insurance provider': 'Proveedor de seguro',
      "Don't add this card": 'No agregar esta tarjeta',
      'Member ID': 'Identificación de miembro',
      'Group number': 'Número de grupo',
      'Coverage start date': 'Fecha de inicio de cobertura',
      'Fill this out now to save time at your next appointment':
        'Complete esto ahora para ahorrar tiempo en su próxima cita',
      'Please select or add the policyholder for this new card.':
        'Seleccione o agregue el titular de la póliza para esta nueva tarjeta.',
      'Who is the insurance policyholder?':
        '¿Quién es el tomador de la póliza de seguro?',
      'Who is my subscriber?': '¿Quién es mi suscriptor?',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        'El suscriptor es la persona que paga las primas del seguro médico o cuyo empleo es la base para ser miembro del plan de seguro.',
      'Birth date': 'Fecha de nacimiento',
      'Mailing address': 'Dirección postal',
      'same as patient': 'la misma que la del paciente',
      'use different address': 'utilizar otra dirección',
      'Mobile phone number (optional)': 'Número de teléfono móvil (opcional)',
      'How is the patient related to the person who owns the insurance policy?':
        '¿Cuál es el parentesco del paciente con la persona titular de la póliza de seguro?',
      'Review & pay your co-pay': 'Revise y pague su copago',
      'Prior Balance': 'Saldo anterior',
      'Total': 'Total',
      'Continue to Payment': 'Continuar con el pago',
      'Pay Later': 'Pagar más tarde',
      'use a different payment method': 'utilizar un método de pago diferente',
      'pay total due': 'pagar el total adeudado',
      "I''ll pay later": 'Pagaré más tarde',
      'Review and edit any personal information that has changed':
        'Revisar y editar cualquier información personal que haya cambiado',
      'Personal Information': 'Datos personales',
      'Demographics': 'Datos demográficos',
      'Insurance Cards': 'Tarjetas de seguro',
      'Primary Care Providers': 'Proveedores de atención primaria',
      'Confirm your upcoming appointment': 'Confirme su próxima cita',
      'Emergency Contact': 'Contacto de emergencia',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        'Para cancelar una cita dentro de los 60 minutos anteriores, deberá llamar a la clínica mencionada.',
      'Cancel appointment': 'Cancelar cita',
      'Patient Last name': 'Apellido del paciente',
      'Please confirm the following appointments:':
        'Confirme las siguientes citas:',
      'Yes, confirm all': 'Sí, confirmar todas',
      'Thank you for your response. We look forward to your upcoming appointments.':
        'Gracias por su respuesta. Esperamos sus próximas citas.',
      'Confirmed': 'Confirmada',
    },
  },
  ru: {
    photoId: {
      title:
        'Загрузите фотографии водительского удостоверения или документа, удостоверяющего личность пользователя.',
    },
    translation: {
      'dataIsSecure':
        'Все данные передаются в защищенном виде с использованием банковского шифрования и методов, соответствующих требованиям HIPAA.',
      'Answer the following questions to help':
        'Ответьте на следующие вопросы, чтобы',
      'prepare for your upcoming visit.':
        'подготовиться к предстоящему визиту.',
      'Patient Registration': 'Регистрация пациентов',
      'Patient Insurance': 'Страхование пациентов',
      'Social History': 'Социальная история',
      'Clinical Intake': 'Поступление в клинику',
      'Patient Consent - Language': 'Согласие пациента - язык',
      'Social Determinants of Health': 'Социальные определители здоровья',
      'Start': 'Начать',
      "Patient's Mobile Phone Number": 'Номер мобильного телефона пациента',
      "Patient's Home Phone Number (if applicable)":
        'Номер домашнего телефона пациента (по желанию)',
      "Patient's email address": 'Адрес электронной почты пациента',
      "Patient's Home Address": 'Домашний адрес пациента',
      'What race does the patient identify with?':
        'К какой расе относится пациент?',
      'Black or African American': 'Чернокожая или афроамериканская',
      'American Indian or Alaska Native':
        'Американский индеец или коренной житель Аляски',
      'Asian': 'Азиатская',
      'Asian Indian': 'Азиатско-индийская',
      'White': 'Белая',
      'Native Hawaiian or Pacific Islander':
        'Коренные гавайцы или жители тихоокеанских островов',
      'Other': 'Другое',
      "What is the patient's ethnicity?":
        'Какая этническая принадлежность у пациента?',
      'Hispanic, Latino or Spanish Origin':
        'Латиноамериканское, латинское или испанское происхождение',
      'Not Hispanic, Latino or Spanish Origin':
        'Не латиноамериканского, латинского или испанского происхождения',
      'Do not wish to provide': 'Предпочитаю не указывать',
      "Patient's Martial Status": 'Семейное положение пациента',
      'Divorced': 'Разведен',
      'Married': 'В браке',
      'Partnered': 'Партнерство',
      'Separated': 'Разделенные',
      'Single': 'Не в браке',
      'Widowed': 'Вдовец/Вдова',
      'is required': 'обязательно',
      'Invalid number in the field': 'Недопустимый номер в поле',
      'Enter your address': 'Введите свой адрес',
      'Address Line 1': 'Адрес, строка 1',
      'Address Line 2': 'Адрес, строка 2',
      'City': 'Город',
      'State': 'Штат',
      'Zip Code': 'Почтовый индекс',
      'Save': 'Сохранить',
      'Continue': 'Продолжить',
      'Are you currently employed?': 'Работаете ли Вы в настоящее время?',
      'Yes': 'Да',
      'No': 'Нет',
      'What language would you like to sign the consent forms in?':
        'На каком языке Вы хотели бы подписать формы согласия?',
      'English': 'Английский',
      'Spanish': 'Испанский',
      'Haitian Creole': 'Гаитянский креольский',
      'Arabic': 'Арабский',
      'Russian': 'Русский',
      'Employer name': 'Имя работодателя',
      'Select or add an employer': 'Выберите или добавьте работодателя',
      "Employer's phone number": 'Номер телефона работодателя',
      "Will you be using insurance to pay for today's visit?":
        'Будете ли Вы использовать страховку для оплаты сегодняшнего визита?',
      'Is this still your primary insurance?':
        'Это все еще ваша основная страховка?',
      'Upload photos of your primary health insurance card.':
        'Загрузите фотографии вашей основной медицинской страховой карты.',
      'Additional cards may be uploaded after.':
        'Дополнительные карты можно будет загрузить позже.',
      'Front of Insurance Card': 'Лицевая сторона страховой карты',
      'Back of Insurance Card': 'Обратная сторона страховой карты',
      "I don't have my card": 'У меня нет моей карты',
      'No, my insurance has changed': 'Нет, моя страховка изменилась',
      "No, I'm paying out of pocket": 'Нет, я плачу из своего кармана',
      "Front of Driver's License":
        'Лицевая сторона водительского удостоверения',
      "Back of Driver's License":
        'Обратная сторона водительского удостоверения',
      'Front of card': 'Лицевая сторона карты',
      'Take a picture of the front of your insurance card & position it in the frame. Make sure all four corners of your card are visible.':
        'Сфотографируйте лицевую сторону страховой карты и поместите ее в поле. Убедитесь, что видны все четыре угла карточки.',
      'Zoom': 'Увеличить',
      'Rotate': 'Повернуть',
      'Back of card': 'Обратная сторона карты',
      'Save front photo': 'Сохранить переднюю фотографию',
      'Save back photo': 'Сохранить обратную фотографию',
      'Upload': 'Загрузить',
      'Clear images': 'Убрать изображения',
      'Do you have additional insurance you would like to add?':
        'Есть ли у Вас дополнительное страхование, которое Вы хотели бы добавить?',
      'Insurance #1': 'Страховка №1',
      'Edit': 'Изменить',
      'Yes, add another': 'Да, добавить еще',
      'No, continue': 'Нет, продолжить',
      'Upload photos of your additional health insurance card.':
        'Загрузите фотографии вашей дополнительной медицинской страховой карты.',
      'Go back to insurance list': 'Вернуться к списку страховок',
      'Emergency Contact': 'Контактное лицо в случае чрезвычайной ситуации',
      'First Name': 'Имя',
      'Last Name': 'Фамилия',
      'Relationship': 'Отношения',
      'Select an option': 'Выберите вариант',
      'Spouse': 'Супруг/супруга',
      'Parent': 'Родитель',
      'Child': 'Ребенок',
      'Sibling': 'Брат/сестра',
      'Friend': 'Друг',
      'Cousin': 'Кузен',
      'Guardian': 'Опекун',
      'Phone Number': 'Мобильный номер телефона',
      "Avoid using the patient's phone number":
        'Избегайте использования номера телефона пациента',
      "Please list the patient's primary care provider.":
        'Укажите основного лечащего врача пациента.',
      "Please use the provider's first and last name when searching.":
        'Пожалуйста, используйте при поиске имя и фамилию врача.',
      'Enter the name...': 'Введите имя...',
      "Care Provider's First Name": 'Имя врача',
      "Care Provider's Last Name": 'Фамилия врача',
      'Cancel': 'Отменить',
      'Some emergency contact information is missing for':
        'Некоторая информация о контакте в случае чрезвычайной ситуации отсутствует',
      'Loading': 'Загрузка',
      'What is the highest grade or level of school you have completed or the highest degree you have received?':
        'Какой последний класс или школьный уровень Вы закончили или какое наивысшее образование Вы получили?',
      'Never attended': 'Никогда не посещал/a',
      '1st grade': '1-й класс',
      '2nd grade': '2-й класс',
      '3rd grade': '3-й класс',
      '4th grade': '4-й класс',
      '5th grade': '5-й класс',
      '6th grade': '6-й класс',
      '7th grade': '7-й класс',
      '8th grade': '8-й класс',
      '9th grade': '9-й класс',
      '10th grade': '10-й класс',
      '11th grade': '11-й класс',
      '12th grade, no diploma': '12-класс, без аттестата',
      'GED or equivalent': 'Общеобразовательное развитие или эквивалент этому',
      'high school graduate': 'выпускник старшей школы',
      'some college, no degree':
        'Частичное высшее образование, но без получения степени.',
      'Associate degree: occupational, technical, or vocational program':
        'Ассоциированная степень: по профессии, техническая или профессиональная программа',
      'Associate degree: academic program':
        'Ассоциированная степень: академическая программа.',
      "Bachelor's degree (e.g. BA, AB, BS)":
        'Степень бакалавра (например, бакалавр искусств, бакалавр наук)',
      "Master's degree (e.g. MA, MS, MEng, MEd, MSW, MBA)":
        'Степень магистра (например, магистр искусств, магистр наук, магистр техники, магистр образования, магистр социальной работы, магистр делового администрирования)',
      'Professional school degree (e.g. MD, DDS, DVM, JD)':
        'Степень специалиста (например, доктор медицины, доктор стоматологии, доктор ветеринарии, доктор юриспруденции)',
      'Doctoral degree (e.g. PhD, EdD)':
        'Докторская степень (например, доктор философии, доктор образования)',
      "I don't know": 'Я не знаю',
      'Choose not to disclose': 'Предпочитаю не указывать.',
      'What is your occupation?': 'Какова Ваша профессия?',
      'Are you able to care for yourself?':
        'Способны ли Вы позаботиться о себе?',
      'Are you blind or do you have difficulty seeing?':
        'Вы слепы или плохо видите?',
      'Are you deaf or do you have serious difficulty hearing?':
        'Вы глухой или имеете серьезные проблемы со слухом?',
      'Do you have difficulty concentrating, remembering or making decisions?':
        'Испытываете ли Вы трудности с концентрацией внимания, запоминанием или принятием решений?',
      'Do you have difficulty walking or climbing stairs?':
        'Испытываете ли Вы трудности при ходьбе или подъеме по лестнице?',
      'Do you have difficulty dressing or bathing?':
        'Есть ли у Вас трудности с одеванием или купанием?',
      'Do you have difficulty doing errands alone?':
        'У вас есть трудности самостоятельно заниматься делами?',
      'Are you able to walk?': 'Вы можете ходить?',
      'Yes: walks without restrictions': 'Да: хожу без ограничений',
      'Yes: walks with assistive device(s)':
        'Да: хожу с помощью вспомогательного устройства (устройств)',
      'Yes: limited self ability with assistive device(s); generall relies on wheeled mobility':
        'Да, есть ограниченные способности для самостоятельного передвижения с использованием вспомогательных устройств; в целом полагаюсь на передвижение на колесах.',
      'No: confined to chair': 'Нет: прикован к креслу',
      'No: independent in wheelchair': 'Нет, независим в инвалидной коляске.',
      'No: requires minimal help in wheelchair':
        'Нет: требуется минимальная помощь при передвижении в инвалидном кресле',
      'No: dependent on helper pushing wheelchair':
        'Нет: зависит от помощника, толкающего инвалидную коляску',
      'No: unable to walk': 'Нет: не в состоянии ходить',
      'No: unable to initiate walking': 'Нет: неспособен начать ходить',
      'No: bed-ridden': 'Нет: прикован к постели',
      'Do you have transportation difficulties?':
        'Есть ли у Вас трудности с транспортировкой?',
      'Have you been to an area known to be high risk for COVID-19?':
        'Приходилось ли Вам бывать в районах с высоким риском заражения COVID-19?',
      'In the last two weeks, have you been in close contact with someone with a confirmed COVID-19 case while the person was ill?':
        'Находились ли Вы в течение последних двух недель в тесном контакте с человеком, у которого был подтвержден случай заболевания COVID-19, когда этот человек был болен?',
      'In the last two weeks, have you been in close contact with someone with a suspected COVID-19 case while the person was ill?':
        'Находились ли Вы в течение последних двух недель в тесном контакте с человеком, подозреваемым в заболевании COVID-19, когда этот человек был болен?',
      'Do you reside in or have you traveled to an area where Ebola virus transmission is active?':
        'Проживаете ли Вы в регионе, где активно распространяется вирус Эбола, или совершали ли Вы поездки в эти регионы?',
      'Have you processed blood or body fluids from an Ebola virus disease patient without appropriate PPE?':
        'Проводили ли вы обработку крови или биологических жидкостей пациента с заболеванием, вызванным вирусом Эбола, без применения соответствующих СИЗ?',
      'Have there been any changes to your family or social situation?':
        'Произошли ли какие-либо изменения в Вашей семье или социальном положении?',
      'What type of child care do you use?':
        'Каким видом услуг по уходу за детьми Вы пользуетесь?',
      'None or no Children': 'Никаким или нет детей',
      'Relative': 'Родственник',
      'Private Sitter': 'Частная няня',
      'Daycare/Preschool': 'Детский сад/ дошкольное учреждение',
      'Do you have any pets?': 'Есть ли у Вас домашние животные?',
      'Do you have smoke and carbon monoxide detectors in your home?':
        'Есть ли у вас в доме детекторы дыма и угарного газа?',
      'Are you passively exposed to smoke?':
        'Подвергаетесь ли Вы пассивному воздействию дыма?',
      'Are there any guns present in your home?':
        'Имеется ли в Вашем доме оружие?',
      'What is the fluoride status of your home?':
        'Каков статус фторида в воде в вашем доме?',
      'Fluoridated': 'Фторированная.',
      'Unknown': 'Неизвестно.',
      'Non-fluoridated': 'Нефторированная.',
      'Do you use insect repellent routinely?':
        'Используете ли Вы регулярно средства защиты от насекомых?',
      'Do you use sunscreen routinely?':
        'Пользуетесь ли Вы регулярно солнцезащитным кремом?',
      'Finish': 'Закончить',
      'Thanks, all done! We are looking forward to seeing you soon.':
        'Спасибо, все готово! Ждем вас в ближайшее время.',
      'Please arrive 15 minutes prior to your appointment time and check in with the front desk.':
        'Пожалуйста, приезжайте за 15 минут до назначенного времени и зарегистрируйтесь на стойке регистрации.',
      'Ocean Bay Community Development provides free transportation services for Youth, Senior Citizens, and Disabled Residents. Call Mr. JONES or Mrs. Jordan to schedule a trip. 24 hours notice required.':
        'Компания Развитие сообщества Оушен Бэй предоставляет бесплатные транспортные услуги для молодежи, пожилых людей и инвалидов. Позвоните мистеру Джоунсу или миссис Джордан, чтобы запланировать поездку. Требуется уведомление за 24 часа.',
      'Call (929) 553-1312 3 PM to 8 PM':
        'Звоните (929) 553-1312 с 15:00 до 20:00',
      'Call (347) 777-7951 8 AM to 3 PM':
        'Звоните (347) 777-7951 с 8 утра до 3 часов дня',
      'Mask required for transportation':
        'Маска необходима для транспортировки',
      'Add to Calendar': 'Добавить в календарь',
      'What type(s) of communication would you prefer and consent to? (Select any and all that apply):':
        'Какой тип (типы) общения Вы предпочитаете и на какой согласны? (Выберите все, что относится к данному вопросу):',
      'SMS/Text': 'SMS/Текст',
      'Email': 'Электронная почта',
      'Health Care Application ("App")':
        'Приложение для медицинского обслуживания ("Приложение")',
      'Remote Communications (ex. use of tablets to communicate on request with family)':
        'Удаленные коммуникации (например, использование планшетов для общения по запросу с семьей)',
      'Other:': 'Другое',
      'Please explain what other type of communication you are consenting to:':
        'Пожалуйста, поясните, на какой другой вид связи Вы даете согласие:',
      'Additionally, would you like to participate in and consent to Telehealth services?':
        'Кроме того, желаете ли Вы принять участие и дать согласие на получение услуг телемедицины?',
      'Yes, I would like the ability to receive telehealth appointments (EHS Telehealth Programs).':
        'Да, я хотел бы иметь возможность получать приемы по телемедицине (программы телемедицины EHS).',
      'Notice: The EHS Telehealth Consent option was not selected on the previous screen. If you would like to have the option to participate in telehealth appointments (virtual appointments from your home) in the future, please return to the previous screen and select "EHS Telehealth programs". You can also opt in at a later time by completing a new consent form.':
        'Примечание: На предыдущем экране не была выбрана опция EHS Телемедицина Согласие. Если вы хотите в будущем иметь возможность участвовать в телемедицинских приемах (виртуальных встречах из дома), вернитесь на предыдущий экран и выберите "Программы телемедицины EHS". Вы также можете отказаться от участия в программе позднее, заполнив новую форму согласия.',
      'Please review the following document(s).':
        'Пожалуйста, ознакомьтесь со следующим(и) документом(ами).',
      'Tap the checkmark next to each document to sign it. Click the name of the document to view it.':
        'Нажмите на галочку рядом с каждым документом, чтобы подписать его. Нажмите на название документа, чтобы просмотреть его.',
      'By tapping "Add Signature", I agree to use electronic records and signatures. I have read the Electronic Record and Signature Disclosures and understand my options.':
        'Нажимая "Добавить подпись", я соглашаюсь использовать электронные записи и подписи. Я прочитал(а) Информацию о Электронных Записях и Подписях и понимаю мои варианты.',
      'Add Signature': 'Добавить подпись',
      'Do you or have you ever smoked tobacco?':
        'Курите ли Вы или когда-либо курили табак?',
      'Never smoker': 'Никогда не курил',
      'Former smoker': 'В прошлом курил',
      'Current every day smoker': 'Ежедневно курю в настоящее время',
      'Current some days smoker': 'В настоящее время иногда курю',
      'Do you or have you ever used any other forms of tobacco or nicotine?':
        'Употребляете ли Вы или когда-либо употребляли другие виды табака или никотина?',
      'Do you or have you ever used e-cigarettes or vape?':
        'Используете ли Вы или когда-либо использовали электронные сигареты или вейп?',
      'I have never used e-cigarettes or vape':
        'Я никогда не пользовался электронными сигаретами или вейпом',
      'I have formerly used e-cigarettes or vape':
        'Я ранее использовал электронные сигареты или вейп',
      'I currently use e-cigarettes or vape':
        'В настоящее время я использую электронные сигареты или вейп',
      'Do you or have you ever used smokeless tobacco?':
        'Употребляете ли Вы или когда-либо употребляли бездымный табак?',
      'I have ever used smokeless tobacco':
        'Я когда-либо употреблял бездымный табак',
      'I have formerly used smokeless tobacco':
        'В прошлом я употреблял бездымный табак',
      'I currently use snuff':
        'В настоящее время я использую нюхательный табак',
      'I currently use chew tobacco':
        'В настоящее время я употребляю жевательный табак',
      'I currently use moist powdered tobacco':
        'В настоящее время я использую влажный порошкообразный табак',
      'What was the date of your most recent tobacco screening?':
        'Какова дата последнего скрининга на табакокурение?',
      'MM / DD / YYYY': 'ММ / ДД / ГГГГ',
      'Has tobacco cessation counseling been provided?':
        'Проводилось ли консультирование по отказу от табака?',
      'On what date was tobacco cessation counseling provided?':
        'В какой день была проведена консультация по отказу от табака?',
      'What is your level of alcohol consumption?':
        'Каков Ваш уровень употребления алкоголя?',
      'None': 'Не употребляю',
      'Occasional': 'Иногда употребляю',
      'Moderate': 'Умеренно употребляю',
      'Heavy': 'Сильно употребляю',
      'Do you use any illicit or recreational drugs?':
        'Употребляете ли Вы какие-либо запрещенные или рекреационные наркотики?',
      'Which illicit or recreational drugs have you used?':
        'Какие запрещенные или рекреационные наркотики Вы употребляли?',
      'Have you used IV drugs?': 'Принимали ли Вы внутривенные наркотики?',
      'What is your level of caffeine consumption?':
        'Каков Ваш уровень потребления кофеина?',
      'Do you have an advance directive?':
        'Есть ли у вас предварительное распоряжение?',
      'Is blood transfusion acceptable in an emergency?':
        'Допустимо ли переливание крови в экстренных случаях?',
      'Do you feel stressed (tense, restless, nervous, or anxious, or unable to sleep at night)?':
        'Испытываете ли Вы стресс (напряжение, беспокойство, нервозность, тревогу, не можете заснуть ночью)?',
      'Not at all': 'Совсем нет',
      'Only a little': 'Совсем немного',
      'To some extent': 'В некоторой степени',
      'Rather much': 'Достаточно сильно',
      'Very much': 'Очень сильно',
      'Do you wear a helmet when biking?':
        'Носите ли Вы шлем при езде на велосипеде?',
      'Do you use your seat belt or car seat routinely?':
        'Регулярно ли Вы пользуетесь ремнем безопасности или автокреслом?',
      'What is your relationship status?': 'Каков Ваш статус отношений?',
      'Domestic Partner': 'Сожитель',
      'Are you sexually active?': 'Ведете ли Вы половую жизнь?',
      'Do you use protection during sex?':
        'Используете ли Вы защиту во время секса?',
      'Always': 'Всегда',
      'Usually': 'Как правило',
      'How many children do you have?': 'Сколько у Вас детей?',
      'What type of diet are you following?':
        'Какого типа диеты Вы придерживаетесь?',
      'Regular': 'Обычной',
      'Vegetarian': 'Вегетарианской',
      'Vegan': 'Веганской',
      'Gluten Free': 'Безглютеновой',
      'Specific': 'Конкретной',
      'Carbohydrate': 'Углеводной',
      'Cardiac': 'Кардиологической',
      'Diabetic': 'Диабетической',
      'What is your exercise level?':
        'Каков уровень Вашей физической подготовки?',
      'How many days of moderate to strenuous exercise, like a brisk walk, did you do in the last 7 days?':
        'Сколько дней за последние 7 дней Вы занимались умеренной или интенсивной физической нагрузкой, например, бодрой ходьбой?',
      'What types of sporting activities do you participate in?':
        'Какими видами спорта Вы занимаетесь?',
      'Gender identity': 'Гендерная принадлежность',
      'Identifies as male': 'Идентифицирую себя как мужчина',
      'Identifies as female': 'Идентифицирую себя как женщина',
      'Transgender Male / Female-to-Male':
        'Трансгендерный мужчина / женщина-мужчина',
      'Transgender Female / Male-to-Female':
        'Трансгендерная женщина / мужчина-женщина',
      'Gender non-conforming (neither exclusively male nor female)':
        'Гендерная неконформность (не является ни исключительно мужским, ни исключительно женским)',
      'Additional gender category / other, please specify':
        'Дополнительная гендерная категория / другое, пожалуйста, укажите',
      'Please describe your gender identity:':
        'Опишите, пожалуйста, Вашу гендерную принадлежность:',
      'Assigned sex at birth': 'Присвоенный пол при рождении',
      'Male': 'Мужской',
      'Female': 'Женский',
      'Pronouns': 'Местоимение',
      'he/him': 'он/его',
      'she/her': 'она/ей',
      'they/them': 'они/им',
      'Preferred first name': 'Предпочитаемое имя',
      'Sexual orientation': 'Сексуальная ориентация',
      'Lesbian, gay, or homosexual': 'Лесбиянка, гей или гомосексуал',
      'Straight or heterosexual': 'Прямая или гетеросексуальная',
      'Bisexual': 'Бисексуал',
      'Something else, please describe': 'Что-то еще, пожалуйста, опишите',
      'Please describe your sexual orientation:':
        'Опишите, пожалуйста, Вашу сексуальную ориентацию:',
      'Review and update your current allergies.':
        'Просмотрите и обновите имеющиеся аллергические заболевания.',
      'If any of these allergies have changed please discuss this with your caregiver in person.':
        'Если какие-либо из этих аллергических реакций изменились, пожалуйста, обсудите это с вашим лечащим врачом лично.',
      'Add an allergy': 'Добавить аллергию',
      'Search by name...': 'Поиск по названию...',
      'Done adding allergies': 'Завершить добавление аллергий',
      'Search pharmacies': 'Поиск аптек',
      'Type to search': 'Введите для поиска',
      'Allergic Reaction': 'Аллергическая реакция',
      'Abdominal Pain': 'Боль в животе',
      'Anaphylaxis': 'Анафилаксия',
      'Angioedema': 'Ангионевротический отек',
      'Anxiety': 'Тревожность',
      'Chest Pain': 'Боль в грудной клетке',
      'Confusion': 'Путаница',
      'Cough': 'Кашель',
      'Decreased Blood Pressure': 'Пониженное артериальное давление',
      'Decreased Heart Rate': 'Сниженное число сердечных сокращений',
      'Dermatitis': 'Дерматит',
      'Diarrhea': 'Диарея',
      'Dizziness': 'Головокружение',
      'Edema': 'Отек',
      'Eye Redness': 'Покраснение глаз',
      'Eye Swelling': 'Отечность глаз',
      'Fever': 'Лихорадка',
      'Flushing': 'Гиперемия',
      'Hallucinations': 'Галлюцинации',
      'Headache': 'Головная боль',
      'Hives': 'Крапивница',
      'Increased Blood Pressure': 'Повышение артериального давления',
      'Increased Heart Rate': 'Повышенная частота сердечных сокращений',
      'Increased Sensitivity to Light': 'Повышенная чувствительность к свету',
      'Insomnia': 'Бессонница',
      'Irregular Heart Rate': 'Нерегулярный ритм сердца',
      'Itching': 'Зуд',
      'Joint Pain': 'Боль в суставах',
      'Muscle Pain': 'Боли в мышцах',
      'Nausea': 'Тошнота',
      'Rash': 'Сыпь',
      'Respiratory Distress': 'Нарушение дыхания',
      'Ringing in Ears': 'Звон в ушах',
      'Seizure': 'Припадок',
      'Shortness of Breath': 'Одышка',
      'Swelling': 'Отечность',
      'Stevens Johnson Syndrome': 'Синдром Стивенса-Джонсона',
      'Vertigo': 'Вертиго',
      'Vomiting': 'Рвота',
      'Wheezing': 'Хрипы',
      'Severity': 'Тяжесть',
      'Mild': 'Умеренная',
      'Severe': 'Сильная',
      'Search pharmacies...': 'Поиск аптек...',
      'Are you taking the following medications?':
        'Принимаете ли Вы следующие препараты?',
      'Taking as prescribed': 'Принимаю по назначению',
      'Taking but not as prescribed': 'Принимаю, но не по назначению',
      'Not taking': 'Не принимаю',
      'Please tell us about your past medical history':
        'Расскажите, пожалуйста, о Вашей истории болезни в прошлом',
      'Arthritis': 'Артрит',
      'Asthma': 'Астма',
      'Cancer': 'Рак',
      'COPD': 'ХОЗЛ',
      'Coronary artery disease': 'Ишемическая болезнь сердца',
      'Depression': 'Депрессия',
      'Diabetes': 'Диабет',
      'Heart attack': 'Сердечный приступ',
      'High blood pressure (hypertension)':
        'Повышенное артериальное давление (гипертония)',
      'High cholesterol (hyperlipidemia)':
        'Высокий уровень холестерина (гиперлипидемия)',
      'HIV': 'ВИЧ',
      'Hyperthyroidism': 'Гипертиреоз',
      'Hypothyroidism': 'Гипотиреоз',
      'Kidney disease': 'Заболевание почек',
      'Mental disability': 'Психическая неполноценность',
      'Obesity': 'Ожирение',
      'Osteoporosis': 'Остеопороз',
      'Stroke': 'Инсульт',
      'Search..': 'Поиск...',
      "Please tell us about your family's medical history":
        'Расскажите, пожалуйста, об истории болезни Вашей семьи',
      'ADD': 'СДВ',
      'ADHD': 'СДВГ',
      'Alcohol abuse': 'Злоупотребление алкоголем',
      "Alzheimer's disease": 'Болезнь Альцгеймера',
      'Anemia': 'Анемия',
      'Bleeding disorder': 'Нарушение кровообразования',
      'Breast Cancer': 'Рак молочной железы',
      'Chronic back pain': 'Хроническая боль в спине',
      'Chronic kidney disease': 'Хронические заболевания почек',
      'Colon cancer': 'Рак толстой кишки',
      'Dementia': 'Деменция',
      'Developmental delay': 'Задержка развития',
      'Diabetes Type 1': 'Диабет 1 типа',
      'Diabetes Type 2': 'Диабет 2 типа',
      'Diverticulitis': 'Дивертикулит',
      'Eczema': 'Экзема',
      'Emotional problem': 'Проблемы эмоционального характера',
      'End stage renal disease requiring dialysis':
        'Заболевание почек последней стадии, требующее проведения диализа',
      'Epilepsy': 'Эпилепсия',
      'Fibromyalgia': 'Фибромиалгия',
      'GI tract cacner (includes gastric, esophageal)':
        'Рак желудочно-кишечного тракта (включая рак желудка, пищевода)',
      'Gastroesophageal reflux disease (GERD)':
        'Гастроэзофагеальная рефлюксная болезнь (ГЭРБ)',
      'Glaucoma': 'Глаукома',
      'Heart failure': 'Сердечная недостаточность',
      'Inflammatory bowel disease': 'Воспалительные заболевания кишечника',
      'Irritable bowel syndrome': 'Синдром раздраженного кишечника',
      'Lactose intolerance': 'Непереносимость лактозы',
      'Leukemia': 'Лейкемия',
      'Liver cancer': 'Рак печени',
      'Liver cirrhosis': 'Цирроз печени',
      'Lung cancer': 'Рак лёгких',
      'Lupus': 'Волчанка',
      'Lymphoma': 'Лимфома',
      'Migraine headaches': 'Мигреневые головные боли',
      'Multiple sclerosis': 'Рассеянный склероз',
      'Obstructive sleep apnea': 'Обструктивное апноэ сна',
      'Pancreatic cancer': 'Рак поджелудочной железы',
      "Parkinson's": 'Болезнь Паркинсона',
      'Peptic ulcer disease': 'Язвенная болезнь',
      'Prostate cancer': 'Рак предстательной железы',
      'Psoriasis': 'Псориаз',
      'Rheumatoid arthritis': 'Ревматоидный артрит',
      'Season allergies': 'Сезонные аллергии',
      'Seizures': 'Припадки',
      'Sexually transmitted illness': 'Заболевания, передающиеся половым путем',
      'Smoking': 'Курение',
      'Substance abuse': 'Злоупотребление веществами',
      'Suicide': 'Суицид',
      'Thyroid disorder': 'Нарушение функций щитовидной железы',
      'Tuberculosis': 'Туберкулез',
      'Urinary tract infections': 'Инфекции мочевыводящих путей',
      'Which family members have had KIDNEY DISEASE?':
        'Кто из членов семьи страдал болезнью почек?',
      'Brother': 'Брат',
      'Daughter': 'Дочь',
      'Father': 'Отец',
      'Mother': 'Мать',
      'Maternal Aunt': 'Тетя по материнской линии',
      'Maternal Grandfather': 'Дедушка по материнской линии',
      'Maternal Grandmother': 'Бабушка по материнской линии',
      'Maternal Uncle': 'Дядя по материнской линии',
      'Paternal Aunt': 'Тетя по отцовской линии',
      'Paternal Grandmother': 'Бабушка по отцовской линии',
      'Paternal Grandfather': 'Дедушка по отцовской линии',
      'Paternal Uncle': 'Дядя по отцовской линии',
      'Sister': 'Сестра',
      'Son': 'Сын',
      'Review and update your surgical history.':
        'Просмотреть и обновить историю болезни.',
      'Add another surgery': 'Добавить еще одну операцию',
      'When was your surgery': 'Когда была проведена операция',
      'Month (optional)': 'Месяц (необязательно)',
      'January': 'Январь',
      'February': 'Февраль',
      'March': 'Март',
      'April': 'Апрель',
      'May': 'Май',
      'June': 'Июнь',
      'July': 'Июль',
      'August': 'Август',
      'September': 'Сентябрь',
      'October': 'Октябрь',
      'November': 'Ноябрь',
      'December': 'Декабрь',
      'Day (optional)': 'День (необязательно)',
      'Year': 'Год',
      'Are you Hispanic or Latino?':
        'Являетесь ли Вы латиноамериканцем или латиноамериканкой?',
      'I choose not to answer': 'Я предпочитаю не отвечать',
      'Which race(s) are you?': 'Какой Вы расы?',
      'Native Hawaiian': 'Коренной житель Гавайев',
      'Pacific Islander': 'Житель тихоокеанских островов',
      'Black/African American': 'Черный/афроамериканец',
      'American Indian/Alaskan Native':
        'Американский индеец/коренной житель Аляски',
      'Multiple Races': 'Несколько рас',
      "At any point in the past 2 years, has season or migrant farm work been your or your family's main source of income?":
        'Когда-либо за последние 2 года сезонные работы на фермах или работа в качестве мигрантов были основным источником дохода для Вас или Вашей семьи?',
      'Have you been discharged from the armed forces of the United States?':
        'Были ли Вы уволены из вооруженных сил США?',
      'What language are you most comfortable speaking?':
        'На каком языке Вам удобнее всего говорить?',
      'Language other than English': 'Язык, отличный от английского',
      'Please indicate which language you are most comfortable speaking:':
        'Укажите, пожалуйста, на каком языке Вам удобнее всего говорить:',
      'How many family members, including yourself, do you currently live with?':
        'Сколько членов семьи, включая Вас, проживает с Вами в настоящее время?',
      'If "Language other than English" is selected, please document the language in the notes field at the bottom of this screening questionnaire.':
        'Если выбран вариант "Язык, отличный от английского", пожалуйста, укажите язык в поле примечаний в нижней части анкеты.',
      'What is your housing situation today?':
        'Какова Ваша жилищная ситуация на сегодняшний день?',
      'I have housing': 'У меня есть жилье',
      'I do not have housing': 'У меня нет жилья',
      'Are you worried about losing your housing?':
        'Вы боитесь потерять жилье?',
      'What is the highest level of school that you have finished?':
        'Какой самый высокий уровень образования Вы получили?',
      'Less than high school degree': 'Образование ниже среднего',
      'High school diploma or GED':
        'Диплом о среднем образовании или общеобразовательное развитие',
      'More than high school': 'Выше школьного образования',
      'What is your current work situation?':
        'Какова Ваша текущая ситуация с работой?',
      'Unemployed': 'Безработный',
      'Part time or temporary work':
        'Неполный рабочий день или временная работа',
      'Full time work': 'Работа на полную ставку',
      'Otherwise unemployed but not seeking work (ex. student, retired, disabled, unpaid primary care giver)':
        'Безработные, но не ищущие работу (например, студенты, пенсионеры, инвалиды, лица, осуществляющие основной уход за больными)',
      'What is your main insurance?': 'Какова Ваша основная страховка?',
      'None/uninsured': 'Нет/не застрахован',
      'CHIP Medicaid': 'CHIP Медикейд',
      'Medicaid': 'Медикейд',
      'Medicare': 'Медикер',
      'Other public insurance (not CHIP)':
        'Другое государственное страхование (не CHIP)',
      'Other public insurance (CHIP)':
        'Другие виды государственного страхования (CHIP)',
      'Private insurance': 'Частное страхование',
      'During the past year, what was the total combined income for you and the family members you live with?':
        'Каков был совокупный доход Вас и членов семьи, с которыми Вы проживаете, за последний год?',
      'In the past year, have you or any family members you live with been unable to get any of the following when it was really needed? Select all that apply.':
        'За последний год вы или члены вашей семьи, с которыми вы живете, не могли получить что-либо из перечисленного ниже, когда это было действительно необходимо? Выберите все, что относится к данному вопросу.',
      'Food': 'Продукты питания',
      'Utilities': 'Коммунальные услуги',
      'Clothing': 'Одежда',
      'Childcare': 'Присмотр за детьми',
      'Medicine or Any Health Care (Medical, Dental, Mental Health, Vision)':
        'Медицина или любое медицинское обслуживание (медицинское, стоматологическое, психиатрическое, зрительное)',
      'Phone': 'Телефон',
      'Other necessities': 'Прочие предметы первой необходимости',
      'I choose not to answer this question':
        'Я предпочитаю не отвечать на этот вопрос',
      'Has lack of transportation kept you from medical appointments, meetings, work, or from getting things needed for daily living?':
        'Приводило ли отсутствие транспорта к тому, что Вы не могли попасть на прием к врачу, на встречу, на работу или получить необходимые для повседневной жизни вещи?',
      'Yes it has kept me from medical and non-medical appointments':
        'Да, это помешало мне посетить медицинские и не медицинские учреждения',
      'It has kept me from MEDICAL appointments':
        'Это помешало мне попасть на МЕДИЦИНСКИЙ прием',
      'It has kept me from NON-MEDICAL appointments':
        'Это помешало мне попасть на НЕ МЕДИЦИНСКИЕ приемы',
      'How often do you see or talk to people that you care about and feel close to?':
        'Как часто Вы видитесь или разговариваете с людьми, которые Вам дороги и близки?',
      'Less than once a week': 'Реже одного раза в неделю',
      '1 or 2 times a week': '1 или 2 раза в неделю',
      '3 or 5 times a week': '3 или 5 раз в неделю',
      '5 or more times a week': '5 и более раз в неделю',
      'How stressed are you?': 'Насколько Вы подвержены стрессу?',
      'A little bit': 'Немного',
      'Somewhat': 'В некотором роде',
      'Quite a bit': 'Довольно сильно',
      'What is stress?': 'Что такое стресс?',
      'Stress is when someone feels tense, nervous, anxious, or can’t sleep at night because their mind is troubled.':
        'Стресс - это когда человек чувствует себя напряженным, нервным, тревожным или не может заснуть ночью из-за беспокойства в голове.',
      'In the past year, have you spent more than 2 nights in a row in a jail, prison, detention center, or juvenile correctional facility?':
        'Проводили ли Вы за последний год более двух ночей подряд в тюрьме, колонии, центре содержания под стражей или исправительном учреждении для несовершеннолетних?',
      'Are you a refugee?': 'Являетесь ли вы беженцем?',
      'Do you feel physically and emotionally safe where you currently live?':
        'Чувствуете ли Вы себя в физической и эмоциональной безопасности там, где Вы сейчас живете?',
      'Unsure': 'Не уверен',
      'In the past year, have you been afraid of your partner or ex-partner?':
        'В течение последнего года испытывали ли Вы страх перед своим партнером или бывшим партнером?',
      'Have not had partner in last year':
        'Не имел партнера в течение последнего года',
      'For your security, sign in to continue.':
        'В целях безопасности, войдите в систему, чтобы продолжить.',
      'By continuing, you agree to our Terms of Use.':
        'Продолжая, вы соглашаетесь с нашими Условиями использования.',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'Использование данного сервиса предназначено только для несрочных сообщений, и ответы могут быть не рассмотрены вашим врачом. Если вам требуется немедленный ответ, звоните непосредственно в офис вашего врача. В случае экстренной медицинской помощи наберите 911 или немедленно обратитесь в ближайший пункт неотложной помощи.',
      'Change Language:': 'Сменить язык:',
      'Review and edit any personal information that has changed':
        'Просмотрите и отредактируйте любую изменившуюся личную информацию.',
      'Personal Information': 'Личные данные',
      'Mobile Phone': 'Мобильный номер телефона',
      'Home Phone': 'Домашний номер телефона',
      'Physical Address': 'Физический адрес',
      'Demographics': 'Демографические данные',
      'Race': 'Раса',
      'Ethnicity': 'Этническая принадлежность',
      'Marital Status': 'Семейное положение',
      'Employer': 'Работодатель',
      'Identification': 'Идентификация',
      'Save Updates': 'Сохранить обновления',
    },
  },
  ht: {
    photoId: {
      title:
        'Telechaje foto lisans la oswa pyès idantite gouvènman an pou abòne an.',
    },
    translation: {
      'dataIsSecure':
        'Tout done yo telechaje an sekirite avèk kodifikasyon nivo bank ak metòd ki konfòme ak prensip HIPAA yo.',
      'For your security, sign in to continue.':
        'Pou sekirite ou, konekte pou kontinye',
      'By continuing, you agree to our Terms of Use.':
        'Lè w kontinye, ou dakò ak Kondisyon Itilizasyon nou yo.',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'itilizasyon zouti sa a se pou kominikasyon ki pa ijan sèlman, epi founisè w la ka pa revize repons yo. Si w bezwen yon repons imedya, rele biwo founisè w la dirèkteman. Si ta gen yon ijans medikal, rele 911 oswa vizite sal ijans ki pi pre w la imedyatman.',
      'Change Language:': 'Chanje Lang',
      'Answer the following questions to help': 'Reponn kesyon sa yo pou ede',
      'prepare for your upcoming visit.': 'prepare pou pwochen vizit ou a',
      'Patient Registration': 'Anrejistreman Pasyan',
      'Patient Insurance': 'Asirans Pasyan',
      'Social History': 'Istwa Sosyal',
      'Clinical Intake': 'Admisyon klinik',
      'Patient Consent - Language': 'Konsantman Pasyan - Lang',
      'Social Determinants of Health': 'Detèminan Sosyal Sante',
      'Start': 'Kòmanse',
      "Patient's Mobile Phone Number": 'Nimewo telefòn mobil pasyan an',
      "Patient's Home Phone Number (if applicable)":
        'Nimewo Telefòn Kay Pasyan an (si sa aplikab)',
      "Patient's email address": 'Adrès imel pasyan an',
      "Patient's Home Address": 'Adrès Kay Pasyan an',
      'What race does the patient identify with?':
        'Ak ki ras pasyan an idantifye?',
      'Black or African American': 'Nwa oswa Afriken Ameriken',
      'American Indian or Alaska Native':
        'Endyen Ameriken oswa natif natal Alaska',
      'Asian': 'Azyatik',
      'Asian Indian': 'Endyen Azyatik',
      'White': 'Blan',
      'Native Hawaiian or Pacific Islander':
        'Natifnatal Awayi oswa zile Pasifik',
      'Other': 'Lòt',
      "What is the patient's ethnicity?": 'Ki etnisite pasyan an?',
      'Hispanic, Latino or Spanish Origin': 'Panyòl, Orijin Latino oswa Panyòl',
      'Not Hispanic, Latino or Spanish Origin':
        'Pa Panyòl, Orijin Latino oswa Panyòl',
      'Do not wish to provide': 'Pa vle bay',
      "Patient's Martial Status": 'Eta Sivil Pasyan an',
      'Divorced': 'Divòse',
      'Married': 'Marye',
      'Partnered': 'Menaj, Ap viv nan kay',
      'Separated': 'Separe',
      'Single': 'Selibatè',
      'Widowed': 'Vèf',
      'is required': 'se obligatwa',
      'Invalid number in the field': 'Nimewo envalid nan espas sa',
      'Enter your address': 'Antre adrès ou',
      'Address Line 1': 'Liy adrès 1',
      'Address Line 2': 'Liy adrès 2',
      'City': 'Vil',
      'State': 'Eta',
      'Zip Code': 'Kòd postal',
      'Save': 'Sove, enrejistre',
      'Continue': 'Kontinye',
      'Are you currently employed?': 'Èske w ap travay kounye a?',
      'Yes': 'Wi',
      'No': 'Non',
      'What language would you like to sign the consent forms in?':
        'Nan ki lang ou ta renmen siyen fòm konsantman yo?',
      'English': 'angle',
      'Spanish': 'Panyòl',
      'Haitian Creole': 'Kreyòl ayisyen',
      'Arabic': 'Arab',
      'Russian': 'Ris',
      'Employer name': 'Non patwon an. Non anplwayè an',
      'Select or add an employer': 'Chwazi oswa ajoute yon anplwayè',
      "Employer's phone number":
        'Nimewo telefòn patwon an. Nimewo telefòn anplwayè an',
      "Will you be using insurance to pay for today's visit?":
        'Èske w ap itilize asirans pou peye vizit jodi a?',
      'Is this still your primary insurance?':
        'Èske sa toujou asirans prensipal ou a?',
      'Upload photos of your primary health insurance card.':
        'Telechaje foto kat asirans sante prensipal ou a.',
      'Additional cards may be uploaded after.':
        'Lòt kat yo a kapab telechaje apre.',
      'Front of Insurance Card': 'Devan Kat Asirans',
      'Back of Insurance Card': 'Dèyè Kat Asirans',
      "I don't have my card": 'Mwen pa gen kat mwen an',
      'No, my insurance has changed': 'Non, asirans mwen an chanje',
      "Front of Driver's License": 'Devan lisans la',
      "Back of Driver's License": 'Dèyè lisans la',
      'Front of card': 'Devan kat la',
      'Take a picture of the front of your insurance card & position it in the frame. Make sure all four corners of your card are visible.':
        'Pran yon foto devan kat asirans ou epi mete l nan ankadreman an. Asire w ke tout kat(4) kwen kat ou a vizib.',
      'Zoom': 'Rale',
      'Rotate': 'Vire',
      'Back of card': 'Dèyè kat la',
      'Save front photo': 'Enrejistre foto devan',
      'Save back photo': 'Enrejistre foto dèyè',
      'Upload': 'Telechaje (monte)',
      'Clear images': 'Efase imaj oswa (imaj klè)',
      'Do you have additional insurance you would like to add?':
        'Èske w gen lòt asirans ou ta renmen ajoute?',
      'Insurance #1': 'Asirans # 1',
      'Edit': 'Modifye, korige',
      'Yes, add another': 'Wi, ajoute yon lòt',
      'No, continue': 'Non, kontinye',
      'Upload photos of your additional health insurance card.':
        'Telechaje foto lòt kat asirans sante w.',
      'Go back to insurance list': 'Tounen nan lis asirans la',
      'Emergency Contact': 'Kontak Ijans',
      'First Name': 'Prenon ou',
      'Last Name': 'Siyati ou',
      'Relationship': 'Relasyon (kisa moun lan ye pou ou)',
      'Select an option': 'Chwazi yon opsyon',
      'Spouse': 'Konjwen',
      'Parent': 'Paran',
      'Child': 'Pitit, timoun',
      'Sibling': 'Frè ak sè',
      'Friend': 'Zanmi',
      'Cousin': 'Kouzen',
      'Guardian': 'gadyen',
      'Phone Number': 'Nimewo telefòn',
      "Avoid using the patient's phone number":
        'Evite itilize nimewo telefòn pasyan an',
      "Please list the patient's primary care provider.":
        'Tanpri bay lis founisè swen prensipal pasyan an.',
      "Please use the provider's first and last name when searching.":
        'Tanpri itilize non ak siyati founisè a lè w ap chèche.',
      'Enter the name...': 'Antre non an…',
      "Care Provider's First Name": 'Prenon founisè swen an',
      "Care Provider's Last Name": 'Siyati founisè swen an',
      'Cancel': 'Anile',
      'Some emergency contact information is missing for':
        'Gen kèk enfòmasyon kontak ijans ki manke pou',
      'Loading': 'Chaje, en chajeman, ap chaje',
      'What is the highest grade or level of school you have completed or the highest degree you have received?':
        'Ki pi wo klas oswa nivo lekòl ou te rive, oswa ki pi wo grad ou te resevwa?',
      'Never attended': 'Pat janm patisipe, Pat janm ale',
      '1st grade': '1ye ane, (preparatwa 1)',
      '2nd grade': '2yèm ane, (preparatwa 2)',
      '3rd grade': '3yèm ane, (elemantè 1)',
      '4th grade': '4yèm ane, (elemantè 2)',
      '5th grade': '5yèm ane, (mwayen 1)',
      '6th grade': '6yèm ane, (mwayen 2)',
      '7th grade': '7yèm ane, (6yèm segondè)',
      '8th grade': '8yèm ane, (5yèm segondè)',
      '9th grade': '9yèm ane, (4yèm segondè)',
      '10th grade': '10yèm ane, (3yèm segondè)',
      '11th grade': '11yèm ane, (segonde)',
      '12th grade, no diploma': '12yèm ane, pa gen diplòm, (Rheto)',
      'GED or equivalent': 'GED oswa ekivalan, (Philo)',
      'high school graduate': 'gradye nan lekòl segondè',
      'some college, no degree': 'kèk kolèj, pa gen okenn degre',
      'Associate degree: occupational, technical, or vocational program':
        'Asosye degre: okipasyonèl, teknik, oswa pwogram pwofesyonèl',
      'Associate degree: academic program': 'Asosye degre: pwogram akademik',
      "Bachelor's degree (e.g. BA, AB, BS)":
        'Diplòm bakaloreya (egzanp BA, AB, BS)',
      "Master's degree (e.g. MA, MS, MEng, MEd, MSW, MBA)":
        'Mètriz (egzanp MA, MS, MEng, MEd, MSW, MBA)',
      'Professional school degree (e.g. MD, DDS, DVM, JD)':
        'Diplòm lekòl pwofesyonèl (tankou MD, DDS, DVM, JD)',
      'Doctoral degree (e.g. PhD, EdD)': 'Doktora (egzanp PhD, EdD)',
      "I don't know": 'M pa konnen',
      'Choose not to disclose': 'Chwazi pa divilge, chwazi pa di',
      'What is your occupation?': 'Ki travay ou fè? Ki pwofesyon ou?',
      'Are you able to care for yourself?': 'Èske ou kapab pran swen tèt ou?',
      'Are you blind or do you have difficulty seeing?':
        'Èske w avèg oswa ou gen difikilte pou w wè?',
      'Are you deaf or do you have serious difficulty hearing?':
        'Èske ou soud oswa ou gen gwo difikilte pou tande?',
      'Do you have difficulty concentrating, remembering or making decisions?':
        'Èske ou gen difikilte pou konsantre, sonje oswa pran desizyon?',
      'Do you have difficulty walking or climbing stairs?':
        'Èske ou gen difikilte pou mache oswa monte eskalye?',
      'Do you have difficulty dressing or bathing?':
        'Èske w gen difikilte pou w abiye oswa benyen?',
      'Do you have difficulty doing errands alone?':
        'Èske w gen difikilte pou w fè komisyon poukont ou? Èske w gen difikilte regle aktivite ou poukont ou?',
      'Are you able to walk?': 'Èske ou ka mache?',
      'Yes: walks without restrictions': 'Wi: mache san restriksyon',
      'Yes: walks with assistive device(s)': 'Wi: mache ak aparèy asistans',
      'Yes: limited self ability with assistive device(s); generall relies on wheeled mobility':
        'Wi: kapasite pèsonèl limite ak aparèy asistans; jeneralman depandan de mobilite sou wou',
      'No: confined to chair': 'Non: kloue sou yon chèz',
      'No: independent in wheelchair': 'Non: endepandan, sou chèz woulant',
      'No: requires minimal help in wheelchair':
        'Non: sou chèz woulant men nesesite èd minimòm',
      'No: dependent on helper pushing wheelchair':
        'Non: depann de asistan pou pouse chèz woulant la',
      'No: unable to walk': 'Non: pa ka mache',
      'No: unable to initiate walking':
        'Non: pa kapab kòmanse mache pou kont mwen',
      'No: bed-ridden': 'Non: kouche sou kabann',
      'Do you have transportation difficulties?':
        'Èske w gen difikilte pou transpò?',
      'Have you been to an area known to be high risk for COVID-19?':
        'Èske w te ale nan yon zòn ki gen gwo risk pou COVID-19?',
      'In the last two weeks, have you been in close contact with someone with a confirmed COVID-19 case while the person was ill?':
        'Nan (2) de semèn ki sot pase yo la, èske ou te an kontak sere ak yon moun ki gen yon ka konfime COVID-19 pandan ke moun sa te malad?',
      'In the last two weeks, have you been in close contact with someone with a suspected COVID-19 case while the person was ill?':
        'Nan (2) de semèn ki sot pase yo, èske w te an kontak sere ak yon moun ki gen ka sispèk COVID-19 pandan ke moun nan te malad?',
      'Do you reside in or have you traveled to an area where Ebola virus transmission is active?':
        'Èske w abite oswa èske w te vwayaje nan yon zòn kote transmisyon viris Ebola aktif?',
      'Have you processed blood or body fluids from an Ebola virus disease patient without appropriate PPE?':
        'Èske w te trete san oswa likid ki sòti nan kò yon pasyan ki genyen viris maladi Ebola san ekipman pwoteksyon pèsonèl (EPP) apwopriye?',
      'Have there been any changes to your family or social situation?':
        'Èske gen chanjman ki fèt nenpòt nan fanmi w oswa sitiyasyon sosyal ou a?',
      'What type of child care do you use?': 'Ki kalite gadri ou itilize?',
      'None or no Children': 'Okenn oswa pa gen timoun',
      'Relative': 'Fanmi',
      'Private Sitter': 'Gadyen prive pou timoun',
      'Daycare/Preschool': 'Gadri, Krèch /Preskolè',
      'Do you have any pets?': 'Èske ou gen bèt na kay (chyen, chat)?',
      'Do you have smoke and carbon monoxide detectors in your home?':
        'Èske w gen detektè lafimen ak monoksid kabòn lakay ou?',
      'Are you passively exposed to smoke?':
        'Èske ekspoze a lafimen pasivman ?',
      'Are there any guns present in your home?': 'Èske gen zam lakay ou?',
      'What is the fluoride status of your home?': 'Ki estati fliyò lakay ou?',
      'Fluoridated': 'Fliyorize',
      'Unknown': 'Enkoni, pa konenn',
      'Non-fluoridated': 'Ki pa fliyorize',
      'Do you use insect repellent routinely?':
        'Èske w itilize pwodui pou repouse ensèk regilyèman?',
      'Do you use sunscreen routinely?':
        'Èske w itilize krèm pwoteksyon kont solèy regilyèman?',
      'Finish': 'Fini',
      'Thanks, all done! We are looking forward to seeing you soon.':
        'Mèsi, tout bagay fini! Nou ap tann pou wè ou ankò.',
      'Please arrive 15 minutes prior to your appointment time and check in with the front desk.':
        'Tanpri rive 15 minit anvan lè randevou ou a epi tcheke nan resepsyon an',
      'Ocean Bay Community Development provides free transportation services for Youth, Senior Citizens, and Disabled Residents. Call Mr. JONES or Mrs. Jordan to schedule a trip. 24 hours notice required.':
        'Ocean Bay Community Development bay sèvis transpò gratis pou Jèn, granmoun aje, ak rezidan ki andikape yo. Rele Mesye JONES oswa Madanm Jordan pou planifye yon vwayaj. Li obligatwa pou avize 24 èdtan avan.',
      'Call (929) 553-1312 3 PM to 8 PM': 'Rele (929) 553-1312 3 PM pou 8 PM',
      'Call (347) 777-7951 8 AM to 3 PM': 'Rele (347) 777-7951 8 AM jiska 3 PM',
      'Mask required for transportation': 'Mask obligatwa pandan transpò a',
      'What type(s) of communication would you prefer and consent to? (Select any and all that apply):':
        'Ki mwayen kominikasyon ou prefere ak konsanti? (Chwazi nenpòt ak tout sa ki aplike):',
      'SMS/Text': 'SMS/Mesaj Tèks',
      'Email': 'Imèl',
      'Health Care Application ("App")':
        'Aplikasyon pou Swen Sante ("Aplikasyon nan Playstore oswa Apple Store")',
      'Remote Communications (ex. use of tablets to communicate on request with family)':
        'Kominikasyon Adistans (egzanp itilizasyon tablèt pou kominike sou demann ak fanmi)',
      'Other:': 'Lòt:',
      'Please explain what other type of communication you are consenting to:':
        'Tanpri eksplike ki lòt mwayen kominikasyon wa va dakò(wa va aksepte):',
      'Additionally, would you like to participate in and consent to Telehealth services?':
        'Anplis de sa, èske ou ta renmen patisipe nan sèvis Telesante ak bay konsantman pou sa?',
      'Yes, I would like the ability to receive telehealth appointments (EHS Telehealth Programs).':
        'Wi, mwen ta renmen kapab resevwa randevou telesante (EHS Telehealth Programs/ EHS Pwogram Telesante)',
      'Notice: The EHS Telehealth Consent option was not selected on the previous screen. If you would like to have the option to participate in telehealth appointments (virtual appointments from your home) in the future, please return to the previous screen and select "EHS Telehealth programs". You can also opt in at a later time by completing a new consent form.':
        'Ou pat seleksyone opsyon pou aksepte "EHS Telehealth" la nan premye ekran. Si ou ta renmen alavni kapab patisipe nan randevou sante adistans (randevou vityèl lakay ou) tanpri retounen nan premye ekran epi chwazi:" EHS Telehealth Programs". Avek tou ou kapab enskri ankò pita lè w ranpli yon nouvo fòmilè konsantman.',
      'Please review the following document(s).': 'Tanpri revize dokiman sa yo',
      'Tap the checkmark next to each document to sign it. Click the name of the document to view it.':
        'Make yon ti flèch akote chak dokiman pou siyen li. Klike sou non dokiman an pou wè li.',
      'By tapping "Add Signature", I agree to use electronic records and signatures. I have read the Electronic Record and Signature Disclosures and understand my options.':
        'Lè mwen tape sou "Ajoute siyati", mwen dakò pou mwen itilize dosye elektwonik ak siyati yo. Mwen te li prensip Divilgasyon Dosye Elektwonik ak Siyati yo, epi mwen konprann opsyon mwen yo',
      'Add Signature': 'Ajoute siyati',
      'Do you or have you ever smoked tobacco?':
        'Èske ou fimen oswa èske ou janm fimen tabak?',
      'Never smoker': 'Pa janm fimen',
      'Former smoker': 'Ansyen fimè',
      'Current every day smoker': 'Aktyèl fimè ki fimen chak jou',
      'Current some days smoker': 'Aktyèl fimè ki fimen gen des fwa (jou)',
      'Do you or have you ever used any other forms of tobacco or nicotine?':
        'Èske w itilize oswa èske w janm itilize lòt fòm tabak oswa nikotin?',
      'Do you or have you ever used e-cigarettes or vape?':
        'Èske w itilize oswa janm itilize e-sigarèt oswa vape?',
      'I have never used e-cigarettes or vape':
        'Mwen pa janm itilize e-sigarèt oswa vape',
      'I have formerly used e-cigarettes or vape':
        'Mwen te itilize e-sigarèt oswa vape anvan',
      'I currently use e-cigarettes or vape':
        'Kounye a mwen itilize e-sigarèt oswa vape',
      'Do you or have you ever used smokeless tobacco?':
        'Èske ou itilize oswa èske ou janm itilize tabak san lafimen?',
      'I have ever used smokeless tobacco':
        'Mwen te janm itilize tabak san lafimen',
      'I have formerly used smokeless tobacco':
        'Mwen te itilize tabak san lafimen anvan',
      'I currently use snuff': 'Kounye a mwen pran priz tabak nan tou nen mwen',
      'I currently use chew tobacco': 'Kounye a mwen moulen tabak ak dan mwen',
      'I currently use moist powdered tobacco':
        'Kounye a mwen itilize tabak an poud imid',
      'What was the date of your most recent tobacco screening?':
        'Ki dat ou te fè dènye tès depistaj tabak ou a?',
      'MM / DD / YYYY': 'JJ / MM / AAAA',
      'Has tobacco cessation counseling been provided?':
        'Èske yo bay terapi (konsèy) pou sispann tabak?',
      'On what date was tobacco cessation counseling provided?':
        'Nan ki dat yo te bay terapi (konsèy) pou sispann tabak?',
      'What is your level of alcohol consumption?':
        'Ki nivo ou nan konsomasyon alkòl?',
      'None': 'Okenn',
      'Occasional': 'Okazyonèl',
      'Moderate': 'Modere',
      'Heavy': 'Lou, Gran bivè',
      'Do you use any illicit or recreational drugs?':
        'Èske w itilize dwòg ilegal oswa rekreasyonel?',
      'Which illicit or recreational drugs have you used?':
        'Ki dwòg ilegal oswa rekreasyonel ou itilize?',
      'Have you used IV drugs?': 'Èske w te itilize dwòg yo pran nan venn?',
      'What is your level of caffeine consumption?':
        'Ki nivo ou nan konsomasyon kafeyin?',
      'Do you have an advance directive?': 'Èske w gen yon direktiv avanse?',
      'Is blood transfusion acceptable in an emergency?':
        'Èske transfizyon san akseptab nan ka ijans?',
      'Do you feel stressed (tense, restless, nervous, or anxious, or unable to sleep at night)?':
        'Èske w santi w estrèse (krispe, ajite, nève, oswa enkyete, oswa ou pa kapab dòmi lannwit)?',
      'Not at all': 'Pa ditou',
      'Only a little': 'Se sèlman yon ti kras',
      'To some extent': 'Nan yon sèten mezi',
      'Rather much': 'Okontrè anpil',
      'Very much': 'Anpil',
      'Do you wear a helmet when biking?':
        'Èske w mete yon kas lè w ap monte bisiklèt?',
      'Do you use your seat belt or car seat routinely?':
        'Èske w itilize senti sekirite w oswa chèz machin pou tibebe regilyèman?',
      'What is your relationship status?': 'Ki sitiyasyon relasyonel ou?',
      'Domestic Partner': 'Patnè Domestik, Plase',
      'Are you sexually active?': 'Èske w aktif seksyèlman?',
      'Do you use protection during sex?':
        'Èske w sèvi ak pwoteksyon (kapoòt) pandan sèks?',
      'Always': 'Toujou, tout tan',
      'Usually': 'Anjeneral',
      'How many children do you have?': 'Konbyen pitit ou genyen?',
      'What type of diet are you following?':
        'Ki kalite rejim alimantè ou swiv?',
      'Regular': 'Regilye, nòmal',
      'Vegetarian': 'Vejetaryen',
      'Vegan': 'Vegan',
      'Gluten Free': 'San Glitèn',
      'Specific': 'Espesifik',
      'Carbohydrate': 'idrat kabòn',
      'Cardiac': 'Kadyak',
      'Diabetic': 'Dyabetik',
      'What is your exercise level?': 'Ki nivo egzèsis ou?',
      'How many days of moderate to strenuous exercise, like a brisk walk, did you do in the last 7 days?':
        'Konbyen jou egzèsis modere ak fatigan (difisil), tankou yon mache rapid, ou te fè nan 7 dènye jou sa yo?',
      'What types of sporting activities do you participate in?':
        'Nan ki tip aktivite espòtif ou patisipe?',
      'Gender identity': 'Ak ki sèks ke ou idantifye ou?',
      'Identifies as male': 'Idantifye kòm gason',
      'Identifies as female': 'Idantifye kòm fi',
      'Transgender Male / Female-to-Male':
        'Gason trans / sòti fi pou vinn gason',
      'Transgender Female / Male-to-Female':
        'Fi trans / sòti gason pou vinn fi',
      'Gender non-conforming (neither exclusively male nor female)':
        'Pa konfòme ak okenn sèks (pa eklisivman gason ni fi)',
      'Additional gender category / other, please specify':
        'Lòt kategori sèks / lòt, tanpri presize',
      'Please describe your gender identity:': 'Tanpri dekri idantite sèks ou:',
      'Assigned sex at birth':
        'Sèks ke yo di ke ou ye (asiyen) lè ou te fenk fèt',
      'Male': 'Gason',
      'Female': 'Fi',
      'Pronouns': 'Pwonon',
      'he/him': 'li/li',
      'she/her': 'li/li',
      'they/them': 'yo/yo',
      'Preferred first name': 'Prenon ke ou prefere',
      'Sexual orientation': 'Oryantasyon seksyèl ou ?',
      'Lesbian, gay, or homosexual': 'Madivin, masisi, oswa omoseksyèl',
      'Straight or heterosexual': 'Dwat oswa etewoseksyèl',
      'Bisexual': 'Biseksyèl',
      'Something else, please describe':
        'Yon lòt bagay, tanpri eksplike (dekri)',
      'Please describe your sexual orientation:':
        'Tanpri dekri oryantasyon seksyèl ou:',
      'Review and update your current allergies.':
        'Revize ak mete ajou alèji aktyèl ke ou genyen yo.',
      'If any of these allergies have changed please discuss this with your caregiver in person.':
        'Si nenpòt nan alèji sa yo chanje, tanpri diskite sou sa ak moun k ap ba ou swen an pèsòn.',
      'Add an allergy': 'Ajoute yon alèji',
      'Search by name...': 'Chèche pa non…',
      'Done adding allergies': 'Fini ajoute alèji',
      'Search pharmacies': 'Chèche famasi',
      'Type to search': 'Tape pou ka chèche',
      'Allergic Reaction': 'Reyaksyon alèjik',
      'Abdominal Pain': 'Doulè nan vant, doulè abdominal',
      'Anaphylaxis': 'Anafilaktik',
      'Angioedema': 'Angioedema',
      'Anxiety': 'Anksyete',
      'Chest Pain': 'Doulè nan pwatrin',
      'Confusion': 'Konfizyon',
      'Cough': 'Touse, tous',
      'Decreased Blood Pressure': 'Tansyon ba, presyon ba',
      'Decreased Heart Rate': 'Batman kè diminye, batman kè ba',
      'Dermatitis': 'dèrmatit',
      'Diarrhea': 'Dyare',
      'Dizziness': 'vètij',
      'Edema': 'Edem',
      'Eye Redness': 'Je Wouj',
      'Eye Swelling': 'Je anfle',
      'Fever': 'Lafyèv',
      'Flushing': 'Flushing',
      'Hallucinations': 'Alisinasyon',
      'Headache': 'Tèt fè mal',
      'Hives': 'Itikè',
      'Increased Blood Pressure': 'Tansyon Ogmante, ogmantasyon tansyon',
      'Increased Heart Rate': 'Batman kè ogmante, ogmantasyon Batman kè',
      'Increased Sensitivity to Light': 'Ogmantasyon sansiblite a limyè',
      'Insomnia': 'Lensomni',
      'Irregular Heart Rate': 'Batman kè iregilye',
      'Itching': 'Grate',
      'Joint Pain': 'Doulè nan jwenti',
      'Muscle Pain': 'Doulè nan misk',
      'Nausea': 'Kè plen',
      'Rash': 'Gratèl',
      'Respiratory Distress': 'Detrès respiratwa',
      'Ringing in Ears': 'Zòrèy Sonnen',
      'Seizure': 'Kriz',
      'Shortness of Breath': 'Souf kout',
      'Swelling': 'Anfle, anfleman',
      'Stevens Johnson Syndrome': 'Sendwòm Stevens Johnson',
      'Vertigo': 'Vertigo, vètij',
      'Vomiting': 'Vomisman',
      'Wheezing': 'souf anlè',
      'Severity': 'Severite',
      'Mild': 'léjè',
      'Severe': 'Grav',
      'Search pharmacies...': 'Chèche famasi…',
      'Are you taking the following medications?':
        'Èske w ap pran medikaman sa yo?',
      'Taking as prescribed': 'Pran l jan yo preskri li an',
      'Taking but not as prescribed': 'Pran l men pa jan yo preskri',
      'Not taking': 'Pap pran',
      'Please tell us about your past medical history':
        'Tanpri fè nou konnen istwa medikal pase ou',
      'Arthritis': 'Atrit',
      'Asthma': 'Opresyon',
      'Cancer': 'Kansè',
      'COPD': 'Maladi poumon kwonik obstriktif',
      'Coronary artery disease': 'Maladi atè kowonè',
      'Depression': 'Depresyon',
      'Diabetes': 'Dyabèt',
      'Heart attack': 'Atak kè',
      'High blood pressure (hypertension)': 'Tansyon wo (ipètansyon)',
      'High cholesterol (hyperlipidemia)': 'Kolestewòl wo (ipèlipidemi)',
      'HIV': 'VIH',
      'Hyperthyroidism': 'Ipètyroidi',
      'Hypothyroidism': 'Ipotyroidi',
      'Kidney disease': 'Maladi ren',
      'Mental disability': 'Andikap mantal',
      'Obesity': 'Obezite',
      'Osteoporosis': 'Osteyopowoz',
      'Stroke': 'Konjesyon serebral',
      'Search..': 'Chèche..',
      "Please tell us about your family's medical history":
        'Tanpri fè nou konnen istwa medikal fanmi ou',
      'ADD': 'Twoub defisi atansyon',
      'ADHD': 'Twoub defisi atansyon / ipèaktivite',
      'Alcohol abuse': 'Abi alkòl',
      "Alzheimer's disease": 'Maladi alzaymè',
      'Anemia': 'Anemi',
      'Bleeding disorder': 'Twoub senyen',
      'Breast Cancer': 'Kansè nan tete',
      'Chronic back pain': 'Doulè nan do kwonik',
      'Chronic kidney disease': 'Maladi ren kwonik',
      'Colon cancer': 'Kansè nan kolon',
      'Dementia': 'Demans',
      'Developmental delay': 'Reta nan devlopman',
      'Diabetes Type 1': 'Dyabèt tip 1',
      'Diabetes Type 2': 'Dyabèt tip 2',
      'Diverticulitis': 'Divertikulit',
      'Eczema': 'Ekzema',
      'Emotional problem': 'Pwoblèm emosyonèl',
      'End stage renal disease requiring dialysis':
        'Maladi ren tèminal ki mande dyaliz',
      'Epilepsy': 'Epilepsi',
      'Fibromyalgia': 'Fibromyalji',
      'GI tract cacner (includes gastric, esophageal)':
        'Kansè nan aparèy dijestifI (gastri, èzofaj)',
      'Gastroesophageal reflux disease (GERD)': 'Maladi Refli Gastro Ezofajien',
      'Glaucoma': 'Glokòm',
      'Heart failure': 'Ensifizans kadyak',
      'Inflammatory bowel disease': 'Maladi enflamatwa entesten',
      'Irritable bowel syndrome': 'Sendwòm entesten iritab',
      'Lactose intolerance': 'Entolerans a laktoz',
      'Leukemia': 'Lesemi',
      'Liver cancer': 'Kansè nan fwa',
      'Liver cirrhosis': 'Siwoz fwa',
      'Lung cancer': 'Kansè nan poumon',
      'Lupus': 'Lupus',
      'Lymphoma': 'Lenfom',
      'Migraine headaches': 'Migrèn tèt fè mal',
      'Multiple sclerosis': 'Sklewoz miltip',
      'Obstructive sleep apnea': 'Apne somèy obstriktif',
      'Pancreatic cancer': 'Kansè pankreyas',
      "Parkinson's": 'Maladi Pakinson',
      'Peptic ulcer disease': 'Maladi ilsè gastric',
      'Prostate cancer': 'Kansè pwostat',
      'Psoriasis': 'Psoriasis',
      'Rheumatoid arthritis': 'Atrit rimatoyid',
      'Season allergies': 'Alèji sezonye',
      'Seizures': 'Kriz',
      'Sexually transmitted illness': 'Maladi seksyèlman transmisib',
      'Smoking': 'Fimen',
      'Substance abuse': 'Abi sibstans',
      'Suicide': 'Swisid',
      'Thyroid disorder': 'Twoub tiwoyid',
      'Tuberculosis': 'Tibèkiloz',
      'Urinary tract infections': 'Enfeksyon nan aparèy urinè',
      'Which family members have had KIDNEY DISEASE?':
        'Ki manm fanmi ou ki te gen MALADI REN?',
      'Brother': 'Frè',
      'Daughter': 'Pitit fi',
      'Father': 'Papa',
      'Mother': 'Manman',
      'Maternal Aunt': 'Matant bò manman',
      'Maternal Grandfather': 'Granpè bò manman',
      'Maternal Grandmother': 'Granmè bò manman',
      'Maternal Uncle': 'Tonton bò manman',
      'Paternal Aunt': 'Matant bò papa',
      'Paternal Grandmother': 'Granmè bò papa',
      'Paternal Grandfather': 'Granpè bò papa',
      'Paternal Uncle': 'Tonton bò papa',
      'Sister': 'Sè',
      'Son': 'Pitit gason',
      'Review and update your surgical history.':
        'Revize epi mete ajou istwa chirijikal ou.',
      'Add another surgery': 'Ajoute yon lòt operasyon',
      'When was your surgery': 'Ki lè ou te fè operasyon an',
      'Month (optional)': 'Mwa (opsyonèl)',
      'January': 'Janvye',
      'February': 'Fevriye',
      'March': 'Mas',
      'April': 'Avril',
      'May': 'Me',
      'June': 'Jen',
      'July': 'Jiyè',
      'August': 'Out',
      'September': 'Septanm',
      'October': 'Oktòb',
      'November': 'Novanm',
      'December': 'Desanm',
      'Day (optional)': 'Jou (opsyonèl)',
      'Year': 'Ane',
      'Review and edit any personal information that has changed':
        'Revize epi modifye nenpòt enfòmasyon pèsonèl ki chanje',
      'Personal Information': 'Enfomasyon pèsonèl',
      'Mobile Phone': 'Telefòn mobil',
      'Home Phone': 'Telefòn lakay',
      'Physical Address': 'Adrès Fizik',
      'Demographics': 'Enfòmasyon demografik',
      'Race': 'Ras',
      'Ethnicity': 'Orijin Etnik ou',
      'Marital Status': 'Eta sivil',
      'Employer': 'Patwon, Anplwayè',
      'Identification': 'Idantifikasyon',
      'Save Updates': 'Enrejistre Mizajou',
      'Are you Hispanic or Latino?': 'Èske ou Panyòl oswa Latino?',
      'I choose not to answer': 'Mwen chwazi pa reponn',
      'Which race(s) are you?': 'Ki ras ou ye?',
      'Native Hawaiian': 'Natifnatal Awayi',
      'Pacific Islander': 'Moun zile Pasifik yo',
      'Black/African American': 'Nwa/Afriken Ameriken',
      'American Indian/Alaskan Native':
        'Endyen Ameriken / Moun Alaska natif natal',
      'Multiple Races': 'Plizyè Ras, Metis',
      "At any point in the past 2 years, has season or migrant farm work been your or your family's main source of income?":
        'Eske te genyen yon moman nan 2 ane ki sot pase yo, travay sezon oswa travay agrikòl migran te prensipal sous revni pou ou oswa fanmi ou?',
      'Have you been discharged from the armed forces of the United States?':
        'Èske w te diplome nan fòs lame Etazini yo?',
      'What language are you most comfortable speaking?':
        'Ki lang ou pi alèz pale?',
      'Language other than English': 'Lang ki pa angle',
      'Please indicate which language you are most comfortable speaking:':
        'Tanpri endike ki lang ou pi alèz pou w pale:',
      'How many family members, including yourself, do you currently live with?':
        'Ak konbyen manb fanmi w, enkli tèt ou, ou ap viv kounye a?',
      'If "Language other than English" is selected, please document the language in the notes field at the bottom of this screening questionnaire.':
        'Si w chwazi "Lang ki pa Angle", tanpri endike lang la nan espas nòt ki anba kesyonè tès depistaj sa a.',
      'What is your housing situation today?':
        'Ki sitiyasyon lojman w ye jodi a?',
      'I have housing': 'Mwen gen lojman',
      'I do not have housing': 'Mwen pa gen lojman',
      'Are you worried about losing your housing?':
        'Èske w enkyete a pwopo pèdi lojman w?',
      'What is the highest level of school that you have finished?':
        'Ki pi wo nivo lekòl ou te rive?',
      'Less than high school degree': 'Mwens pase diplòm lekòl segondè',
      'High school diploma or GED': 'Diplòm lekòl segondè oswa GED',
      'More than high school': 'Plis pase lekòl segondè, Depase lekòl segondè',
      'What is your current work situation?':
        'Ki sitiyasyon travay ou ye kounye a?',
      'Unemployed': 'Chomaj',
      'Part time or temporary work': 'Tan pasyèl oswa travay tanporè',
      'Full time work': 'Travay a tan plen',
      'Otherwise unemployed but not seeking work (ex. student, retired, disabled, unpaid primary care giver)':
        'Otreman pap travay men pa chèche travay (egzanp elèv, retrete, andikape, moun k ap bay swen prensipal ki pa peye)',
      'What is your main insurance?': 'Ki asirans prensipal ou?',
      'None/uninsured': 'Okenn/pa gen asirans',
      'CHIP Medicaid': 'CHIP Medicaid',
      'Medicaid': 'Medicaid',
      'Medicare': 'Medicare',
      'Other public insurance (not CHIP)': 'Lòt asirans piblik ( Ki pa CHIP)',
      'Other public insurance (CHIP)': 'Lòt asirans piblik (CHIP)',
      'Private insurance': 'Asirans prive',
      'During the past year, what was the total combined income for you and the family members you live with?':
        'Pandan ane ki sot pase la, ki sa ki revni total konbine pou ou ak manm fanmi ou ap viv avèk yo a?',
      'In the past year, have you or any family members you live with been unable to get any of the following when it was really needed? Select all that apply.':
        'Nan ane ki sot pase la, èske oumenm oswa nenpòt manm fanmi ou ke ou ap viv avèk yo la pa t kapab jwenn okenn nan sa ki vinn apre yo la lè li te vrèman nesesè? Chwazi tout sa ki aplike.',
      'Food': 'Manje',
      'Utilities': 'Gaz, Dlo, Kouran',
      'Clothing': 'Rad',
      'Childcare': 'gadri',
      'Medicine or Any Health Care (Medical, Dental, Mental Health, Vision)':
        'Medikaman oswa nenpòt swen sante (medikal, dantè, sante mantal, vizyon)',
      'Phone': 'Telefòn',
      'Other necessities': 'Lòt nesesite',
      'I choose not to answer this question':
        'Mwen chwazi pa reponn kesyon sa a',
      'Has lack of transportation kept you from medical appointments, meetings, work, or from getting things needed for daily living?':
        'Èske mank transpò te anpeche w ale nan randevou medikal, reyinyon, travay, oswa anpeche w jwenn bagay ki nesesè pou lavi chak jou ou?',
      'Yes it has kept me from medical and non-medical appointments':
        'Wi, sa te anpeche m ale nan randevou medikal ak randevou ki pa medikal',
      'It has kept me from MEDICAL appointments':
        'Sa te anpeche m ale nan randevou medikal',
      'It has kept me from NON-MEDICAL appointments':
        'sa te anpeche m ale nan randevou ki pa medikal',
      'How often do you see or talk to people that you care about and feel close to?':
        'Konbyen fwa ou wè oswa pale ak moun ke ou renmen epi ke ou santi ki pwòch ou?',
      'Less than once a week': 'Mwens pase yon fwa pa semèn',
      '1 or 2 times a week': '1 oswa 2 fwa pa semèn',
      '3 or 5 times a week': '3 oswa 5 fwa pa semèn',
      '5 or more times a week': '5 fwa oswa plis fwa nan yon semèn',
      'How stressed are you?': 'Ki jan estrès ou ye? A ki nivo ke ou estrese ?',
      'A little bit': 'Yon ti kal',
      'Somewhat': 'Yon ti jan',
      'Quite a bit': 'Yon bon jan',
      'What is stress?': 'Ki sa ki estrès?',
      'Stress is when someone feels tense, nervous, anxious, or can’t sleep at night because their mind is troubled.':
        'Estrès se lè yon moun santi l sou tansyon, nève, enkyete, oswa li pa ka dòmi lannwit paske lespri li boulvèse.',
      'In the past year, have you spent more than 2 nights in a row in a jail, prison, detention center, or juvenile correctional facility?':
        'Nan ane ki sot pase a, èske w te pase plis pase 2 nwit sou yon ban prizon, nan prizon, yon sant detansyon, oswa yon sant koreksyonèl pou timoun?',
      'Are you a refugee?': 'Èske w se yon refijye?',
      'Do you feel physically and emotionally safe where you currently live?':
        'Èske w santi w an sekirite fizikman ak emosyonèlman kote w ap viv kounye a?',
      'Unsure': 'Pa sèten',
      'In the past year, have you been afraid of your partner or ex-partner?':
        'Nan ane ki sot pase a, èske ou te pè patnè ou oswa ansyen patnè ou a?',
      'Have not had partner in last year':
        'Pa te gen patnè nan ane ki sot pase a',
    },
  },
  km: {
    translation: {
      ' is required': ' គឺ​តំរូវ​អោយ​មាន',
      'Address Line 1': 'អាស័យដ្ធានជួរទី 1',
      'Address Line 2': 'អាស័យដ្ធានជួរទី 2',
      'By continuing, you agree to our':
        'តាមរយៈការបន្ត អ្នកយល់ព្រមចំពោះរបស់យើង។',
      'Cancel': 'បោះបង់',
      'Change Language': 'ប្ដូរ​ភាសា',
      'City': 'ទីក្រុង',
      'Confirming your appointment...': 'បញ្ចាក់ការណាត់ជួបរបស់លោកអ្នក...',
      'Continue': 'បន្ត',
      'Date of birth': 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
      'Edit': 'ផ្ទៀងផ្ទាត់',
      'enterAddress': 'បញ្ចូលអាសយដ្ឋានរបស់អ្នក',
      'Female': 'ភេទស្រី',
      'Fetching available time slots...': 'កន្លែងសមស្រប សម្រាប់ការណាត់ជួប...',
      'Finish': 'បញ្ចប់',
      'For your security,': 'សម្រាប់សុវត្តិភាពរបស់លោកអ្នក',
      'For your security, in which of the following ZIP codes do you reside?':
        'សំរាប់សន្តិសុខរបស់អ្នក តើលេខកូដតំបន់មួយណា ដែលអ្នករស់នៅ ?',
      'invalidAddress': 'អាសយដ្ឋានមិនត្រឹមត្រូវ',
      'invalidInputError': "{{type}}មិនត្រឹមត្រូវនៅក្នុងវាល '{{label}}'។",
      'Invalid zip selected, please select/unselect the correct zip and try again.':
        'បានជ្រើសរើស​​/មិនបានជ្រើសរើស លើលេខកូដដំបន់ត្រឹមត្រូវ ហើយព្យាយាមម្ដងទៀត។',
      'invalidZipcode': 'លេខកូដតំបន់មិនត្រឹមត្រូវ',
      'Last name': 'នាមត្រកូល',
      'Last name and date of birth must be provided.':
        'ត្រូវមាន នាមត្រកូល និងថ្ងៃខែធ្នាំកំណើត',
      'Loading...': 'កុំពុងដំណើរការ...',
      'Male': 'ភេទប្រុស',
      'Max login attempts reached. Please contact your provider for support.':
        'ព្យាយាមចូលដល់កំណត់ ។   សូមទាក់ទងអ្នកផ្តល់សេវាកម្មរបស់អ្នក សំរាប់ជំនួយ ។',
      'Need help signing in?': 'ត្រូវការជំនួយក្នុងការចូល?',
      'Negative Feedback': 'មតិអវិជ្ជមាន',
      'Non-Binary': 'មិនមែន ទាំងពីរភេទ',
      'number': 'លេខ',
      'Patient date of birth': 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
      'Patient last name': 'នាមត្រកូល',
      'Please don’t share any sensitive personal information, as this feedback will be shared with non-clinical members of our team to improve the experience.':
        'សូមកុំចែករំលែកព័ត៌មានផ្ទាល់ខ្លួនរសើបណាមួយព្រោះថាមតិប្រតិកម្មនេះនឹងត្រូវចែករំលែកដល់សមាជិកមិនមែនគ្លីនិកនៃក្រុមរបស់យើងដើម្បីបង្កើនបទពិសោធន៍។',
      "Please enter the patient's date of birth and last name.":
        'សូមវាយចូលថ្ងៃ ខែ ធ្នាំ កំណើតរបស់អ្នកជម្ងឺ',
      'Please explain (optional)': 'សូមពន្យល់ (ស្រេចចិត្ត)',
      'Positive Feedback': 'មតិប្រតិកម្មវិជ្ជមាន',
      'Save': 'រក្សាទុក',
      'Select a language': 'ជ្រើសរើសភាសា',
      'Sign in': 'ចុះហត្ថលេខា',
      'sign in to continue.': 'ចុះហត្ថលេខា ដើម្បីបន្ត',
      'Something went wrong. Please refresh or contact the practice for support.':
        'មាន​អ្វីមួយ​មិនត្រឹមត្រូវ សូមចុចសាឡើងវិញ ឬ ទាក់ទងទៅអ្នកធ្វើការសំរាប់ជំនួយ។',
      'Start': 'ចាប់ផ្ដើម,',
      'State': 'រដ្',
      'Tell us what you loved! (optional)':
        'សូមពួកយើងនូវអ្វីដែលអ្នកស្រឡាញ់ពេញចិត្ត!  (តាមជម្រើស)',
      'The appointment could not be scheduled, please select another date or time.':
        'ការណាត់ជួបពុំអាច ដាក់នៅពេលនេះទេ សូមជ្រើសរើសថ្ងៃ ឬពេលវេលាផ្សេងទៀត។',
      'Terms of Use': 'ច្បាប់ប្រើប្រាស់របស់យើង។',
      'There was an error. Please try again.':
        'មាន​កំហុស​មួយ​គឺ។ សូម​ព្យាយាម​ម្តង​ទៀត។',
      'There was an error logging in.': 'មានការរអាក់រអួលក្នុងការចូល។',
      'This application requires your browser to have cookies enabled. Change your privacy settings and refresh the page to login.':
        'កម្មវិធីនេះ តម្រូវឲ្យ កម្មវិធីរុករករបស់អ្នកបើកខូឃីស៍។ ផ្លាស់ប្តូរការកំណត់ភាពឯកជនរបស់អ្នកហើយផ្ទុកទំព័រឡើងវិញដើម្បីចូល។',
      'This link is no longer valid. If your appointment has not already passed, please check your messages for a newer link.':
        'តំណនេះមិនមានសុពលភាពទៀតទេ។ ប្រសិនបើការណាត់ជួបរបស់អ្នកមិនទាន់បានបញ្ចប់សូមពិនិត្យមើលសាររបស់អ្នកសម្រាប់តំណថ្មីមួយ',
      'This link has expired. If your appointment has not already passed, please check your messages for a newer link.':
        'តំណនេះបានផុតកំណត់។ ប្រសិនបើការណាត់ជួបរបស់អ្នកមិនទាន់បានបញ្ចប់សូមពិនិត្យមើលសាររបស់អ្នកសម្រាប់តំណថ្មីមួយ។',
      'To make a change please let us know when you check in for your appointment.':
        'ដើម្បីធ្វើការផ្លាស់ប្តូរសូមប្រាប់យើងពេលណាអ្នកចូលណាត់ជួបអ្នក។',
      'Today,': 'ថ្ងៃនេះ',
      'today at': 'ថ្ងៃនេះនៅ',
      'Tmrw,': 'ថ្ងៃស្អែក',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'ការប្រើផ្នែកនេះ គឺសម្រាប់ទំនាក់ទំនងមិនបន្ទាន់តែប៉ុនោះ ហើយការឆ្លើយតបអាចឬមិនបានពិនិត្យដោយគ្រូពេទ្យរបស់អ្នក។ ប្រសិនបើលោកអ្នកត្រូវការឆ្លើយតបភ្លាមៗ សូមទូរស័ព្ទទៅការិយាល័យ គ្រូពេទ្យរបស់លោកអ្នក ដោយផ្ទាល់។ នៅក្នុងករណីសង្គ្រោះជាអាសន្ន ចុចលេខ 911 ឬ្ ចូលទៅ បន្ទប់សង្គ្រោះជាអាសន្ន ដែលនៅជិតបំផុត ភ្លាមៗ។',
      'Was this experience easy to use?': 'តើបទពិសោធន៍នេះងាយស្រួលប្រើទេ?',
      'We no longer have any available vaccine slots, but you have been added to our waitlist. We will be contacting you to schedule once there are more availabilities.':
        'យើងពុំមានចន្លោះទំនេរ សម្រាប់ដាក់ការណាត់ជួប ចាក់វាក់សំាង ទៀតទេ ប៉ុន្តែយើងបានដាក់ឈ្មោះរបស់លោកអ្នក នៅក្នុងបញ្ជីរោងចំារបស់យើង។ យើងនឺងទាក់ទងទៅ លោកអ្នកដើម្បីដាក់ការណាត់ជួប នៅពេលយើងមានចន្លោះទំនេរ។',
      'What made the experience challenging?':
        'តើអ្វីដែលធ្វើឱ្យបទពិសោធន៍មានការពិបាក?',
      'What made the experience easy to use?':
        'តើអ្វីទៅដែលធ្វើអោយបទពិសោធន៍នេះ ងាយស្រួលប្រើប្រាស់? ',
      'yesterday at': 'កាលពីម្សិលមិញនៅ',
      'You submitted this': 'អ្នកបានដាក់ស្នើនេះ',
      'Your appointment is confirmed.': 'ការណាត់ជួបរបស់អ្នក ត្រូវបានបញ្ចាក់',
      'Zip code': 'លេខ​កូដ​តំបន់',
      'Zip Code': 'លេខ​កូដ​តំបន់',
    },
  },
  pt: {
    translation: {
      ' is required': ' é necessário',
      'Address Line 1': 'Endereço Linha 1',
      'Address Line 2': 'Endereço Linha 2',
      'By continuing, you agree to our':
        'Ao continuar, você concorda com nossos',
      'Cancel': 'Cancelar',
      'Change Language': 'Mudar idioma',
      'City': 'Cidade',
      'Confirming your appointment...': 'Confirmando a sua consulta...',
      'Continue': 'Continuar',
      'Date of birth': 'Data de nascimento',
      'Edit': 'Editar',
      'Female': 'Feminino',
      'Fetching available time slots...': 'Buscando horários disponíveis...',
      'Finish': 'Terminar',
      'For your security,': 'Para sua segurança,',
      'For your security, in which of the following ZIP codes do you reside?':
        'Para sua segurança, em qual dos seguintes códigos postais você reside?',
      'Invalid zip selected, please select/unselect the correct zip and try again.':
        'Zip selecionado invalído, por favor selecione/ desmarque o zip correto e tente novamente.',
      'Last name': 'Sobrenome',
      'Last name and date of birth must be provided.':
        'Sobrenome e a data de nascimento devem ser fornecidos.',
      'Loading...': 'Carregando...',
      'Male': 'Masculino',
      'Max login attempts reached. Please contact your provider for support.':
        'Máximo de tentativas de login alcançadas. Entre em contato com seu provedor para obter suporte.',
      'Need help signing in?': 'Precisa de ajuda para fazer login?',
      'Negative Feedback': 'Avaliação negativa',
      'Non-Binary': 'Não-binário',
      'Patient date of birth': 'Data de nascimento do paciente',
      'Patient last name': 'Sobrenome',
      'Please don’t share any sensitive personal information, as this feedback will be shared with non-clinical members of our team to improve the experience.':
        'Não compartilhe nenhuma informação pessoal sensível, pois este feedback será compartilhado com membros não clínicos de nossa equipe para melhorar a experiência.',
      "Please enter the patient's date of birth and last name.":
        'Insira a data de nascimento e o sobrenome do paciente.',
      'Please explain (optional)': 'Explique (opcional)',
      'Positive Feedback': 'Feedback Positivo',
      'Save': 'Salve',
      'Select a language': 'Selecione um idioma',
      'Sign in': 'Entrar',
      'Something went wrong. Please refresh or contact the practice for support.':
        'Algo deu errado. Atualize ou entre em contato com o consultório para obter suporte.',
      'Start': 'Começar',
      'State': 'Estado',
      'Tell us what you loved! (optional)': 'Diga-nos o que amou! (opcional)',
      'Terms of Use': 'Termos de Uso',
      'The appointment could not be scheduled, please select another date or time.':
        'A consulta não pôde ser agendada,por favor escolha outro dia ou horário',
      'There was an error logging in.': 'Ocorreu um erro ao iniciar a sessão.',
      'There was an error. Please try again.':
        'Havia um erro. Por favor, tente novamente.',
      'This application requires your browser to have cookies enabled. Change your privacy settings and refresh the page to login.':
        'Este aplicativo requer que os cookies do seu navegador estejam ativados. Altere suas configurações de privacidade e atualize a página para fazer o login.',
      'This link has expired. If your appointment has not already passed, please check your messages for a newer link.':
        'Este link expirou. Se o seu compromisso ainda não tiver passado, verifique suas mensagens para obter um link mais recente.',
      'This link is no longer valid. If your appointment has not already passed, please check your messages for a newer link.':
        'Este link nao e mais valído. Se a sua consulta ainda não ocorreu, por favor verifique suas mensagens para obter um link novo.',
      'Tmrw,': 'Amanhã,',
      'To make a change please let us know when you check in for your appointment.':
        'Para fazer uma alteração, avise-nos quando fizer o check-in para o seu agendamento.',
      'Today,': 'Hoje,',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'O uso desta ferramenta é apenas para comunicações sem urgência e as respostas não podem ser revisadas pelo seu provedor. Se você precisar de uma resposta imediata, ligue diretamente para o escritório do seu provedor. No caso de uma emergência médica, ligue para o 911 ou vá imediatamente para o hospital mais próximo.',
      'Was this experience easy to use?': 'Essa experiência foi fácil de usar?',
      'We no longer have any available vaccine slots, but you have been added to our waitlist. We will be contacting you to schedule once there are more availabilities.':
        'Não temos mais vagas disponíveis para a vacina, mas adicionámos o seu nome à nossa lista de espera.Entraremos em contato para agendar assim que houver mais disponibilidade.',
      'What made the experience challenging?':
        'O que tornou a expeciência desafiadora?',
      'What made the experience easy to use?':
        'O que fez essa experiência fácil de usar?',
      'You submitted this': 'Você enviou isso',
      'Your appointment is confirmed.': 'A sua consulta está confirmada.',
      'Zip Code': 'Código Postal',
      'Zip code': 'Código postal',
      'enterAddress': 'Digite seu endereço',
      'invalidAddress': 'Endereço inválido',
      'invalidInputError': "{{type}} inválido no campo '{{label}}'",
      'invalidZipcode': 'CEP inválido',
      'sign in to continue.': 'faça login para continuar',
      'today at': 'hoje às',
      'yesterday at': 'ontem às',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        'Para reagendar uma consulta, ligue para o número disponível acima com a sua consulta.',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'Responda às seguintes perguntas para ajudar a Notable Testing a se preparar para a sua próxima consulta.',
      'Patient Registration': 'Registo de paciente',
      'Payments & Insurance': 'Pagamentos e seguros',
      'Mailing Address': 'Morada para enviar correspondência',
      'Email Address (if you do not have an email, enter NA@test.com)':
        'Endereço de e-mail (se não tiver um e-mail, insira NA@test.com)',
      'Cell Phone Number': 'Número de celular',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        'Número de telefone residencial (deixe em branco se não tiver um número de telefone residencial)',
      'What race do you most identify with?':
        'Com que raça você mais se identifica?',
      'American Indian': 'Nativo-americano',
      'Asian': 'Asiático',
      'Black or African American': 'Negro ou afro-americano',
      'White or Caucasian': 'Branco ou caucasiano',
      'Native Hawaiian or Pacific Islander':
        'Nativo do Havaí ou de outra ilha do Pacífico',
      'other': 'Outro',
      'Do not wish to provide': 'Prefiro não dizer',
      'What is your ethnicity?': 'Qual é a sua etnia?',
      'Hispanic, Latino, or Spanish Origin':
        'Origem hispânica, latina ou espanhola',
      'Not Hispanic, Latino, or Spanish Origin':
        'Origem não hispânica, latina ou espanhola',
      'What is your preferred Language': 'Qual é o seu idioma preferido',
      'Please list your emergency contact and their relationship to the patient':
        'Liste o seu contato de emergência e a relação dele com o paciente',
      'First Name': 'Nome',
      'First name': 'Nome',
      'Last Name': 'Sobrenome',
      'Relationship': 'Parentesco',
      'Child': 'Filho ou filha',
      'Spouse': 'Cônjuge',
      'Life Partner': 'Companheiro',
      'Other': 'Outro',
      'Phone Number': 'Número de telefone',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '"Liste o seu contato de emergência e a relação dele com o paciente" é obrigatório',
      'Do you need an interpreter for a spoken language or ASL?':
        'Você precisa de um intérprete para uma língua falada ou linguagem de surdos dos EUA?',
      'Yes': 'Sim',
      'No': 'Não',
      'Are you an MIT student?': 'Você é um estudante do MIT?',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        'Esta consulta está relacionada a um acidente, lesão de trabalho ou visita do DOT, ou você está autorizado a receber cuidados aqui como parte de seu trabalho?',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        'Para garantir que nossas informações de faturamento estejam corretas, verifique sua cobertura para esta consulta na recepção quando chegar.',
      'Remove': 'Remover',
      'Confirm Insurance': 'Confirmar o seguro',
      'Add another Insurance': 'Adicionar outro seguro',
      "Don't Use Insurance": 'Não usar o seguro',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        'Sem adicionar um seguro, você pode ser totalmente responsável pelas suas despesas médicas.',
      'Go back': 'Voltar',
      'Please upload images of the front and back of your insurance card.':
        'Envie as imagens da frente e do verso do seu cartão de seguro.',
      'Add the front of your card': 'Adicionar a frente do seu cartão',
      'Add the back of your card': 'Adicionar o verso do seu cartão',
      'Upload': 'Enviar',
      'Capture': 'Capturar',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        'Não é possível ler as informações do seu cartão. Adicionar as informações que faltam abaixo para continuar adicionando a cobertura de seguro.',
      'Insurance provider': 'Provedor de seguro',
      "Don't add this card": 'Não adicionar este cartão',
      'Member ID': 'Identidade de membro',
      'Group number': 'Número do grupo',
      'Coverage start date': 'Data de início da cobertura',
      'Fill this out now to save time at your next appointment':
        'Preencha isto agora para economizar tempo em sua próxima consulta',
      'Please select or add the policyholder for this new card.':
        'Selecione ou adicione o segurado para este novo cartão.',
      'Who is the insurance policyholder?': 'Quem é o segurado?',
      'More information': 'Mais Informações',
      'Who is my subscriber?': 'Quem é meu assinante?',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        'O assinante é a pessoa que paga as propinas do seguro saúde ou cujo vínculo empregatício é a base para a adesão ao plano de seguro.',
      'Was this helpful?': 'Isso foi útil?',
      'Someone else': 'Outra pessoa',
      'Birth date': 'Data de nascimento',
      'Sex': 'Sexo',
      'Mailing address': 'Endereço para correspondência',
      'same as patient': 'o mesmo que o do paciente',
      'use different address': 'usar endereço diferente',
      'Mobile phone number (optional)': 'Número de celular (opcional)',
      'Employment status': 'Situação de emprego',
      'Not employed': 'Desempregado',
      'Self employed': 'Profissional autônomo',
      'Student full time': 'Estudante em tempo integral',
      'Full time': 'Tempo total',
      'Unknown': 'Desconhecido',
      'Disabled': 'Deficiente',
      'Retired': 'Aposentado',
      'Part time': 'Tempo parcial',
      'Student part time': 'Estudante em meio período',
      'How is the patient related to the person who owns the insurance policy?':
        'Qual é a relação entre o paciente e o titular da apólice de seguro?',
      "This person is the patient's...": 'Essa pessoa é...',
      'Self': 'O próprio paciente',
      'Parent': 'Pai ou mãe',
      'Guardian': 'Guardião',
      'Review & pay your co-pay': 'Revise e pague seu copagamento',
      'Co-pay': 'Copagamento',
      'Prior Balance': 'Saldo anterior',
      'Total': 'Total',
      'Full payment is not required at this time but will save you time when you arrive.':
        'O pagamento integral não é exigido neste momento, mas você poupará tempo quando chegar se o fizer agora.',
      'Continue to Payment': 'Continuar para o pagamento',
      'Pay Later': 'Pagar depois',
      'Please choose a payment method below.':
        'Escolha um método de pagamento abaixo.',
      'use a different payment method': 'usar uma forma de pagamento diferente',
      'Email me a receipt': 'Enviar um recibo por e-mail',
      'pay total due': 'pagar o total devido',
      "I''ll pay later": 'Pagarei mais tarde',
      'Review and edit any personal information that has changed':
        'Revise e edite quaisquer informações pessoais que tenham sido alteradas',
      'Personal Information': 'Informações pessoais',
      'Demographics': 'Dados demográficos',
      'Insurance Cards': 'Cartões de seguro',
      'Primary Care Providers': 'Prestadores de cuidados primários',
      'Confirm your upcoming appointment': 'Confirme a sua próxima consulta',
      'Confirm or Cancel': 'Confirmar ou cancelar',
      'This will speed up your check-in process.':
        'Isto irá acelerar o seu processo de check-in.',
      'Emergency Contact': 'Contatos de emergência',
      'Cancellation window has passed': 'A janela de cancelamento já passou',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        'O cancelamento de consultas dentro de 60 minutos exigirá uma chamada por telefone para a clínica listada acima.',
      'Select the appointment you would like to cancel.':
        'Selecione a consulta que você deseja cancelar.',
      'Cancel appointment': 'Cancela a consulta',
      'Patient Last name': 'Sobrenome do paciente',
      'Please confirm the following appointments:':
        'Confirme as seguintes consultas:',
      'Reschedule or cancel appointment': 'Reagendar ou cancelar a consulta',
      'Yes, confirm all': 'Sim, confirmar tudo',
      'Thank you for your response. We look forward to your upcoming appointments.':
        'Obrigado pela sua resposta. Aguardamos suas próximas consultas.',
      'Confirmed': 'Confirmado',
      'Save time later by completing your registration now':
        'Poupe tempo mais tarde e preencha o seu registo agora',
      'Complete my registration': 'Concluir o meu cadastro',
    },
  },
  bn: {
    translation: {
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'চালিয়ে গিয়ে, আপনি আমাদের ব্যবহারের শর্তাবলীতে সম্মত হচ্ছেন। এই টুলটি শুধুমাত্র জরুরী নয় এমন যোগাযোগের জন্য ব্যবহার করা হবে এবং এর প্রতিক্রিয়া আপনার প্রদানকারী পর্যালোচনা নাও করতে পারেন। আপনার অবিলম্বে প্রতিক্রিয়ার প্রয়োজন হলে, সরাসরি প্রদানকারীর অফিসে কল করুন। চিকিৎসাগত জরুরী পরিস্থিতি সৃষ্টি হলে, 911 ডায়াল করুন বা অবিলম্বে নিকটতম এমারজেন্সি রুমে যান।',
      'Patient date of birth': 'রোগীর জন্ম তারিখ',
      'Patient Last name': 'রোগীর পদবি',
      'Sign in': 'সাইন ইন করুন',
      'Please confirm the following appointments:':
        'অনুগ্রহ করে নিম্নলিখিত অ্যাপয়েন্টমেন্টগুলি নিশ্চিত করুন:',
      'Reschedule or cancel appointment':
        'অ্যাপয়েন্টমেন্টের সময়সূচি পুনঃনির্ধারণ বা বাতিল করুন',
      'Yes, confirm all': 'হ্যাঁ, সব নিশ্চিত করুন',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        ' অ্যাপয়েন্টমেন্টের সময়সূচি পুনঃনির্ধারণ করার জন্য, অনুগ্রহ করে উপরে আপনার অ্যাপয়েন্টমেন্টে দেওয়া নম্বরটিতে কল করুন৷',
      'Thank you for your response. We look forward to your upcoming appointments.':
        'আপনার প্রতিক্রিয়ার জন্য আপনাকে ধন্যবাদ জানাই। আমরা আপনার আগামী অ্যাপয়েন্টমেন্টের অপেক্ষা করছি।',
      'Confirmed': 'নিশ্চিত করা হয়েছে',
      'Save time later by completing your registration now':
        'এখনই আপনার নিবন্ধন সম্পূর্ণ করে সময় বাঁচান',
      'Complete my registration': 'আমার নিবন্ধন সম্পূর্ণ করুন',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'নিম্নলিখিত প্রশ্নের উত্তর দিন, যাতে নোটেবল টেস্টিং আপনার আগামী ভিজিটের জন্য প্রস্তুতি নিতে পারে।',
      'Patient Registration': 'রোগীর নিবন্ধন',
      'Payments & Insurance': 'পেমেন্ট ও বীমা',
      'Mailing Address': 'চিঠি পাঠানোর ঠিকানা',
      'Mailing address': 'চিঠি পাঠানোর ঠিকানা',
      'Email Address (if you do not have an email, enter NA@test.com)':
        'ইমেল অ্যাড্রেস (যদি আপনার ইমেল না থাকে, তবে NA@test.com লিখুন)',
      'Cell Phone Number': 'সেল ফোন নম্বর',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        'বাড়ির ফোন নম্বর (আপনার বাড়ির ফোন নম্বর না থাকলে, ক্ষেত্রটি ফাঁকা রাখুন)',
      'What race do you most identify with?':
        'আপনার বর্ণসত্তা কোনটির সাথে মেলে?',
      'American Indian': 'আমেরিকান ইন্ডিয়ান',
      'Asian': 'এশীয়',
      'Black or African American': 'কৃষ্ণাঙ্গ বা আফ্রিকান আমেরিকান',
      'White or Caucasian': 'শ্বেতাঙ্গ বা ককেশীয়',
      'Native Hawaiian or Pacific Islander':
        'হাওয়াইয়ের আদি নিবাসী বা প্রশান্ত মহাসাগরীয় দ্বীপবাসী',
      'other': 'অন্যান্য',
      'Do not wish to provide': 'জানাতে অনিচ্ছুক',
      'What is your ethnicity?': 'আপনার জাতিগত উৎস কী?',
      'Hispanic, Latino, or Spanish Origin':
        'হিস্পানিক, ল্যাটিনো বা স্পেনীয় উৎস',
      'Not Hispanic, Latino, or Spanish Origin':
        'হিস্পানিক, ল্যাটিনো বা স্পেনীয় উৎস নয়',
      'What is your preferred Language': 'আপনার পছন্দের ভাষা কী',
      'Please list your emergency contact and their relationship to the patient':
        'অনুগ্রহ করে জরুরি সময় যার সাথে যোগাযোগ করা হবে তার নম্বর এবং রোগীর সাথে তার সম্পর্ক উল্লেখ করুন',
      'First Name': 'নাম',
      'First name': 'নাম',
      'Last Name': 'পদবি',
      'Last name': 'পদবি',
      'Relationship': 'সম্পর্ক',
      'Child': 'সন্তান',
      'Spouse': 'স্বামী/স্ত্রী',
      'Life Partner': 'জীবনসঙ্গী',
      'Other': 'অন্যান্য',
      'Phone Number': 'ফোন নম্বর',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '“অনুগ্রহ করে জরুরি সময় যার সাথে যোগাযোগ করা হবে তার নম্বর এবং রোগীর সাথে তার সম্পর্ক উল্লেখ করুন”-এই তথ্যটি প্রয়োজনীয়',
      'Do you need an interpreter for a spoken language or ASL?':
        'আপনার কি কোনও কথ্য ভাষার জন্য দোভাষী প্রয়োজন না কি ASL-এর প্রয়োজন?',
      'Yes': 'হ্যাঁ',
      'No': 'না',
      'Are you an MIT student?': 'আপনি কি MIT-এর শিক্ষার্থী?',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        'এই অ্যাপয়েন্টমেন্টটি কি কোনো দুর্ঘটনা, কাজ সম্পর্কিত আঘাত, বা DOT ভিজিটের সাথে সম্পর্কিত, না কি আপনি আপনার কাজের অংশ হিসাবে এখানে পরিচর্যা পাওয়ার জন্য অনুমোদিত?',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        ' আমাদের বিল সংক্রান্ত তথ্য সঠিক কি না, তা নিশ্চিত করতে, আপনি পৌঁছানোর পর ফ্রন্ট ডেস্ক থেকে এই ভিজিটের জন্য আপনার কভারেজ যাচাই করুন।',
      'Continue': 'চালিয়ে যান',
      'Edit': 'সম্পাদনা করুন',
      'Finish': 'শেষ করুন',
      'Remove': 'সরিয়ে দিন',
      'Confirm Insurance': 'বীমা নিশ্চিত করুন',
      'Add another Insurance': 'অন্য একটি বীমা যোগ করুন',
      "Don't Use Insurance": 'বীমা ব্যবহার করবেন না',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        'বীমা যোগ না করলে, আপনি নিজের চিকিৎসা বিল পরিশোধের ক্ষেত্রে সম্পূর্ণরূপে দায়ী থাকতে পারেন।',
      'Go back': 'ফিরে যান',
      'Please upload images of the front and back of your insurance card.':
        'আপনার বীমা কার্ডের সামনে এবং পিছন দিকের ছবি আপলোড করুন।',
      'Add the front of your card': 'আপনার কার্ডের সামনের দিকের ছবি যোগ করুন',
      'Add the back of your card': 'আপনার কার্ডের পিছন দিকের ছবি যোগ করুন',
      'Upload': 'আপলোড করুন',
      'Capture': 'ক্যাপচার করুন',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        'আপনার কার্ডের তথ্য পড়া যায়নি। বীমার কভারেজ যোগ করা চালিয়ে যেতে, নিচে অনুপস্থিত তথ্য যোগ করুন।',
      'Insurance provider': 'বীমা প্রদানকারী',
      "Don't add this card": 'এই কার্ড যোগ করবেন না',
      'Member ID': 'সদস্য ID',
      'Group number': 'গ্রুপের নম্বর',
      'Coverage start date': 'কভারেজ সূচনার তারিখ',
      'Fill this out now to save time at your next appointment':
        'পরবর্তী অ্যাপয়েন্টমেন্টে, সময় বাঁচানোর জন্য, এটা এখনই পূরণ করুন',
      'Please select or add the policyholder for this new card.':
        'অনুগ্রহ করে এই নতুন কার্ডের পলিসিহোল্ডার বেছে নিন বা যোগ করুন।',
      'Who is the insurance policyholder?': 'বীমার পলিসিহোল্ডার কে?',
      'More information': 'আরও তথ্য',
      'Who is my subscriber?': 'আমার সাবস্ক্রাইবার কে?',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        'যিনি স্বাস্থ্য বীমা প্রিমিয়ামের অর্থ প্রদান করেন বা যার কর্মসংস্থানের ভিত্তিতে এই বীমা পরিকল্পনার সদস্যতা প্রাপ্ত হয়েছে, তিনিই হলেন সাবস্ক্রাইবার।',
      'Was this helpful?': 'এটা কি আপনার জন্য সহায়ক ছিল?',
      'Someone else': 'অন্য কেউ',
      'Birth date': 'জন্ম তারিখ',
      'Sex': 'লিঙ্গ',
      'Female': 'মহিলা',
      'Male': 'পুরুষ',
      'same as patient': 'রোগীর দেওয়া তথ্যের সাথে হুবহু মেলে',
      'use different address': 'অন্য ঠিকানা ব্যবহার করুন',
      'Mobile phone number (optional)': 'মোবাইল ফোন নম্বর (ঐচ্ছিক)',
      'Employment status': 'কর্মসংস্থানের অবস্থা',
      'Not employed': 'কর্মহীন',
      'Self employed': 'স্বনির্ভর',
      'Student full time': 'পূর্ণ সময়ের জন্য শিক্ষার্থী',
      'Full time': 'পূর্ণ সময়',
      'Unknown': 'অজানা',
      'Disabled': 'প্রতিবন্ধী',
      'Retired': 'অবসরপ্রাপ্ত',
      'Part time': 'আংশিক সময়ের',
      'Student part time': 'আংশিক সময়ের জন্য শিক্ষার্থী',
      'How is the patient related to the person who owns the insurance policy?':
        'যে ব্যক্তি বীমা পলিসি করিয়েছেন, তার সাথে রোগীর সম্পর্ক কী?',
      "This person is the patient's...": 'এই ব্যক্তি হল রোগীর...',
      'Self': 'নিজে রোগী',
      'Parent': 'পিতামাতা',
      'Guardian': 'অভিভাবক',
      'Review & pay your co-pay': 'পর্যালোচনা করুন এবং আপনার কো-পে প্রদান করুন',
      'Co-pay': 'কো-পে',
      'Prior Balance': 'পূর্ববর্তী ব্যালেন্স',
      'Total': 'মোট',
      'Full payment is not required at this time but will save you time when you arrive.':
        'এখন সম্পূর্ণ পেমেন্ট করার প্রয়োজন নেই, তবে করে রাখলে এসে পৌঁছনোর পর আপনার সময় বাঁচবে।',
      'Continue to Payment': 'পেমেন্ট করার জন্য এগিয়ে যান',
      'Pay Later': 'পরে পেমেন্ট করুন',
      'Please choose a payment method below.':
        'নীচের একটি পেমেন্ট পদ্ধতি বেছে নিন।',
      'use a different payment method': 'অন্য পেমেন্ট পদ্ধতি ব্যবহার করে দেখুন',
      'Email me a receipt': 'আমাকে রসিদ ইমেল করুন',
      'pay total due': 'মোট বকেয়া পরিশোধ করুন',
      "I''ll pay later": 'আমি পরে পেমেন্ট করব',
      'Review and edit any personal information that has changed':
        'কোনো ব্যক্তিগত তথ্য পরিবর্তিত হয়ে থাকলে, সেগুলো পর্যালোচনা ও সম্পাদনা করুন',
      'Personal Information': 'ব্যক্তিগত তথ্য',
      'Demographics': 'জনসংখ্যাতত্ত্',
      'Insurance Cards': 'বীমা কার্ড',
      'Primary Care Providers': 'প্রাথমিক পরিচর্যা প্রদানকারী',
      'Confirm your upcoming appointment':
        'আপনার আগামী অ্যাপয়েন্টমেন্ট নিশ্চিত করুন',
      'Confirm or Cancel': 'নিশ্চিত করুন বা বাতিল করুন',
      'This will speed up your check-in process.':
        'এতে আপনার চেক-ইন প্রক্রিয়া দ্রুত সম্পন্ন হবে।',
      'Emergency Contact': 'জরুরী যোগাযোগ',
      'Cancellation window has passed': 'বাতিলকরণের সময় শেষ হয়ে গেছে',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        '60 মিনিটের মধ্যে অ্যাপয়েন্টমেন্ট বাতিল করার জন্য, উপরে দেওয়া ক্লিনিকে কল করতে হবে।',
      'Select the appointment you would like to cancel.':
        'আপনি যে অ্যাপয়েন্টমেন্ট বাতিল করতে চান, সেটা নির্বাচন করুন।',
      'Cancel appointment': 'অ্যাপয়েন্টমেন্ট বাতিল করুন',
    },
  },
  ja: {
    translation: {
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        '本ツールの使用は、緊急性のないコミュニケーションのみを目的としており、保険会社はあなたの回答を確認しない場合があります。ただちに返答が必要な場合は、保険会社の事務所に直接お電話ください。医療上の緊急事態が発生した場合は、911にお電話いただくか、直ちに最寄りの緊急センターに行ってください。',
      'Patient date of birth': '患者の生年月日',
      'Patient Last name': '患者の姓',
      'Sign in': 'サインイン',
      'Please confirm the following appointments:':
        '以下の予約内容をご確認ください。',
      'Reschedule or cancel appointment': '予約の変更またはキャンセル',
      'Yes, confirm all': 'すべて確認しました',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        '予約を変更する場合は、上記の予約内容に記載の番号までお電話ください。',
      'Thank you for your response. We look forward to your upcoming appointments.':
        'ご回答ありがとうございます。お会いできることを楽しみにしております。',
      'Confirmed': '確認済み',
      'Save time later by completing your registration now':
        '今すぐ登録を完了して、受診時の手間を省きましょう',
      'Complete my registration': '来院登録を完了させる',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'Notable Testingがあなたの来院に向けて準備を整えられるよう、以下の質問にご回答ください。',
      'Patient Registration': '患者登録',
      'Payments & Insurance': '支払いおよび保険',
      'Mailing Address': '住所',
      'Email Address (if you do not have an email, enter NA@test.com)':
        'メールアドレス(メールアドレスをお持ちでない場合は、NA@test.comとご入力ください)',
      'Cell Phone Number': '携帯電話番号',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        '自宅電話番号（ご自宅のお電話をお持ちでない場合は、空欄にしてください）',
      'What race do you most identify with?':
        'あなたの人種に最も近いものはどれですか？',
      'American Indian': 'アメリカ先住民',
      'Asian': 'アジア人',
      'Black or African American': '黒人またはアフリカ系アメリカ人',
      'White or Caucasian': '白人またはコーカサス人',
      'Native Hawaiian or Pacific Islander': 'ハワイ先住民または太平洋諸島住民',
      'other': 'その他',
      'Do not wish to provide': '回答を控える',
      'What is your ethnicity?': 'あなたの民族性は次のうちどれですか？',
      'Hispanic, Latino, or Spanish Origin':
        'ヒスパニック、ラテン、またはスペイン系',
      'Not Hispanic, Latino, or Spanish Origin':
        'ヒスパニック、ラテン、またはスペイン系以外',
      'What is your preferred Language': 'ご希望の言語',
      'Please list your emergency contact and their relationship to the patient':
        '緊急連絡先、および患者様との関係を記入してください',
      'First Name': '名',
      'Last Name': '姓',
      'Relationship': '関係',
      'Child': '子ども',
      'Spouse': '配偶者',
      'Life Partner': 'パートナー',
      'Other': 'その他',
      'Phone Number': '電話番号',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '「緊急連絡先、および患者様との関係を記入してください」は必須項目です',
      'Do you need an interpreter for a spoken language or ASL?':
        'あなたが話す言語への通訳、またはアメリカ手話を必要としますか？',
      'Yes': 'はい',
      'No': 'いいえ',
      'Are you an MIT student?':
        'あなたはマサチューセッツ工科大学の学生ですか？',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        '今回の予約は、事故、業務上の怪我、またはDOT受診に関連するものですか？または業務の一環としてこちらでの治療を受けることを許可されていますか？',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        '請求情報が正しいことを確認するため、ご到着されましたら受付にて今回の受診に適用される保険内容をご確認ください。',
      'Continue': '続行',
      'Edit': '編集',
      'Finish': '完了',
      'Remove': '削除する',
      'Confirm Insurance': '保険を確認する',
      'Add another Insurance': '別の保険を追加する',
      "Don't Use Insurance": '保険を使用しない',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        '保険を追加しない場合、医療費は全額自己負担となる可能性があります。',
      'Go back': '戻る',
      'Please upload images of the front and back of your insurance card.':
        '保険証の表面と裏面をアップロードしてください。',
      'Add the front of your card': '表面を追加する',
      'Add the back of your card': '裏面を追加する',
      'Upload': 'アップロード',
      'Capture': 'キャプチャ',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        '保険証の情報を読み込めませんでした。保険の追加を続行するには、以下に不足している情報を入力してください。',
      'Insurance provider': '保険会社',
      "Don't add this card": 'この保険証を追加しない',
      'Member ID': '保険番号',
      'Group number': 'グループ番号',
      'Coverage start date': '保険開始日',
      'Fill this out now to save time at your next appointment':
        '今この情報を入力いただくと、次回ご予約時の手間を省くことができます',
      'Please select or add the policyholder for this new card.':
        'この新しい保険証の契約者を選択または追加してください。',
      'Who is the insurance policyholder?': '保険契約者とは誰を指しますか？',
      'More information': '詳細情報',
      'Who is my subscriber?': '加入者とは誰を指しますか？',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        '加入者とは、健康保険料を支払う人、または保険プランに加入するための大元となる雇用主を指します。',
      'Was this helpful?': 'この情報は役に立ちましたか？',
      'Someone else': '別のかた',
      'First name': '名',
      'Last name': '姓',
      'Birth date': '生年月日',
      'Sex': '性別',
      'Female': '女性',
      'Male': '男性',
      'Mailing address': '住所',
      'same as patient': '患者様と同じ',
      'use different address': '別の住所を使用する',
      'Mobile phone number (optional)': '携帯電話番号（任意）',
      'Employment status': '雇用状況',
      'Not employed': '無職',
      'Self employed': '自営業',
      'Student full time': '学生（全日制）',
      'Full time': 'フルタイム',
      'Unknown': '不明',
      'Disabled': '障がい',
      'Retired': '定年退職',
      'Part time': 'パートタイム',
      'Student part time': '学生（半日制）',
      'How is the patient related to the person who owns the insurance policy?':
        '保険契約者様と患者様の関係',
      "This person is the patient's...": '保険契約者様は患者様の...',
      'Self': '本人',
      'Parent': '両親',
      'Guardian': '保護者',
      'Review & pay your co-pay': '確認して自己負担額を支払う',
      'Co-pay': '自己負担額',
      'Prior Balance': '繰り越し残高',
      'Total': '合計',
      'Full payment is not required at this time but will save you time when you arrive.':
        '現時点で全額お支払いいただく必要はありませんが、受診時の手間を省くことができます。',
      'Continue to Payment': 'お支払いに進む',
      'Pay Later': '後ほど支払う',
      'Please choose a payment method below.':
        'お支払方法を以下よりお選びください。',
      'use a different payment method': '別の支払い方法を利用する',
      'Email me a receipt': '領収書をメールで受け取る',
      'pay total due': '全額支払う',
      "I''ll pay later": '後ほど支払う',
      'Review and edit any personal information that has changed':
        '変更があった個人情報を確認・編集する',
      'Personal Information': '個人情報',
      'Demographics': '人口統計',
      'Insurance Cards': '保険証',
      'Primary Care Providers': 'かかりつけ医',
      'Confirm your upcoming appointment': '次回のご予約を確認',
      'This will speed up your check-in process.':
        'これによりチェックイン手続きをスムーズに行うことができます。',
      'Confirm or Cancel': '確認またはキャンセル',
      'Emergency Contact': '緊急連絡先',
      'Cancellation window has passed': 'キャンセル受付時間を過ぎています',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        'ご予約時間まで1時間を切っている場合は、上記に記載のクリニックへお電話いただく必要があります。',
      'Select the appointment you would like to cancel.':
        'キャンセルしたいご予約をお選びください。',
      'Cancel appointment': '予約のキャンセル',
    },
  },
  ko: {
    translation: {
      'Patient date of birth': '환자 생년월일',
      'Patient Last name': '환자 성(姓)',
      'Sign in': '로그인',
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        '이 도구의 사용은 비긴급성 통신용에 한하며, 귀 제공자가 응답을 검토하지 않을 수 있습니다. 즉각적인 응답이 필요한 경우, 담당 제공자 사무실로 바로 전화하십시오. 의료 응급상황의 경우, 즉시 911에 전화하거나 가장 가까운 응급실을 방문하십시오.',
      '': 'undefined',
      'Please confirm the following appointments:':
        '다음의 예약 사항을 확정해 주십시오.',
      'Reschedule or cancel appointment': '예약 일정 재설정 혹은 취소',
      'Yes, confirm all': '예, 모두 확정합니다',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        ' 예약 일정을 재설정하려면, 위 예약 사항과 함께 제공된 번호로 전화해 주십시오.',
      'Thank you for your response. We look forward to your upcoming appointments.':
        '답변해 주셔서 감사합니다. 곧 예정된 예약에서 뵙겠습니다.',
      'Confirmed': '확정됨',
      'Save time later by completing your registration now':
        '지금 등록을 완료하면 이후 시간을 절약할 수 있습니다',
      'Complete my registration': '등록 완료하기',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'Notable Testing에서 곧 있을 귀하의 방문을 준비할 수 있게 아래 질문에 답해 주십시오.',
      'Patient Registration': '환자 등록',
      'Payments & Insurance': '결제 및 보험',
      'Mailing Address': '우편 주소',
      'Mailing address': '우편 주소',
      'Email Address (if you do not have an email, enter NA@test.com)':
        '이메일 주소(이메일이 없는 경우, NA@test.com 입력)',
      'Cell Phone Number': '휴대전화 번호',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        '자택 전화번호(자택 전화번호가 없는 경우 공란으로 둘 것)',
      'What race do you most identify with?':
        '본인에게 가장 해당된다고 생각되는 인종은?',
      'American Indian': '미국 원주민',
      'Asian': '아시아계',
      'Black or African American': '흑인 혹은 아프리카계 미국인',
      'White or Caucasian': '백인',
      'Native Hawaiian or Pacific Islander':
        '하와이 원주민 또는 태평양 섬 주민',
      'other': '기타',
      'Do not wish to provide': '다음을 제공하시겠습니까?',
      'What is your ethnicity?': '민족은 어떻게 되십니까?',
      'Hispanic, Latino, or Spanish Origin': '히스패닉, 라티노 혹은 스페인계',
      'Not Hispanic, Latino, or Spanish Origin':
        '히스패닉, 라티노 혹은 스페인계 아님',
      'What is your preferred Language': '선호하는 언어는 무엇입니까',
      'Please list your emergency contact and their relationship to the patient':
        '비상 연락처와 해당인의 환자와의 관계를 열거해 주십시오',
      'First Name': '이름',
      'First name': '이름',
      'Last Name': '성',
      'Last name': '성',
      'Relationship': '관계',
      'Child': '자녀',
      'Spouse': '배우자',
      'Life Partner': '파트너',
      'Other': '기타',
      'Phone Number': '전화번호',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '“비상 연락처와 해당인의 환자와의 관계를 열거해 주십시오”는 필수 입력 사항입니다',
      'Do you need an interpreter for a spoken language or ASL?':
        '음성 언어 혹은 ASL(미국 수어)을 위한 통역사가 필요하십니까?',
      'Yes': '예',
      'No': '아니요',
      'Are you an MIT student?': 'MIT 학생이십니까?',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        '이 예약이 사고, 업무 관련 부상 혹은 DOT 방문 관련인가요, 아니면 업무의 일환으로 여기에서 의료관리를 받도록 승인을 받으셨습니까?',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        ' 청구 정보가 정확한지 확인하기 위해, 도착 시 프론트데스크에서 본 방문에 대한 보장을 인증해 주십시오.',
      'Continue': '계속',
      'Edit': '편집',
      'Finish': '마치기',
      'Remove': '제거',
      'Confirm Insurance': '보험 확인',
      'Add another Insurance': '다른 보험 추가',
      "Don't Use Insurance": '보험을 사용하지 마시오',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        '보험을 추가하지 않으면 의료 고지서 본인 부담 비용에 대해 전적으로 본인이 책임져야 할 수 있습니다.',
      'Go back': '뒤로 가기',
      'Please upload images of the front and back of your insurance card.':
        '보험 카드의 앞, 뒷면 이미지를 업로드해 주십시오.',
      'Add the front of your card': '카드 앞면 추가',
      'Add the back of your card': '카드 뒷면 추가',
      'Upload': '업로드',
      'Capture': '캡쳐',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        '카드 정보를 읽을 수 없습니다. 아래에 누락 정보를 추가한 후 계속해서 보험 보장을 추가하십시오.',
      'Insurance provider': '보험 제공자',
      "Don't add this card": '이 카드를 추가하지 마시오',
      'Member ID': '회원 ID',
      'Group number': '그룹 번호',
      'Coverage start date': '보장 시작일',
      'Fill this out now to save time at your next appointment':
        '지금 작성을 완료하면 다음번 예약 시 시간을 절약할 수 있습니다',
      'Please select or add the policyholder for this new card.':
        '이 새 카드의 보험 계약자를 선택 혹은 추가해 주십시오.',
      'Who is the insurance policyholder?': '보험 계약자는 누구입니까?',
      'More information': '추가 정보',
      'Who is my subscriber?': '내 가입자는 누구입니까?',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        '가입자는 건강 보험료를 지불하는 사람 혹은 그 고용이 해당 보험 플랜의 회원자격 근간이 되는 사람입니다.',
      'Was this helpful?': '유용한 정보였나요?',
      'Someone else': '다른 누군가',
      'Birth date': '생년월일',
      'Sex': '성별',
      'Female': '여성',
      'Male': '남성',
      'same as patient': '환자와 동일',
      'use different address': '다른 주소 사용',
      'Mobile phone number (optional)': '휴대전화 번호(선택 사항)',
      'Employment status': '고용 상태',
      'Not employed': '실직',
      'Self employed': '자영',
      'Student full time': '전일제 학생',
      'Full time': '전일제',
      'Unknown': '알 수 없음',
      'Disabled': '장애',
      'Retired': '은퇴',
      'Part time': '시간제',
      'Student part time': '시간제 학생',
      'How is the patient related to the person who owns the insurance policy?':
        '환자와 보험증서를 소유한 사람과의 관계는 어떻게 되나요?',
      "This person is the patient's...": '이 사람은 환자의...',
      'Self': '본인',
      'Parent': '부모',
      'Guardian': '후견인',
      'Review & pay your co-pay': '검토 및 코페이 결제',
      'Co-pay': '코페이',
      'Prior Balance': '이전 잔액',
      'Total': '총액',
      'Full payment is not required at this time but will save you time when you arrive.':
        '지금 바로 전액을 납부해야 하는 것은 아니지만 그렇게 하시면 도착 시 시간이 절약됩니다.',
      'Continue to Payment': '결제로 계속',
      'Pay Later': '나중에 결제',
      'Please choose a payment method below.':
        '아래에서 결제 수단을 선택하십시오.',
      'use a different payment method': '다른 결제 수단 사용',
      'Email me a receipt': '영수증을 이메일로 보내주십시오',
      'pay total due': '납부 총액 결제',
      "I''ll pay later": '나중에 결제하겠습니다',
      'Review and edit any personal information that has changed':
        '검토 및 변경된 개인 정보 편집',
      'Personal Information': '개인정보',
      'Demographics': '인구통계',
      'Insurance Cards': '보험 카드',
      'Primary Care Providers': '일차 관리 제공자',
      'Confirm your upcoming appointment': '곧 예정된 예약 확정하기',
      'This will speed up your check-in process.':
        '그러면 체크인을 신속히 진행할 수 있습니다.',
      'Confirm or Cancel': '확정 혹은 취소',
      'Emergency Contact': '비상 연락처',
      'Cancellation window has passed': '취소창이 닫혔습니다',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        '60분 이내 예약 취소 시에는 위에 열거된 클리닉으로 전화 통화가 필요합니다.',
      'Select the appointment you would like to cancel.':
        '취소하려는 예약을 선택하십시오.',
      'Cancel appointment': '예약 취소',
    },
  },
  ro: {
    translation: {
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        'Utilizarea acestui instrument este doar pentru comunicări non-urgente și este posibil ca răspunsurile să nu fie revizuite de furnizorul dvs. Dacă aveți nevoie de un răspuns imediat, sunați direct la biroul furnizorului dvs. În cazul unei urgențe medicale, apelați 911 sau vizitați imediat cea mai apropiată cameră de urgență.',
      'Patient date of birth': 'Data nașterii pacientului',
      'Patient Last name': 'Numele pacientului',
      'Sign in': 'Accesați',
      'Please confirm the following appointments:':
        'Vă rugăm să confirmați următoarele programări:',
      'Reschedule or cancel appointment':
        'Reprogramați sau anulați programarea',
      'Yes, confirm all': 'Da, confirmă toate',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        'Pentru a reprograma o programare, vă rugăm să sunați la numărul furnizat mai sus împreună cu programarea dvs.',
      'Thank you for your response. We look forward to your upcoming appointments.':
        'Vă mulțumim pentru răspunsul dvs. Așteptăm cu nerăbdare programările dumneavoastră viitoare.',
      'Confirmed': 'Confirmat',
      'Save time later by completing your registration now':
        'Economisiți timp mai târziu completând înregistrarea acum',
      'Complete my registration': 'Finalizarea înregistrării',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        'Răspundeți la următoarele întrebări pentru a ajuta Notable Testing să se pregătească pentru următoarea vizită a dvs.',
      'Patient Registration': 'Înregistrarea pacientului',
      'Payments & Insurance': 'Plăți și asigurări',
      'Mailing Address': 'Adresa poștală',
      'Mailing address': 'Adresa poștală',
      'Email Address (if you do not have an email, enter NA@test.com)':
        'Adresa Email (dacă nu aveți un e-mail, introduceți NA@test.com)',
      'Cell Phone Number': 'Numărul de telefon mobil',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        'Numărul de telefon de acasă (lăsați necompletat dacă nu aveți un număr de telefon de acasă)',
      'What race do you most identify with?':
        'Cu ce rasă vă identificați cel mai mult?',
      'American Indian': 'Indian american',
      'Asian': 'Asiatic',
      'Black or African American': 'Negru sau afro-american',
      'White or Caucasian': 'Alb sau caucazian',
      'Native Hawaiian or Pacific Islander':
        'Nativ din Hawaii sau din Pacificul',
      'other': 'alta',
      'Do not wish to provide': 'Nu doresc să răspund',
      'What is your ethnicity?': 'Care este etnia dvs?',
      'Hispanic, Latino, or Spanish Origin':
        'Origine hispanică, latină sau spaniolă',
      'Not Hispanic, Latino, or Spanish Origin':
        'Nu sunt de origine hispanică, latină sau spaniolă',
      'What is your preferred Language': 'Care este limba preferată',
      'Please list your emergency contact and their relationship to the patient':
        'Vă rugăm să enumerați contactul dumneavoastră de urgență și relația lor cu pacientul',
      'First Name': 'Nume',
      'First name': 'Nume',
      'Last Name': 'Prenume',
      'Last name': 'Prenume',
      'Relationship': 'Relația',
      'Child': 'Copil',
      'Spouse': 'Soț/soție',
      'Life Partner': 'Partener de viață',
      'Phone Number': 'Numărul de telefon',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '"Vă rugăm să enumerați contactul dumneavoastră de urgență și relația lor cu pacientul" este necesar',
      'Do you need an interpreter for a spoken language or ASL?':
        'Aveți nevoie de un interpret pentru o limbă vorbită sau ASL?',
      'Yes': 'Da',
      'No': 'Nu',
      'Are you an MIT student?': 'Sunteți student MIT?',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        'Această programare are legătură cu un accident, un accident de muncă sau o vizită DOT sau sunteți autorizat să primiți îngrijire aici ca parte a locului de muncă?',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        'Pentru a vă asigura că informațiile noastre de facturare sunt corecte, vă rugăm să verificați acoperirea pentru această vizită la recepție când ajungeți.',
      'Continue': 'Continuare',
      'Edit': 'Editare',
      'Finish': 'Finisare',
      'Remove': 'Șterge',
      'Confirm Insurance': 'Confirmă asigurarea',
      'Add another Insurance': 'Adaugă o altă asigurare',
      "Don't Use Insurance": 'Nu folosiți asigurare',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        'Fără să adăugați asigurare, puteți fi pe deplin responsabil pentru factura medicală din buzunar.',
      'Go back': 'Înapoi',
      'Please upload images of the front and back of your insurance card.':
        'Vă rugăm să încărcați imagini cu fața și spatele cardului dvs. de asigurare.',
      'Add the front of your card': 'Adăugați partea din față a cardului dvs.',
      'Add the back of your card': 'Adăugați partea din spate a cardului dvs.',
      'Upload': 'Încarcă',
      'Capture': 'Captură',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        'Nu se pot citi informațiile cardului dvs. Adăugați informațiile care lipsesc mai jos pentru a continua să adăugați acoperire de asigurare.',
      'Insurance provider': 'Furnizor de asigurări',
      "Don't add this card": 'Nu adăugați acest card',
      'Member ID': 'Membru ID',
      'Group number': 'Număr de grup',
      'Coverage start date': 'Data de începere a acoperirii',
      'Fill this out now to save time at your next appointment':
        'Completați acest lucru acum pentru a economisi timp la următoarea programare',
      'Please select or add the policyholder for this new card.':
        'Vă rugăm să selectați sau să adăugați titularul poliței pentru acest nou card.',
      'Who is the insurance policyholder?':
        'Cine este deținătorul poliței de asigurare?',
      'More information': 'Mai multe detalii',
      'Who is my subscriber?': 'Cine este abonatul meu?',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        'Abonatul este persoana care plătește primele de asigurări de sănătate sau a cărei angajare stă la baza aderării la planul de asigurare.',
      'Was this helpful?': 'A fost de ajutor?',
      'Someone else': 'Altcineva',
      'Birth date': 'Data de naștere',
      'Sex': 'Sex',
      'Female': 'Feminin',
      'Male': 'Masculin',
      'Other': 'Altul',
      'same as patient': 'la fel ca cea a pacientului',
      'use different address': 'folosește altă adresă',
      'Mobile phone number (optional)': 'Numărul de telefon mobil (opțional)',
      'Employment status': 'Statutul de angajare',
      'Not employed': 'Șomer',
      'Self employed': 'Lucrător pe cont propriu',
      'Student full time': 'Student full time',
      'Full time': 'Cu normă întreagă',
      'Unknown': 'Necunoscut',
      'Disabled': 'Dezactivat',
      'Retired': 'Pensionar',
      'Part time': 'Cu jumătate de normă',
      'Student part time': 'Student part time',
      'How is the patient related to the person who owns the insurance policy?':
        'Cum se raportează pacientul cu persoana care deține polița de asigurare?',
      "This person is the patient's...":
        'Această persoană se raportează pacientului...',
      'Self': 'Pacientul',
      'Parent': 'Părinte',
      'Guardian': 'Tutor',
      'Review & pay your co-pay': 'Examinați și plătiți co-plata',
      'Co-pay': 'Co-plata',
      'Prior Balance': 'Sold prealabil',
      'Total': 'Total',
      'Full payment is not required at this time but will save you time when you arrive.':
        'Plata integrală nu este necesară în acest moment, dar vă va economisi timp când ajungeți.',
      'Continue to Payment': 'Continuarea Plății',
      'Pay Later': 'Plătește apoi',
      'Please choose a payment method below.':
        'Vă rugăm să alegeți o metodă de plată de mai jos.',
      'use a different payment method': 'utilizați o altă metodă de plată',
      'Email me a receipt': 'Trimite-mi o chitanță prin e-mail',
      'pay total due': 'achita totalul',
      "I''ll pay later": 'Plătesc apoi',
      'Review and edit any personal information that has changed':
        'Examinați și editați orice informații personale care s-au modificat',
      'Personal Information': 'Informații personale',
      'Demographics': 'Demografie',
      'Insurance Cards': 'Carduri de Asigurare',
      'Primary Care Providers': 'Furnizorii de îngrijire primară',
      'Confirm your upcoming appointment':
        'Confirmați-vă următoarea programare',
      'This will speed up your check-in process.':
        'Acest lucru vă va accelera procesul de check-in.',
      'Confirm or Cancel': 'Confirmă sau anulează',
      'Emergency Contact': 'Contact de urgență',
      'Cancellation window has passed': 'Timpul de anulare a trecut',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        'Anularea programărilor în 60 de minute va necesita un apel la clinica enumerată mai sus.',
      'Select the appointment you would like to cancel.':
        'Selectați programarea pe care doriți să o anulați.',
      'Cancel appointment': 'Anulează programarea',
    },
  },
  zh: {
    translation: {
      "Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.":
        '此工具仅用于非紧急通信，您的提供者可能不会查看查回复。如果您需要立即回复，请直接致电提供者办公室。如果发生医疗紧急情况，请立即拨打 911 或前往最近的急诊室。',
      'Please confirm the following appointments:': '请确认以下预约：',
      'Reschedule or cancel appointment': '重新安排或取消预约',
      'Yes, confirm all': '是，全部确认',
      'To reschedule an appointment, please call the number provided with your appointment above.':
        '想要重新安排预约，请致电上述预约提供的号码。',
      'Thank you for your response. We look forward to your upcoming appointments.':
        '感谢您的回复。我们期待着您即将到来的预约',
      'Confirmed': '已确认',
      'Save time later by completing your registration now':
        '立即完成注册以节省之后的时间',
      'Complete my registration': '完成我的注册',
      'Answer the following questions to help Notable Testing prepare for your upcoming visit.':
        '回答以下问题，帮助 Notable Testing 为您即将到来的就诊做准备。',
      'Patient Registration': '患者注册',
      'Payments & Insurance': '付款和保险',
      'Mailing Address': '邮寄地址',
      'Email Address (if you do not have an email, enter NA@test.com)':
        '电子邮件地址（如果您没有电子邮件，请输入 NA@test.com)',
      'Cell Phone Number': '手机号码',
      'Home Phone Number (leave blank if you do not have a home phone number)':
        '家庭电话号码（如果您没有家庭电话号码，请留空）',
      'What race do you most identify with?': '您最认同自己属于哪个种族？',
      'American Indian': '美洲印第安人',
      'Asian': '亚裔',
      'Black or African American': '黑人或非裔美国人',
      'White or Caucasian': '白色或高加索人',
      'Native Hawaiian or Pacific Islander': '夏威夷原住民或太平洋岛民',
      'other': '其他',
      'Do not wish to provide': '不想回答',
      'What is your ethnicity?': '您的民族是什么？',
      'Hispanic, Latino, or Spanish Origin': '西班牙裔、拉丁裔或西班牙血统',
      'Not Hispanic, Latino, or Spanish Origin':
        '非西班牙裔、拉丁裔或西班牙血统',
      'What is your preferred Language': '您的首选语言是什么',
      'Please list your emergency contact and their relationship to the patient':
        '请列出您的紧急联系人及其与患者的关系',
      'First Name': '名字',
      'Last Name': '姓氏',
      'Relationship': '关系',
      'Child': '子女',
      'Spouse': '配偶',
      'Life Partner': '生活伴侣',
      'Other': '其他',
      'Phone Number': '电话号码',
      '"Please list your emergency contact and their relationship to the patient" is required':
        '“请列出您的紧急联系人及其与患者的关系”为必填项',
      'Do you need an interpreter for a spoken language or ASL?':
        '您是否需要口译员或手语译员？',
      'Yes': '是',
      'No': '否',
      'Are you an MIT student?': '您是否为 MIT 的学生？',
      'Is this appointment related to an accident, a work-related injury, or a DOT visit, or are you authorized to receive care here as part of your job?':
        '这一预约是否与事故、工伤或 DOT 就诊有关，或者您是否获得授权在这里接受护理作为您工作的一部分？',
      'To make sure our billing information is correct, please verify your coverage for this visit with the front desk when you arrive.':
        ' 为确保我们的账单信息正确，请在您到达时与前台核实您此次就诊的承保范围。',
      'Continue': '继续',
      'Edit': '编辑',
      'Finish': '完成',
      'Remove': '移除',
      'Confirm Insurance': '确认保险',
      'Add another Insurance': '添加其他保险',
      "Don't Use Insurance": '不要使用保险',
      'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.':
        '如果不添加保险，您可能会全额支付医疗费用自付额。',
      'Go back': '返回',
      'Please upload images of the front and back of your insurance card.':
        '请上传保险卡正反面图像。',
      'Add the front of your card': '添加卡的正面',
      'Add the back of your card': '添加卡的背面',
      'Upload': '上传',
      'Capture': '捕获',
      'Unable to read your card information. Add the missing information below to continue adding insurance coverage.':
        '无法读取您的保险卡的信息。添加以下缺失信息，以继续添加保险承保范围。',
      'Insurance provider': '保险提供者',
      "Don't add this card": '不要添加此卡',
      'Member ID': '会员 ID',
      'Group number': '组号',
      'Coverage start date': '承保开始日期',
      'Fill this out now to save time at your next appointment':
        '现在填写此项以在下次预约时节省时间',
      'Please select or add the policyholder for this new card.':
        '请选择或添加此新卡的保单持有人。',
      'Who is the insurance policyholder?': '谁是保单持有人？',
      'More information': '更多信息',
      'Who is my subscriber?': '谁是我的投保人？',
      'The subscriber is the person who pays for health insurance premiums or whose employment is the basis for membership in the insurance plan.':
        '投保人是支付健康保险保费的人，或者其工作是成为保险计划会员的基础。',
      'Was this helpful?': '这是否有帮助？',
      'Someone else': '其他人',
      'Birth date': '出生日期',
      'Sex': '性别',
      'Female': '女',
      'Male': '男',
      'Mailing address': '邮寄地址',
      'same as patient': '与患者相同',
      'use different address': '使用不同的地址',
      'Mobile phone number (optional)': '移动电话号码（选填）',
      'Employment status': '就业状态',
      'Not employed': '未就业',
      'Self employed': '个体经营',
      'Sign in': '登录',
      'Student full time': '学生全职',
      'First name': '名字',
      'Last name': '姓氏',
      'Full time': '全职',
      'Unknown': '未知',
      'Disabled': '残疾',
      'Retired': '已退休',
      'Part time': '兼职',
      'Student part time': '学生兼职',
      'How is the patient related to the person who owns the insurance policy?':
        '患者与拥有保险单的人员有何关系？',
      "This person is the patient's...": '此人员是患者……',
      'Self': '自己',
      'Patient date of birth': '患者出生日期',
      'Patient Last name': '患者姓氏',
      'Parent': '父母',
      'Guardian': '监护人',
      'Review & pay your co-pay': '查看并支付共付额',
      'Co-pay': '共付额',
      'Prior Balance': '前期余额',
      'Total': '总计',
      'Full payment is not required at this time but will save you time when you arrive.':
        '目前无需全额付款，但当您到达时会为您节省时间。',
      'Continue to Payment': '继续付款',
      'Pay Later': '稍后付款',
      'Please choose a payment method below.': '请在下方选择一种付款方式。',
      'use a different payment method': '使用不同的付款方式',
      'Email me a receipt': '通过电子邮件向我发送收据',
      'pay total due': '支付应付款总额',
      "I''ll pay later": '我将稍后付款',
      'Review and edit any personal information that has changed':
        '查看并编辑任何已更改的个人信息',
      'Personal Information': '个人信息',
      'Demographics': '人口统计',
      'Insurance Cards': '保险卡',
      'Primary Care Providers': '初级保健提供者',
      'Confirm your upcoming appointment': '确认您即将到来的预约',
      'This will speed up your check-in process.': '这将加快您登记流程的速度。',
      'Confirm or Cancel': '确认或取消',
      'Emergency Contact': '紧急联系人',
      'Cancellation window has passed': '取消窗口已过',
      'Cancelling appointments within 60 minutes will require a call to the clinic listed above.':
        '在 60 分钟内取消预约需要致电上述诊所。',
      'Select the appointment you would like to cancel.':
        '选择想要取消的预约。',
      'Cancel appointment': '取消预约',
    },
  },
};

export default resources;
